/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Money` scalar type represents monetary values and supports signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point). */
  Money: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AddCountryToShippingMethodInput = {
  countryIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AddCustomerToEventInput = {
  contactInfo?: InputMaybe<ContactInfoInput>;
  customerId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  idolId?: InputMaybe<Scalars['ID']['input']>;
  purchaseQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type AddFulfillmentToOrderResult = CreateFulfillmentError | EmptyOrderLineSelectionError | Fulfillment | FulfillmentStateTransitionError | InsufficientStockOnHandError | InvalidFulfillmentHandlerError | ItemsAlreadyFulfilledError;

export type AddItemInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddItemToDraftOrderInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddManualPaymentToOrderResult = ManualPaymentStateError | Order;

export type AddNoteToCustomerInput = {
  id: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type AddNoteToOrderInput = {
  id: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type Address = Node & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<AddressCustomFields>;
  defaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  defaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idCardNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<RegionCode>;
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressCustomFields = {
  __typename?: 'AddressCustomFields';
  chinaName?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Asset>>;
  idCardNumber?: Maybe<Scalars['String']['output']>;
};

export type AdjustDraftOrderLineInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export enum AdjustmentType {
  DistributedOrderPromotion = 'DISTRIBUTED_ORDER_PROMOTION',
  Other = 'OTHER',
  Promotion = 'PROMOTION'
}

export type Admin = Node & {
  __typename?: 'Admin';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type Administrator = Node & {
  __typename?: 'Administrator';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type AdministratorFilterParameter = {
  _and?: InputMaybe<Array<AdministratorFilterParameter>>;
  _or?: InputMaybe<Array<AdministratorFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type AdministratorList = PaginatedList & {
  __typename?: 'AdministratorList';
  items: Array<Administrator>;
  totalItems: Scalars['Int']['output'];
};

export type AdministratorListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AdministratorFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AdministratorSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AdministratorPaymentInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorRefundInput = {
  /**
   * The amount to be refunded to this particular Payment. This was introduced in
   * v2.2.0 as the preferred way to specify the refund amount. The `lines`, `shipping` and `adjustment`
   * fields will be removed in a future version.
   */
  amount?: InputMaybe<Scalars['Money']['input']>;
  paymentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AffectedOrder = {
  __typename?: 'AffectedOrder';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
};

export type AlbumRank = Node & {
  __typename?: 'AlbumRank';
  firstProduct?: Maybe<Product>;
  firstProductId?: Maybe<Scalars['ID']['output']>;
  fourthProduct?: Maybe<Product>;
  fourthProductId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  secondProduct?: Maybe<Product>;
  secondProductId?: Maybe<Scalars['ID']['output']>;
  thirdProduct?: Maybe<Product>;
  thirdProductId?: Maybe<Scalars['ID']['output']>;
};

export type Alert = Node & {
  __typename?: 'Alert';
  activeDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nContent: Scalars['String']['output'];
  nTitle: Scalars['String']['output'];
  translations: Array<AlertTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AlertFilterParameter = {
  _and?: InputMaybe<Array<AlertFilterParameter>>;
  _or?: InputMaybe<Array<AlertFilterParameter>>;
  activeDate?: InputMaybe<DateOperators>;
  createdAt?: InputMaybe<DateOperators>;
  endDate?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  nContent?: InputMaybe<StringOperators>;
  nTitle?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type AlertList = PaginatedList & {
  __typename?: 'AlertList';
  items: Array<Alert>;
  totalItems: Scalars['Int']['output'];
};

export type AlertListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AlertFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AlertSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertSortParameter = {
  activeDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nContent?: InputMaybe<SortOrder>;
  nTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AlertTranslation = Node & {
  __typename?: 'AlertTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  nContent: Scalars['String']['output'];
  nTitle: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AlertTranslationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  nContent: Scalars['String']['input'];
  nTitle: Scalars['String']['input'];
};

export type Allocation = Node & StockMovement & {
  __typename?: 'Allocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderLine: OrderLine;
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned if an attempting to refund an OrderItem which has already been refunded */
export type AlreadyRefundedError = ErrorResult & {
  __typename?: 'AlreadyRefundedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  refundId: Scalars['ID']['output'];
};

export type ApplyCouponCodeResult = CouponCodeExpiredError | CouponCodeInvalidError | CouponCodeLimitError | Order;

export enum ApprovalStatus {
  Approved = 'Approved',
  Deprecated = 'Deprecated',
  New = 'New',
  Partial = 'Partial',
  Rejected = 'Rejected'
}

export type ApprovePurchaseNeededGroupInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  requests?: InputMaybe<Array<InputMaybe<ApprovePurchaseNeededInput>>>;
  retailerId?: InputMaybe<Scalars['ID']['input']>;
  shopSupplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ApprovePurchaseNeededInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type Area = {
  __typename?: 'Area';
  city?: Maybe<Array<Maybe<City>>>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Artist = Node & {
  __typename?: 'Artist';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Asset>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  productUpdateDate: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility?: Maybe<Scalars['Boolean']['output']>;
};

export type ArtistFilterParameter = {
  _and?: InputMaybe<Array<ArtistFilterParameter>>;
  _or?: InputMaybe<Array<ArtistFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  logoId?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  productUpdateDate?: InputMaybe<DateOperators>;
  total?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  visibility?: InputMaybe<BooleanOperators>;
};

export type ArtistList = PaginatedList & {
  __typename?: 'ArtistList';
  items: Array<Artist>;
  totalItems: Scalars['Int']['output'];
};

export type ArtistListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ArtistFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ArtistSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtistSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  logoId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productUpdateDate?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Asset = Node & {
  __typename?: 'Asset';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  fileSize: Scalars['Int']['output'];
  focalPoint?: Maybe<Coordinate>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tags: Array<Tag>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Int']['output'];
};

export type AssetFilterParameter = {
  _and?: InputMaybe<Array<AssetFilterParameter>>;
  _or?: InputMaybe<Array<AssetFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  fileSize?: InputMaybe<NumberOperators>;
  height?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  mimeType?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  preview?: InputMaybe<StringOperators>;
  source?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  width?: InputMaybe<NumberOperators>;
};

export type AssetList = PaginatedList & {
  __typename?: 'AssetList';
  items: Array<Asset>;
  totalItems: Scalars['Int']['output'];
};

export type AssetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AssetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AssetSortParameter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsOperator?: InputMaybe<LogicalOperator>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  preview?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export enum AssetType {
  Binary = 'BINARY',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type AssignAssetsToChannelInput = {
  assetIds: Array<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
};

export type AssignCollectionsToChannelInput = {
  channelId: Scalars['ID']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
};

export type AssignFacetsToChannelInput = {
  channelId: Scalars['ID']['input'];
  facetIds: Array<Scalars['ID']['input']>;
};

export type AssignPaymentMethodsToChannelInput = {
  channelId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignProductVariantsToChannelInput = {
  channelId: Scalars['ID']['input'];
  priceFactor?: InputMaybe<Scalars['Float']['input']>;
  productVariantIds: Array<Scalars['ID']['input']>;
};

export type AssignProductsToChannelInput = {
  channelId: Scalars['ID']['input'];
  priceFactor?: InputMaybe<Scalars['Float']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type AssignPromotionsToChannelInput = {
  channelId: Scalars['ID']['input'];
  promotionIds: Array<Scalars['ID']['input']>;
};

export type AssignShippingMethodsToChannelInput = {
  channelId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignStockLocationsToChannelInput = {
  channelId: Scalars['ID']['input'];
  stockLocationIds: Array<Scalars['ID']['input']>;
};

export type AuditRequest = Node & {
  __typename?: 'AuditRequest';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: AuditRequestType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AuditRequestFilterParameter = {
  _and?: InputMaybe<Array<AuditRequestFilterParameter>>;
  _or?: InputMaybe<Array<AuditRequestFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  itemId?: InputMaybe<IdOperators>;
  note?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type AuditRequestList = PaginatedList & {
  __typename?: 'AuditRequestList';
  items: Array<AuditRequest>;
  totalItems: Scalars['Int']['output'];
};

export type AuditRequestListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AuditRequestFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AuditRequestSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditRequestSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AuditRequestType {
  CancelEvent = 'CANCEL_EVENT',
  CreateEvent = 'CREATE_EVENT',
  CreateLink = 'CREATE_LINK',
  CreateProduct = 'CREATE_PRODUCT',
  DeleteEvent = 'DELETE_EVENT',
  DeleteLink = 'DELETE_LINK',
  DeleteProduct = 'DELETE_PRODUCT',
  EditEvent = 'EDIT_EVENT',
  EditFanClub = 'EDIT_FAN_CLUB',
  EditProduct = 'EDIT_PRODUCT',
  EditProductVariant = 'EDIT_PRODUCT_VARIANT',
  InboundRequest = 'INBOUND_REQUEST',
  PurchaseRequest = 'PURCHASE_REQUEST',
  Refund = 'REFUND',
  SuspendLink = 'SUSPEND_LINK',
  UnsuspendLink = 'UNSUSPEND_LINK',
  UpdateLinkTime = 'UPDATE_LINK_TIME'
}

export type AuthenticationInput = {
  native?: InputMaybe<NativeAuthInput>;
};

export type AuthenticationMethod = Node & {
  __typename?: 'AuthenticationMethod';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  strategy: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthenticationResult = CurrentUser | InvalidCredentialsError;

export type AvailableCountryInput = {
  countryId: Scalars['ID']['input'];
  shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AvailableCountryShipping = {
  __typename?: 'AvailableCountryShipping';
  country: Country;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  methods?: Maybe<Array<ShippingMethod>>;
};

export type Banner = Node & {
  __typename?: 'Banner';
  bannerAsset: Asset;
  bannerAssetId: Scalars['ID']['output'];
  bannerCategory?: Maybe<BannerCategory>;
  bannerCategoryId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  linkURL: Scalars['String']['output'];
  mobileBannerAsset?: Maybe<Asset>;
  mobileBannerAssetId?: Maybe<Scalars['ID']['output']>;
  showing?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BannerCategory = Node & {
  __typename?: 'BannerCategory';
  banners: Array<Banner>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type BannerFilterParameter = {
  _and?: InputMaybe<Array<BannerFilterParameter>>;
  _or?: InputMaybe<Array<BannerFilterParameter>>;
  bannerAssetId?: InputMaybe<IdOperators>;
  bannerCategoryId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  endDate?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  linkURL?: InputMaybe<StringOperators>;
  mobileBannerAssetId?: InputMaybe<IdOperators>;
  showing?: InputMaybe<BooleanOperators>;
  startDate?: InputMaybe<DateOperators>;
  title?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type BannerList = PaginatedList & {
  __typename?: 'BannerList';
  items: Array<Banner>;
  totalItems: Scalars['Int']['output'];
};

export type BannerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<BannerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<BannerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerSortParameter = {
  bannerAssetId?: InputMaybe<SortOrder>;
  bannerCategoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkURL?: InputMaybe<SortOrder>;
  mobileBannerAssetId?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BooleanCustomFieldConfig = CustomField & {
  __typename?: 'BooleanCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Operators for filtering on a list of Boolean fields */
export type BooleanListOperators = {
  inList: Scalars['Boolean']['input'];
};

/** Operators for filtering on a Boolean field */
export type BooleanOperators = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpdatePackageReviewInput = {
  currentVariantId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
  newVariantId: Scalars['ID']['input'];
};

export type BulkUpdateRulePackageReviewInput = {
  freeGiftQuantity: Scalars['Int']['input'];
  ids: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  shippingQuantity: Scalars['Int']['input'];
  shippingWeight: Scalars['Int']['input'];
};

export type BulkVariantPriceData = {
  priceData?: InputMaybe<Array<CurrencyBeforeTax>>;
  variantId: Scalars['ID']['input'];
};

export type CalculateShippingCostInput = {
  productId: Scalars['ID']['input'];
  province: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CalculateShippingCostProductInput = {
  countryCode: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** Returned if an attempting to cancel lines from an Order which is still active */
export type CancelActiveOrderError = ErrorResult & {
  __typename?: 'CancelActiveOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  orderState: Scalars['String']['output'];
};

export type CancelOrderInput = {
  /** Specify whether the shipping charges should also be cancelled. Defaults to false */
  cancelShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally specify which OrderLines to cancel. If not provided, all OrderLines will be cancelled */
  lines?: InputMaybe<Array<OrderLineInput>>;
  /** The id of the order to be cancelled */
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderResult = CancelActiveOrderError | EmptyOrderLineSelectionError | MultipleOrderError | Order | OrderStateTransitionError | QuantityTooGreatError;

/** Returned if the Payment cancellation fails */
export type CancelPaymentError = ErrorResult & {
  __typename?: 'CancelPaymentError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

export type CancelPaymentResult = CancelPaymentError | Payment | PaymentStateTransitionError;

export type Cancellation = Node & StockMovement & {
  __typename?: 'Cancellation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderLine: OrderLine;
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChangeStatusInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type Channel = Node & {
  __typename?: 'Channel';
  availableCurrencyCodes: Array<CurrencyCode>;
  availableLanguageCodes?: Maybe<Array<LanguageCode>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use defaultCurrencyCode instead */
  currencyCode: CurrencyCode;
  customFields?: Maybe<ChannelCustomFields>;
  defaultCurrencyCode: CurrencyCode;
  defaultLanguageCode: LanguageCode;
  defaultShippingZone?: Maybe<Zone>;
  defaultTaxZone?: Maybe<Zone>;
  id: Scalars['ID']['output'];
  /** Not yet used - will be implemented in a future release. */
  outOfStockThreshold?: Maybe<Scalars['Int']['output']>;
  pricesIncludeTax: Scalars['Boolean']['output'];
  seller?: Maybe<Seller>;
  token: Scalars['String']['output'];
  /** Not yet used - will be implemented in a future release. */
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChannelCustomFields = {
  __typename?: 'ChannelCustomFields';
  fanClubPointExchangeRate?: Maybe<Scalars['Float']['output']>;
};

/**
 * Returned when the default LanguageCode of a Channel is no longer found in the `availableLanguages`
 * of the GlobalSettings
 */
export type ChannelDefaultLanguageError = ErrorResult & {
  __typename?: 'ChannelDefaultLanguageError';
  channelCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChannelFilterParameter = {
  _and?: InputMaybe<Array<ChannelFilterParameter>>;
  _or?: InputMaybe<Array<ChannelFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  defaultCurrencyCode?: InputMaybe<StringOperators>;
  defaultLanguageCode?: InputMaybe<StringOperators>;
  fanClubPointExchangeRate?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  outOfStockThreshold?: InputMaybe<NumberOperators>;
  pricesIncludeTax?: InputMaybe<BooleanOperators>;
  token?: InputMaybe<StringOperators>;
  trackInventory?: InputMaybe<BooleanOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ChannelList = PaginatedList & {
  __typename?: 'ChannelList';
  items: Array<Channel>;
  totalItems: Scalars['Int']['output'];
};

export type ChannelListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ChannelFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ChannelSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ChannelSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  fanClubPointExchangeRate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outOfStockThreshold?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type City = {
  __typename?: 'City';
  code?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Array<Maybe<Place>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ClickAction {
  OpenActivity = 'OPEN_ACTIVITY',
  OpenApp = 'OPEN_APP',
  OpenUrl = 'OPEN_URL'
}

export type Collection = Node & {
  __typename?: 'Collection';
  assets: Array<Asset>;
  breadcrumbs: Array<CollectionBreadcrumb>;
  children?: Maybe<Array<Collection>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  featuredAsset?: Maybe<Asset>;
  filters: Array<ConfigurableOperation>;
  id: Scalars['ID']['output'];
  inheritFilters: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  languageCode?: Maybe<LanguageCode>;
  name: Scalars['String']['output'];
  parent?: Maybe<Collection>;
  parentId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  productVariants: ProductVariantList;
  slug: Scalars['String']['output'];
  translations: Array<CollectionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CollectionProductVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type CollectionBreadcrumb = {
  __typename?: 'CollectionBreadcrumb';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CollectionFilterParameter = {
  _and?: InputMaybe<Array<CollectionFilterParameter>>;
  _or?: InputMaybe<Array<CollectionFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  inheritFilters?: InputMaybe<BooleanOperators>;
  isPrivate?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  position?: InputMaybe<NumberOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CollectionList = PaginatedList & {
  __typename?: 'CollectionList';
  items: Array<Collection>;
  totalItems: Scalars['Int']['output'];
};

export type CollectionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CollectionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CollectionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Which Collections are present in the products returned
 * by the search, and in what quantity.
 */
export type CollectionResult = {
  __typename?: 'CollectionResult';
  collection: Collection;
  count: Scalars['Int']['output'];
};

export type CollectionSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CollectionTranslation = {
  __typename?: 'CollectionTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommentAdmin = {
  __typename?: 'CommentAdmin';
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ConfigArg = {
  __typename?: 'ConfigArg';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConfigArgDefinition = {
  __typename?: 'ConfigArgDefinition';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigArgInput = {
  name: Scalars['String']['input'];
  /** A JSON stringified representation of the actual value */
  value: Scalars['String']['input'];
};

export type ConfigurableOperation = {
  __typename?: 'ConfigurableOperation';
  args: Array<ConfigArg>;
  code: Scalars['String']['output'];
};

export type ConfigurableOperationDefinition = {
  __typename?: 'ConfigurableOperationDefinition';
  args: Array<ConfigArgDefinition>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ConfigurableOperationInput = {
  arguments: Array<ConfigArgInput>;
  code: Scalars['String']['input'];
};

export type ConfirmWinnerInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type ConfirmationCheckbox = Node & {
  __typename?: 'ConfirmationCheckbox';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: FanClubLink;
  linkId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactInfoInput = {
  birthdate: Scalars['DateTime']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export enum ContactInfoType {
  KakaoTalk = 'KakaoTalk',
  Line = 'Line',
  WeChat = 'WeChat'
}

export type CooperateUser = Node & {
  __typename?: 'CooperateUser';
  attachmentIds: Array<Maybe<Scalars['ID']['output']>>;
  attachments: Array<Maybe<Asset>>;
  customer: Customer;
  id: Scalars['ID']['output'];
  isApproved: Scalars['Boolean']['output'];
  representative: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
};

export type CooperateUserList = PaginatedList & {
  __typename?: 'CooperateUserList';
  items: Array<CooperateUser>;
  totalItems: Scalars['Int']['output'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CoordinateInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/**
 * A Country of the world which your shop operates in.
 *
 * The `code` field is typically a 2-character ISO code such as "GB", "US", "DE" etc. This code is used in certain inputs such as
 * `UpdateAddressInput` and `CreateAddressInput` to specify the country.
 */
export type Country = Node & Region & {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CountryCustomFields>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zones?: Maybe<Array<Zone>>;
};

export type CountryCustomFields = {
  __typename?: 'CountryCustomFields';
  currencyCode?: Maybe<Scalars['String']['output']>;
};

export type CountryFilterParameter = {
  _and?: InputMaybe<Array<CountryFilterParameter>>;
  _or?: InputMaybe<Array<CountryFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CountryList = PaginatedList & {
  __typename?: 'CountryList';
  items: Array<Country>;
  totalItems: Scalars['Int']['output'];
};

export type CountryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CountryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CountrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CountryTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeExpiredError = ErrorResult & {
  __typename?: 'CouponCodeExpiredError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeInvalidError = ErrorResult & {
  __typename?: 'CouponCodeInvalidError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeLimitError = ErrorResult & {
  __typename?: 'CouponCodeLimitError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  limit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CreateAddressCustomFieldsInput = {
  chinaName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  filesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  idCardNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to create an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<CreateAddressCustomFieldsInput>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdministratorInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type CreateAlertInput = {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate: Scalars['DateTime']['input'];
  translations: Array<AlertTranslationInput>;
};

export type CreateAndStockinInput = {
  vendCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArtistInput = {
  code: Scalars['String']['input'];
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAssetInput2 = {
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAssetQuestionInput = {
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAssetResult = Asset | MimeTypeError;

export type CreateBannerInput = {
  bannerAssetId: Scalars['ID']['input'];
  bannerCategoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkURL: Scalars['String']['input'];
  mobileBannerAssetId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelCustomFieldsInput = {
  fanClubPointExchangeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateChannelInput = {
  availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
  availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<CreateChannelCustomFieldsInput>;
  defaultCurrencyCode?: InputMaybe<CurrencyCode>;
  defaultLanguageCode: LanguageCode;
  defaultShippingZoneId: Scalars['ID']['input'];
  defaultTaxZoneId: Scalars['ID']['input'];
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  pricesIncludeTax: Scalars['Boolean']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateChannelResult = Channel | LanguageNotAvailableError;

export type CreateCollectionInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  filters: Array<ConfigurableOperationInput>;
  inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<CreateCollectionTranslationInput>;
};

export type CreateCollectionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  languageCode: LanguageCode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateCooperateCustomerInput = {
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCountryCustomFieldsInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCountryInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<CreateCountryCustomFieldsInput>;
  enabled: Scalars['Boolean']['input'];
  translations: Array<CountryTranslationInput>;
};

export type CreateCustomerCustomFieldsInput = {
  allowNotification?: InputMaybe<Scalars['Boolean']['input']>;
  chinaIdName?: InputMaybe<Scalars['String']['input']>;
  chinaIdNumber?: InputMaybe<Scalars['String']['input']>;
  cooperateUserId?: InputMaybe<Scalars['ID']['input']>;
  customerCountryId?: InputMaybe<Scalars['ID']['input']>;
  moneySpent?: InputMaybe<Scalars['Float']['input']>;
  pointAccumulate?: InputMaybe<Scalars['Float']['input']>;
  userLevelId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCustomerGroupInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  customFields?: InputMaybe<CreateCustomerCustomFieldsInput>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerResult = Customer | EmailAddressConflictError;

export type CreateDefaultEventConsentContent = {
  description: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateDefaultEventConsentContentTranslationInput = {
  baseId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  languageCode: LanguageCode;
  value: Scalars['String']['input'];
};

export type CreateDefaultProductDescriptionInput = {
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  translations: Array<CreateDefaultProductDescriptionTranslationInput>;
};

export type CreateDefaultProductDescriptionTranslationInput = {
  bottomDescription?: InputMaybe<Scalars['String']['input']>;
  defaultProductDescriptionId: Scalars['ID']['input'];
  languageCode: LanguageCode;
  title: Scalars['String']['input'];
  topDescription?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDefaultProductInformationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateEmailTemplateInput = {
  code: Scalars['String']['input'];
};

export type CreateEmailTemplateTranslationInput = {
  content: Scalars['String']['input'];
  languageCode: LanguageCode;
  subject: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type CreateEventIdolInput = {
  name: Scalars['String']['input'];
  numOfWinners: Scalars['Int']['input'];
};

export type CreateExchangeRateInput = {
  countryId: Scalars['ID']['input'];
  default: Scalars['Boolean']['input'];
  enable: Scalars['Boolean']['input'];
  exchangeRate: Scalars['Float']['input'];
  taxRateId: Scalars['ID']['input'];
};

export type CreateFacetInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  translations: Array<FacetTranslationInput>;
  values?: InputMaybe<Array<CreateFacetValueWithFacetInput>>;
};

export type CreateFacetValueInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  facetId: Scalars['ID']['input'];
  translations: Array<FacetValueTranslationInput>;
};

export type CreateFacetValueWithFacetInput = {
  code: Scalars['String']['input'];
  translations: Array<FacetValueTranslationInput>;
};

export type CreateFanClubEventInput = {
  allowCorporate: Scalars['Boolean']['input'];
  announcementContent?: InputMaybe<Scalars['String']['input']>;
  applicationEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  artistId?: InputMaybe<Scalars['ID']['input']>;
  artistName: Scalars['String']['input'];
  checkboxes?: InputMaybe<Array<UpdateEventConsentContentInput>>;
  consentContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactInfoType: ContactInfoType;
  createIdols?: InputMaybe<Array<CreateEventIdolInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  eventType: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  numOfWinners: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateFanClubGroupInput = {
  fanClubId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type CreateFanClubInput = {
  artistId?: InputMaybe<Scalars['ID']['input']>;
  artistName: Scalars['String']['input'];
  assetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFanClubLinkInput = {
  availableCountries?: InputMaybe<Array<AvailableCountryInput>>;
  checkboxs?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fanClubId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCorporateLink?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFanClubExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  linkVariants?: InputMaybe<Array<CreateLinkVariantInput>>;
  productId: Scalars['ID']['input'];
  shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showGifts?: InputMaybe<Scalars['Boolean']['input']>;
  showSalesData?: InputMaybe<Scalars['Boolean']['input']>;
  showStock?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateFanClubLinkMissionInput = {
  isActive: Scalars['Boolean']['input'];
  languageCode?: InputMaybe<LanguageCode>;
  linkId: Scalars['ID']['input'];
  pointRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  rewardType: FanClubLinkMissionRewardType;
  target: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFanClubPointHistoryInput = {
  amount: Scalars['Int']['input'];
  fanClubId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFreeGiftConditionInput = {
  giftQuantity: Scalars['Int']['input'];
  minQuantity: Scalars['Int']['input'];
  productVariantIds: Array<Scalars['ID']['input']>;
  selectionId: Scalars['String']['input'];
};

export type CreateFreeGiftInput = {
  productId: Scalars['ID']['input'];
};

/** Returned if an error is thrown in a FulfillmentHandler's createFulfillment method */
export type CreateFulfillmentError = ErrorResult & {
  __typename?: 'CreateFulfillmentError';
  errorCode: ErrorCode;
  fulfillmentHandlerError: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CreateGroupOptionInput = {
  code: Scalars['String']['input'];
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateGuidanceInput = {
  guidanceContentId: Scalars['String']['input'];
  translations: Array<GuidanceTranslationInput>;
};

export type CreateInboundApproveInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  inboundId: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
  quantity: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInboundApproveRequestInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  assetIds: Array<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type CreateInboundingInput = {
  status: InboundingStatus;
};

export type CreateLinkVariantInput = {
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  customStock?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  productVariantId: Scalars['ID']['input'];
  stockAllocated?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLinkVariantPriceInput = {
  beforeTax: Scalars['Int']['input'];
  countryId: Scalars['ID']['input'];
  customServiceFee?: InputMaybe<Scalars['Float']['input']>;
  linkVariantId: Scalars['ID']['input'];
};

export type CreateNoticeInput = {
  translations: Array<NoticeTranslationInput>;
  visibility: Scalars['Boolean']['input'];
};

export type CreatePackageInput = {
  jackyunOrderID?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<InputMaybe<CreatePackageLine>>>;
  orderId: Scalars['ID']['input'];
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePackageLine = {
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreatePackageReviewInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['ID']['input'];
};

export type CreatePackageReviewOrderLineInput = {
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  packageReviewId: Scalars['ID']['input'];
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreatePaymentMethodInput = {
  checker?: InputMaybe<ConfigurableOperationInput>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  handler: ConfigurableOperationInput;
  translations: Array<PaymentMethodTranslationInput>;
};

export type CreateProductCustomFieldsInput = {
  artistId?: InputMaybe<Scalars['ID']['input']>;
  createdInJackyun?: InputMaybe<Scalars['Boolean']['input']>;
  customThreshold?: InputMaybe<Scalars['Int']['input']>;
  defaultProductDescriptionId?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<Scalars['Boolean']['input']>;
  eventsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facetsColumn?: InputMaybe<Scalars['Boolean']['input']>;
  freeGifts?: InputMaybe<Scalars['Boolean']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  isSinglePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  preorder?: InputMaybe<Scalars['Boolean']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  purchaseNote?: InputMaybe<Scalars['String']['input']>;
  purchaseUrl?: InputMaybe<Scalars['String']['input']>;
  randomOption?: InputMaybe<Scalars['Boolean']['input']>;
  retailerId?: InputMaybe<Scalars['ID']['input']>;
  shippingSetting?: InputMaybe<Scalars['String']['input']>;
  showSales?: InputMaybe<Scalars['Boolean']['input']>;
  showStock?: InputMaybe<Scalars['Boolean']['input']>;
  splitOrderRuleId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  totalLinks?: InputMaybe<Scalars['String']['input']>;
  totalSalesQuantity?: InputMaybe<Scalars['String']['input']>;
  totalStocks?: InputMaybe<Scalars['Int']['input']>;
  useSaleTime?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProductInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<CreateProductCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<ProductTranslationInput>;
};

export type CreateProductOptionGroupInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  options: Array<CreateGroupOptionInput>;
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductOptionInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  productOptionGroupId: Scalars['ID']['input'];
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductSpecificationInput = {
  name: Scalars['String']['input'];
  productVariantId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateProductTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductVariantCustomFieldsInput = {
  fixPrice?: InputMaybe<Scalars['Float']['input']>;
  maxPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minPerOrder?: InputMaybe<Scalars['Int']['input']>;
  skuBarcode?: InputMaybe<Scalars['String']['input']>;
  stockWaiting?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProductVariantInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<CreateProductVariantCustomFieldsInput>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Money']['input']>;
  productId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
  stockLevels?: InputMaybe<Array<StockLevelInput>>;
  stockOnHand?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  trackInventory?: InputMaybe<GlobalFlag>;
  translations: Array<ProductVariantTranslationInput>;
  useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVariantOptionInput = {
  code: Scalars['String']['input'];
  optionGroupId: Scalars['ID']['input'];
  translations: Array<ProductOptionTranslationInput>;
};

export type CreatePromotionCustomFieldsInput = {
  customersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreatePromotionInput = {
  actions: Array<ConfigurableOperationInput>;
  conditions: Array<ConfigurableOperationInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<CreatePromotionCustomFieldsInput>;
  enabled: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  translations: Array<PromotionTranslationInput>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePromotionResult = MissingConditionsError | Promotion;

export type CreateProvinceCustomFieldsInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProvinceInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<CreateProvinceCustomFieldsInput>;
  enabled: Scalars['Boolean']['input'];
  translations: Array<ProvinceTranslationInput>;
};

export type CreatePurchaseInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  advancePay?: InputMaybe<Scalars['Float']['input']>;
  advancePayPercent?: InputMaybe<Scalars['Float']['input']>;
  batchControlByWarehouse?: InputMaybe<Scalars['Int']['input']>;
  batchList?: InputMaybe<Array<PurchBatchList>>;
  busiName?: InputMaybe<Scalars['String']['input']>;
  busiUserId: Scalars['Int']['input'];
  companyCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  currencyName: Scalars['String']['input'];
  currencyRate: Scalars['String']['input'];
  departCode?: InputMaybe<Scalars['String']['input']>;
  field1?: InputMaybe<Scalars['String']['input']>;
  field2?: InputMaybe<Scalars['String']['input']>;
  field3?: InputMaybe<Scalars['String']['input']>;
  field4?: InputMaybe<Scalars['String']['input']>;
  field5?: InputMaybe<Scalars['String']['input']>;
  goodsQuantity?: InputMaybe<Scalars['Float']['input']>;
  goodsTypeQuantity?: InputMaybe<Scalars['Float']['input']>;
  invoiceHead?: InputMaybe<Scalars['String']['input']>;
  invoiceMemo?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<Scalars['Int']['input']>;
  list: Array<PurchList>;
  logisticCode?: InputMaybe<Scalars['String']['input']>;
  logisticNo?: InputMaybe<Scalars['String']['input']>;
  logisticType?: InputMaybe<Scalars['String']['input']>;
  openingBank?: InputMaybe<Scalars['String']['input']>;
  openingBankAccount?: InputMaybe<Scalars['String']['input']>;
  orderTime?: InputMaybe<Scalars['String']['input']>;
  payTotal?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodName?: InputMaybe<Scalars['String']['input']>;
  purFee?: InputMaybe<Scalars['Float']['input']>;
  purFeeType: Scalars['Int']['input'];
  purTotalPrice?: InputMaybe<Scalars['Float']['input']>;
  purchCode: Scalars['String']['input'];
  purchExpressInfo?: InputMaybe<PurchExpressInfo>;
  purchOfficeCode?: InputMaybe<Scalars['String']['input']>;
  purchType: Scalars['String']['input'];
  receAccName?: InputMaybe<Scalars['String']['input']>;
  receAccNo?: InputMaybe<Scalars['String']['input']>;
  receAccTypeCode?: InputMaybe<Scalars['String']['input']>;
  receAccTypeName?: InputMaybe<Scalars['String']['input']>;
  receOpenBank?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  vendCode?: InputMaybe<Scalars['String']['input']>;
  vendOrderId?: InputMaybe<Scalars['String']['input']>;
  warehouseCode: Scalars['String']['input'];
};

export type CreatePurchaseRequestCronjobInput = {
  everyHour: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreatePushTemplateInput = {
  isActive: Scalars['Boolean']['input'];
  translations: Array<PushTemplateTranslationInput>;
  type: Scalars['String']['input'];
};

export type CreateQuestionPostComment = {
  detail: Scalars['String']['input'];
  postId: Scalars['ID']['input'];
};

export type CreateQuestionPostInput = {
  files?: InputMaybe<Array<CreateAssetQuestionInput>>;
  referId?: InputMaybe<Scalars['ID']['input']>;
  secret: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<QuestionPostType>;
};

export type CreateRefundRequestAdminInput = {
  args: RefundOrderDialogResult;
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lines: Array<RefundRequestLineInput>;
  paymentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type CreateRefundRequestInput = {
  assets?: InputMaybe<Array<CreateAssetInput2>>;
  paymentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CreateRequestPurchaseNeededGroupInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  requests: Array<CreateRequestPurchaseNeededInput>;
  retailerId: Scalars['ID']['input'];
  shopSupplierId: Scalars['ID']['input'];
};

export type CreateRequestPurchaseNeededInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notSpecify?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productVariantId: Scalars['ID']['input'];
  quantityNeeded: Scalars['Int']['input'];
};

export type CreateRetailInput = {
  abbreviation: Scalars['String']['input'];
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  logoId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRoleInput = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  permissions: Array<Permission>;
};

export type CreateSellerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateServiceFeeInput = {
  currencyCode: CurrencyCode;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type CreateShippingFeeCountryInput = {
  zoneId: Scalars['ID']['input'];
};

export type CreateShippingFeeInput = {
  city: Scalars['String']['input'];
  priceFirstItem: Scalars['Float']['input'];
  priceFirstWeight: Scalars['Float']['input'];
  priceSubsequentItem: Scalars['Float']['input'];
  priceSubsequentWeight: Scalars['Float']['input'];
};

export type CreateShippingFeeTypeInput = {
  basePrice: Scalars['Float']['input'];
  extraPrice: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shippingFeeCountryId: Scalars['ID']['input'];
  type: ShippingFeeType;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateShippingInput = {
  orderId: Scalars['ID']['input'];
};

export type CreateShippingMethodCustomFieldsInput = {
  countriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customsClearanceActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateShippingMethodInput = {
  calculator: ConfigurableOperationInput;
  checker: ConfigurableOperationInput;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<CreateShippingMethodCustomFieldsInput>;
  fulfillmentHandler: Scalars['String']['input'];
  translations: Array<ShippingMethodTranslationInput>;
};

export type CreateShopSupplier = {
  abbreviation: Scalars['String']['input'];
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  logoId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSmsTemplate = {
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  templateCode: Scalars['String']['input'];
};

export type CreateSplitOrderRuleInput = {
  freeGiftQuantity: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  shippingQuantity: Scalars['Int']['input'];
  shippingWeight: Scalars['Int']['input'];
};

export type CreateStaticPageClassificationInput = {
  translations: Array<StaticPageClassificationTranslationInput>;
};

export type CreateStaticPageInput = {
  classificationId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
  thumbnailId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<StaticPageTranslationInput>;
};

export type CreateStockLocationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSupplierInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  assetIds: Array<Scalars['ID']['input']>;
  assistantCode?: InputMaybe<Scalars['String']['input']>;
  businessScope?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  classCode?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  className: Scalars['String']['input'];
  code: Scalars['String']['input'];
  countryName?: InputMaybe<Scalars['String']['input']>;
  developDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  flagData?: InputMaybe<Scalars['String']['input']>;
  leader?: InputMaybe<Scalars['String']['input']>;
  levelCode?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  townName?: InputMaybe<Scalars['String']['input']>;
  vendLinkmanList?: InputMaybe<Array<VendLinkmanList>>;
  vendPayAccountList?: InputMaybe<Array<VendPayAccountList>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagInput = {
  value: Scalars['String']['input'];
};

export type CreateTaxCategoryInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTaxRateInput = {
  categoryId: Scalars['ID']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  zoneId: Scalars['ID']['input'];
};

export type CreateTicketCommentInput = {
  content: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type CreateTicketInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<TicketPriority>;
  status?: InputMaybe<TicketStatus>;
  title: Scalars['String']['input'];
  type?: InputMaybe<TicketType>;
};

export type CreateUserLevelInput = {
  cashbackPercent: Scalars['Float']['input'];
  levelType: LevelType;
  logoId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  orderQuan?: InputMaybe<Scalars['Int']['input']>;
  orderQuantity: Array<OrderQuantityWithCurrencyCodeInput>;
  pointAccrualPercent: Scalars['Float']['input'];
};

export type CreateVariantFreeGiftInput = {
  id: Scalars['String']['input'];
  isRandom?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  linkMan: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  townName: Scalars['String']['input'];
  vendCode?: InputMaybe<Scalars['String']['input']>;
  warehouseCode: Scalars['String']['input'];
  warehouseCompanyCode: Scalars['String']['input'];
  warehouseDepartCode: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseTypeCode: Scalars['String']['input'];
};

export type CreateWarehouseOneInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  isInoutAudit: Scalars['Int']['input'];
  isInoutTask: Scalars['Int']['input'];
  linkMan: Scalars['String']['input'];
  provinceName?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  tel: Scalars['String']['input'];
  townName?: InputMaybe<Scalars['String']['input']>;
  warehouseCode: Scalars['String']['input'];
  warehouseCompanyId: Scalars['String']['input'];
  warehouseCompanyName: Scalars['String']['input'];
  warehouseDepartId: Scalars['String']['input'];
  warehouseDepartName: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseStoreTypeCode: Scalars['String']['input'];
  warehouseStoreTypeName: Scalars['String']['input'];
  warehouseTypeCode: Scalars['String']['input'];
  warehouseTypeName: Scalars['String']['input'];
};

export type CreateZoneInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type CurrencyBeforeTax = {
  beforeTax: Scalars['Float']['input'];
  countryId: Scalars['ID']['input'];
  currencyCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  serviceFee: Scalars['Float']['input'];
  syncWithOther: Scalars['Boolean']['input'];
};

/**
 * @description
 * ISO 4217 currency code
 *
 * @docsCategory common
 */
export enum CurrencyCode {
  /** United Arab Emirates dirham */
  Aed = 'AED',
  /** Afghan afghani */
  Afn = 'AFN',
  /** Albanian lek */
  All = 'ALL',
  /** Armenian dram */
  Amd = 'AMD',
  /** Netherlands Antillean guilder */
  Ang = 'ANG',
  /** Angolan kwanza */
  Aoa = 'AOA',
  /** Argentine peso */
  Ars = 'ARS',
  /** Australian dollar */
  Aud = 'AUD',
  /** Aruban florin */
  Awg = 'AWG',
  /** Azerbaijani manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina convertible mark */
  Bam = 'BAM',
  /** Barbados dollar */
  Bbd = 'BBD',
  /** Bangladeshi taka */
  Bdt = 'BDT',
  /** Bulgarian lev */
  Bgn = 'BGN',
  /** Bahraini dinar */
  Bhd = 'BHD',
  /** Burundian franc */
  Bif = 'BIF',
  /** Bermudian dollar */
  Bmd = 'BMD',
  /** Brunei dollar */
  Bnd = 'BND',
  /** Boliviano */
  Bob = 'BOB',
  /** Brazilian real */
  Brl = 'BRL',
  /** Bahamian dollar */
  Bsd = 'BSD',
  /** Bhutanese ngultrum */
  Btn = 'BTN',
  /** Botswana pula */
  Bwp = 'BWP',
  /** Belarusian ruble */
  Byn = 'BYN',
  /** Belize dollar */
  Bzd = 'BZD',
  /** Canadian dollar */
  Cad = 'CAD',
  /** Congolese franc */
  Cdf = 'CDF',
  /** Swiss franc */
  Chf = 'CHF',
  /** Chilean peso */
  Clp = 'CLP',
  /** Renminbi (Chinese) yuan */
  Cny = 'CNY',
  /** Colombian peso */
  Cop = 'COP',
  /** Costa Rican colon */
  Crc = 'CRC',
  /** Cuban convertible peso */
  Cuc = 'CUC',
  /** Cuban peso */
  Cup = 'CUP',
  /** Cape Verde escudo */
  Cve = 'CVE',
  /** Czech koruna */
  Czk = 'CZK',
  /** Djiboutian franc */
  Djf = 'DJF',
  /** Danish krone */
  Dkk = 'DKK',
  /** Dominican peso */
  Dop = 'DOP',
  /** Algerian dinar */
  Dzd = 'DZD',
  /** Egyptian pound */
  Egp = 'EGP',
  /** Eritrean nakfa */
  Ern = 'ERN',
  /** Ethiopian birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fiji dollar */
  Fjd = 'FJD',
  /** Falkland Islands pound */
  Fkp = 'FKP',
  /** Pound sterling */
  Gbp = 'GBP',
  /** Georgian lari */
  Gel = 'GEL',
  /** Ghanaian cedi */
  Ghs = 'GHS',
  /** Gibraltar pound */
  Gip = 'GIP',
  /** Gambian dalasi */
  Gmd = 'GMD',
  /** Guinean franc */
  Gnf = 'GNF',
  /** Guatemalan quetzal */
  Gtq = 'GTQ',
  /** Guyanese dollar */
  Gyd = 'GYD',
  /** Hong Kong dollar */
  Hkd = 'HKD',
  /** Honduran lempira */
  Hnl = 'HNL',
  /** Croatian kuna */
  Hrk = 'HRK',
  /** Haitian gourde */
  Htg = 'HTG',
  /** Hungarian forint */
  Huf = 'HUF',
  /** Indonesian rupiah */
  Idr = 'IDR',
  /** Israeli new shekel */
  Ils = 'ILS',
  /** Indian rupee */
  Inr = 'INR',
  /** Iraqi dinar */
  Iqd = 'IQD',
  /** Iranian rial */
  Irr = 'IRR',
  /** Icelandic króna */
  Isk = 'ISK',
  /** Jamaican dollar */
  Jmd = 'JMD',
  /** Jordanian dinar */
  Jod = 'JOD',
  /** Japanese yen */
  Jpy = 'JPY',
  /** Kenyan shilling */
  Kes = 'KES',
  /** Kyrgyzstani som */
  Kgs = 'KGS',
  /** Cambodian riel */
  Khr = 'KHR',
  /** Comoro franc */
  Kmf = 'KMF',
  /** North Korean won */
  Kpw = 'KPW',
  /** South Korean won */
  Krw = 'KRW',
  /** Kuwaiti dinar */
  Kwd = 'KWD',
  /** Cayman Islands dollar */
  Kyd = 'KYD',
  /** Kazakhstani tenge */
  Kzt = 'KZT',
  /** Lao kip */
  Lak = 'LAK',
  /** Lebanese pound */
  Lbp = 'LBP',
  /** Sri Lankan rupee */
  Lkr = 'LKR',
  /** Liberian dollar */
  Lrd = 'LRD',
  /** Lesotho loti */
  Lsl = 'LSL',
  /** Libyan dinar */
  Lyd = 'LYD',
  /** Moroccan dirham */
  Mad = 'MAD',
  /** Moldovan leu */
  Mdl = 'MDL',
  /** Malagasy ariary */
  Mga = 'MGA',
  /** Macedonian denar */
  Mkd = 'MKD',
  /** Myanmar kyat */
  Mmk = 'MMK',
  /** Mongolian tögrög */
  Mnt = 'MNT',
  /** Macanese pataca */
  Mop = 'MOP',
  /** Mauritanian ouguiya */
  Mru = 'MRU',
  /** Mauritian rupee */
  Mur = 'MUR',
  /** Maldivian rufiyaa */
  Mvr = 'MVR',
  /** Malawian kwacha */
  Mwk = 'MWK',
  /** Mexican peso */
  Mxn = 'MXN',
  /** Malaysian ringgit */
  Myr = 'MYR',
  /** Mozambican metical */
  Mzn = 'MZN',
  /** Namibian dollar */
  Nad = 'NAD',
  /** Nigerian naira */
  Ngn = 'NGN',
  /** Nicaraguan córdoba */
  Nio = 'NIO',
  /** Norwegian krone */
  Nok = 'NOK',
  /** Nepalese rupee */
  Npr = 'NPR',
  /** New Zealand dollar */
  Nzd = 'NZD',
  /** Omani rial */
  Omr = 'OMR',
  /** Panamanian balboa */
  Pab = 'PAB',
  /** Peruvian sol */
  Pen = 'PEN',
  /** Papua New Guinean kina */
  Pgk = 'PGK',
  /** Philippine peso */
  Php = 'PHP',
  /** Pakistani rupee */
  Pkr = 'PKR',
  /** Polish złoty */
  Pln = 'PLN',
  /** Paraguayan guaraní */
  Pyg = 'PYG',
  /** Qatari riyal */
  Qar = 'QAR',
  /** Romanian leu */
  Ron = 'RON',
  /** Serbian dinar */
  Rsd = 'RSD',
  /** Russian ruble */
  Rub = 'RUB',
  /** Rwandan franc */
  Rwf = 'RWF',
  /** Saudi riyal */
  Sar = 'SAR',
  /** Solomon Islands dollar */
  Sbd = 'SBD',
  /** Seychelles rupee */
  Scr = 'SCR',
  /** Sudanese pound */
  Sdg = 'SDG',
  /** Swedish krona/kronor */
  Sek = 'SEK',
  /** Singapore dollar */
  Sgd = 'SGD',
  /** Saint Helena pound */
  Shp = 'SHP',
  /** Sierra Leonean leone */
  Sll = 'SLL',
  /** Somali shilling */
  Sos = 'SOS',
  /** Surinamese dollar */
  Srd = 'SRD',
  /** South Sudanese pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe dobra */
  Stn = 'STN',
  /** Salvadoran colón */
  Svc = 'SVC',
  /** Syrian pound */
  Syp = 'SYP',
  /** Swazi lilangeni */
  Szl = 'SZL',
  /** Thai baht */
  Thb = 'THB',
  /** Tajikistani somoni */
  Tjs = 'TJS',
  /** Turkmenistan manat */
  Tmt = 'TMT',
  /** Tunisian dinar */
  Tnd = 'TND',
  /** Tongan paʻanga */
  Top = 'TOP',
  /** Turkish lira */
  Try = 'TRY',
  /** Trinidad and Tobago dollar */
  Ttd = 'TTD',
  /** New Taiwan dollar */
  Twd = 'TWD',
  /** Tanzanian shilling */
  Tzs = 'TZS',
  /** Ukrainian hryvnia */
  Uah = 'UAH',
  /** Ugandan shilling */
  Ugx = 'UGX',
  /** United States dollar */
  Usd = 'USD',
  /** Uruguayan peso */
  Uyu = 'UYU',
  /** Uzbekistan som */
  Uzs = 'UZS',
  /** Venezuelan bolívar soberano */
  Ves = 'VES',
  /** Vietnamese đồng */
  Vnd = 'VND',
  /** Vanuatu vatu */
  Vuv = 'VUV',
  /** Samoan tala */
  Wst = 'WST',
  /** CFA franc BEAC */
  Xaf = 'XAF',
  /** East Caribbean dollar */
  Xcd = 'XCD',
  /** CFA franc BCEAO */
  Xof = 'XOF',
  /** CFP franc (franc Pacifique) */
  Xpf = 'XPF',
  /** Yemeni rial */
  Yer = 'YER',
  /** South African rand */
  Zar = 'ZAR',
  /** Zambian kwacha */
  Zmw = 'ZMW',
  /** Zimbabwean dollar */
  Zwl = 'ZWL'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  channels: Array<CurrentUserChannel>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
};

export type CurrentUserChannel = {
  __typename?: 'CurrentUserChannel';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  token: Scalars['String']['output'];
};

export type CustomField = {
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldConfig = BooleanCustomFieldConfig | DateTimeCustomFieldConfig | FloatCustomFieldConfig | IntCustomFieldConfig | LocaleStringCustomFieldConfig | LocaleTextCustomFieldConfig | RelationCustomFieldConfig | StringCustomFieldConfig | TextCustomFieldConfig;

/**
 * This type is deprecated in v2.2 in favor of the EntityCustomFields type,
 * which allows custom fields to be defined on user-supplies entities.
 */
export type CustomFields = {
  __typename?: 'CustomFields';
  Address: Array<CustomFieldConfig>;
  Administrator: Array<CustomFieldConfig>;
  Asset: Array<CustomFieldConfig>;
  Channel: Array<CustomFieldConfig>;
  Collection: Array<CustomFieldConfig>;
  Customer: Array<CustomFieldConfig>;
  CustomerGroup: Array<CustomFieldConfig>;
  Facet: Array<CustomFieldConfig>;
  FacetValue: Array<CustomFieldConfig>;
  Fulfillment: Array<CustomFieldConfig>;
  GlobalSettings: Array<CustomFieldConfig>;
  Order: Array<CustomFieldConfig>;
  OrderLine: Array<CustomFieldConfig>;
  PackageReview: Array<CustomFieldConfig>;
  PaymentMethod: Array<CustomFieldConfig>;
  Product: Array<CustomFieldConfig>;
  ProductOption: Array<CustomFieldConfig>;
  ProductOptionGroup: Array<CustomFieldConfig>;
  ProductVariant: Array<CustomFieldConfig>;
  ProductVariantPrice: Array<CustomFieldConfig>;
  Promotion: Array<CustomFieldConfig>;
  Region: Array<CustomFieldConfig>;
  Retail: Array<CustomFieldConfig>;
  Seller: Array<CustomFieldConfig>;
  ServiceFee: Array<CustomFieldConfig>;
  ShippingMethod: Array<CustomFieldConfig>;
  SmsTemplate: Array<CustomFieldConfig>;
  StockLocation: Array<CustomFieldConfig>;
  TaxCategory: Array<CustomFieldConfig>;
  TaxRate: Array<CustomFieldConfig>;
  Ticket: Array<CustomFieldConfig>;
  TicketComment: Array<CustomFieldConfig>;
  User: Array<CustomFieldConfig>;
  Zone: Array<CustomFieldConfig>;
};

export type Customer = Node & {
  __typename?: 'Customer';
  addresses?: Maybe<Array<Address>>;
  couponsHeld: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CustomerCustomFields>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<CustomerGroup>;
  history: HistoryEntryList;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  orders: OrderList;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};


export type CustomerHistoryArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};


export type CustomerOrdersArgs = {
  options?: InputMaybe<OrderListOptions>;
};

export type CustomerCountry = Node & {
  __typename?: 'CustomerCountry';
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerCouponFilter = {
  lastLoginDays?: InputMaybe<Scalars['Int']['input']>;
  noOrderInDays?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  totalPurchaseAmount?: InputMaybe<TotalPurchaseAmountFilter>;
};

export type CustomerCustomFields = {
  __typename?: 'CustomerCustomFields';
  allowNotification?: Maybe<Scalars['Boolean']['output']>;
  chinaIdName?: Maybe<Scalars['String']['output']>;
  chinaIdNumber?: Maybe<Scalars['String']['output']>;
  cooperateUser?: Maybe<CooperateUser>;
  customerCountry?: Maybe<CustomerCountry>;
  moneySpent?: Maybe<Scalars['Float']['output']>;
  pointAccumulate?: Maybe<Scalars['Float']['output']>;
  userLevel?: Maybe<UserLevel>;
};

export type CustomerFilterParameter = {
  _and?: InputMaybe<Array<CustomerFilterParameter>>;
  _or?: InputMaybe<Array<CustomerFilterParameter>>;
  allowNotification?: InputMaybe<BooleanOperators>;
  chinaIdName?: InputMaybe<StringOperators>;
  chinaIdNumber?: InputMaybe<StringOperators>;
  couponsHeld?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  moneySpent?: InputMaybe<NumberOperators>;
  phoneNumber?: InputMaybe<StringOperators>;
  pointAccumulate?: InputMaybe<NumberOperators>;
  postalCode?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroup = Node & {
  __typename?: 'CustomerGroup';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customers: CustomerList;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerGroupCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};

export type CustomerGroupFilterParameter = {
  _and?: InputMaybe<Array<CustomerGroupFilterParameter>>;
  _or?: InputMaybe<Array<CustomerGroupFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroupList = PaginatedList & {
  __typename?: 'CustomerGroupList';
  items: Array<CustomerGroup>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerGroupListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerGroupFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerGroupSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerGroupSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerList = PaginatedList & {
  __typename?: 'CustomerList';
  items: Array<Customer>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerSortParameter = {
  allowNotification?: InputMaybe<SortOrder>;
  chinaIdName?: InputMaybe<SortOrder>;
  chinaIdNumber?: InputMaybe<SortOrder>;
  cooperateUser?: InputMaybe<SortOrder>;
  couponsHeld?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerCountry?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  moneySpent?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pointAccumulate?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userLevel?: InputMaybe<SortOrder>;
};

export type CustomsClearance = Node & {
  __typename?: 'CustomsClearance';
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Asset>>;
  id: Scalars['ID']['output'];
  order: Order;
  reviewer?: Maybe<Administrator>;
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploader?: Maybe<Administrator>;
};

/** Operators for filtering on a list of Date fields */
export type DateListOperators = {
  inList: Scalars['DateTime']['input'];
};

/** Operators for filtering on a DateTime field */
export type DateOperators = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeCustomFieldConfig = CustomField & {
  __typename?: 'DateTimeCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type DefaultEventConsentContent = Node & {
  __typename?: 'DefaultEventConsentContent';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  translations?: Maybe<Array<DefaultEventConsentContentTranslation>>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type DefaultEventConsentContentFilterParameter = {
  _and?: InputMaybe<Array<DefaultEventConsentContentFilterParameter>>;
  _or?: InputMaybe<Array<DefaultEventConsentContentFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  isDefault?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type DefaultEventConsentContentList = PaginatedList & {
  __typename?: 'DefaultEventConsentContentList';
  items: Array<DefaultEventConsentContent>;
  totalItems: Scalars['Int']['output'];
};

export type DefaultEventConsentContentListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DefaultEventConsentContentFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DefaultEventConsentContentSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultEventConsentContentSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DefaultEventConsentContentTranslation = Node & {
  __typename?: 'DefaultEventConsentContentTranslation';
  base: DefaultEventConsentContent;
  baseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type DefaultEventConsentContentTranslationFilterParameter = {
  _and?: InputMaybe<Array<DefaultEventConsentContentTranslationFilterParameter>>;
  _or?: InputMaybe<Array<DefaultEventConsentContentTranslationFilterParameter>>;
  baseId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type DefaultEventConsentContentTranslationList = PaginatedList & {
  __typename?: 'DefaultEventConsentContentTranslationList';
  items: Array<DefaultEventConsentContentTranslation>;
  totalItems: Scalars['Int']['output'];
};

export type DefaultEventConsentContentTranslationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DefaultEventConsentContentTranslationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DefaultEventConsentContentTranslationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultEventConsentContentTranslationSortParameter = {
  baseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DefaultProductDescription = Node & {
  __typename?: 'DefaultProductDescription';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  translations: Array<DefaultProductDescriptionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DefaultProductDescriptionFilterParameter = {
  _and?: InputMaybe<Array<DefaultProductDescriptionFilterParameter>>;
  _or?: InputMaybe<Array<DefaultProductDescriptionFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isDefault?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type DefaultProductDescriptionList = PaginatedList & {
  __typename?: 'DefaultProductDescriptionList';
  items: Array<DefaultProductDescription>;
  totalItems: Scalars['Int']['output'];
};

export type DefaultProductDescriptionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DefaultProductDescriptionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DefaultProductDescriptionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultProductDescriptionSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultProductDescriptionTranslation = Node & {
  __typename?: 'DefaultProductDescriptionTranslation';
  bottomDescription: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultProductDescriptionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  title: Scalars['String']['output'];
  topDescription: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DefaultProductDescriptionTranslationFilterParameter = {
  _and?: InputMaybe<Array<DefaultProductDescriptionTranslationFilterParameter>>;
  _or?: InputMaybe<Array<DefaultProductDescriptionTranslationFilterParameter>>;
  bottomDescription?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  defaultProductDescriptionId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  topDescription?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type DefaultProductDescriptionTranslationList = PaginatedList & {
  __typename?: 'DefaultProductDescriptionTranslationList';
  items: Array<DefaultProductDescriptionTranslation>;
  totalItems: Scalars['Int']['output'];
};

export type DefaultProductDescriptionTranslationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DefaultProductDescriptionTranslationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DefaultProductDescriptionTranslationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultProductDescriptionTranslationSortParameter = {
  bottomDescription?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultProductDescriptionId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  topDescription?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultProductInformation = Node & {
  __typename?: 'DefaultProductInformation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type DefaultProductInformationFilterParameter = {
  _and?: InputMaybe<Array<DefaultProductInformationFilterParameter>>;
  _or?: InputMaybe<Array<DefaultProductInformationFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type DefaultProductInformationList = PaginatedList & {
  __typename?: 'DefaultProductInformationList';
  items: Array<DefaultProductInformation>;
  totalItems: Scalars['Int']['output'];
};

export type DefaultProductInformationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DefaultProductInformationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DefaultProductInformationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultProductInformationSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DeleteAssetInput = {
  assetId: Scalars['ID']['input'];
  deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAssetsInput = {
  assetIds: Array<Scalars['ID']['input']>;
  deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteFanClubLinkMissionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteStockLocationInput = {
  id: Scalars['ID']['input'];
  transferToLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeletionResponse = {
  __typename?: 'DeletionResponse';
  message?: Maybe<Scalars['String']['output']>;
  result: DeletionResult;
};

export enum DeletionResult {
  /** The entity was successfully deleted */
  Deleted = 'DELETED',
  /** Deletion did not take place, reason given in message */
  NotDeleted = 'NOT_DELETED'
}

export type Discount = {
  __typename?: 'Discount';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  amountWithTax: Scalars['Money']['output'];
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export type DuplicateEntityError = ErrorResult & {
  __typename?: 'DuplicateEntityError';
  duplicationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicateEntityInput = {
  duplicatorInput: ConfigurableOperationInput;
  entityId: Scalars['ID']['input'];
  entityName: Scalars['String']['input'];
};

export type DuplicateEntityResult = DuplicateEntityError | DuplicateEntitySuccess;

export type DuplicateEntitySuccess = {
  __typename?: 'DuplicateEntitySuccess';
  newEntityId: Scalars['ID']['output'];
};

/** Returned when attempting to create a Customer with an email address already registered to an existing User. */
export type EmailAddressConflictError = ErrorResult & {
  __typename?: 'EmailAddressConflictError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EmailTemplate = Node & {
  __typename?: 'EmailTemplate';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  translations?: Maybe<Array<EmailTemplateTranslation>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmailTemplateCode {
  CooperateApprove = 'CooperateApprove',
  FanClubAdded = 'FanClubAdded',
  FanClubAdminAdded = 'FanClubAdminAdded',
  FanClubAdminRemoved = 'FanClubAdminRemoved',
  FanClubApprove = 'FanClubApprove',
  FanClubReject = 'FanClubReject',
  FanClubRemoved = 'FanClubRemoved',
  FanClubRequest = 'FanClubRequest',
  LevelUp = 'LevelUp',
  OrderCancelled = 'OrderCancelled',
  OrderDelivered = 'OrderDelivered',
  OrderShipping = 'OrderShipping',
  OrderSuccess = 'OrderSuccess',
  QuestionPost = 'QuestionPost',
  Refund = 'Refund',
  RefundApprove = 'RefundApprove'
}

export type EmailTemplateFilterParameter = {
  _and?: InputMaybe<Array<EmailTemplateFilterParameter>>;
  _or?: InputMaybe<Array<EmailTemplateFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type EmailTemplateList = PaginatedList & {
  __typename?: 'EmailTemplateList';
  items: Array<EmailTemplate>;
  totalItems: Scalars['Int']['output'];
};

export type EmailTemplateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<EmailTemplateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<EmailTemplateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailTemplateSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateTranslation = Node & {
  __typename?: 'EmailTemplateTranslation';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  template: EmailTemplate;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned if no OrderLines have been specified for the operation */
export type EmptyOrderLineSelectionError = ErrorResult & {
  __typename?: 'EmptyOrderLineSelectionError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EntityCustomFields = {
  __typename?: 'EntityCustomFields';
  customFields: Array<CustomFieldConfig>;
  entityName: Scalars['String']['output'];
};

export type EntityDuplicatorDefinition = {
  __typename?: 'EntityDuplicatorDefinition';
  args: Array<ConfigArgDefinition>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  forEntities: Array<Scalars['String']['output']>;
  requiresPermission: Array<Permission>;
};

export enum ErrorCode {
  AlreadyRefundedError = 'ALREADY_REFUNDED_ERROR',
  CancelActiveOrderError = 'CANCEL_ACTIVE_ORDER_ERROR',
  CancelPaymentError = 'CANCEL_PAYMENT_ERROR',
  ChannelDefaultLanguageError = 'CHANNEL_DEFAULT_LANGUAGE_ERROR',
  CouponCodeExpiredError = 'COUPON_CODE_EXPIRED_ERROR',
  CouponCodeInvalidError = 'COUPON_CODE_INVALID_ERROR',
  CouponCodeLimitError = 'COUPON_CODE_LIMIT_ERROR',
  CreateFulfillmentError = 'CREATE_FULFILLMENT_ERROR',
  DuplicateEntityError = 'DUPLICATE_ENTITY_ERROR',
  EmailAddressConflictError = 'EMAIL_ADDRESS_CONFLICT_ERROR',
  EmptyOrderLineSelectionError = 'EMPTY_ORDER_LINE_SELECTION_ERROR',
  FacetInUseError = 'FACET_IN_USE_ERROR',
  FulfillmentStateTransitionError = 'FULFILLMENT_STATE_TRANSITION_ERROR',
  GuestCheckoutError = 'GUEST_CHECKOUT_ERROR',
  IneligibleShippingMethodError = 'INELIGIBLE_SHIPPING_METHOD_ERROR',
  InsufficientStockError = 'INSUFFICIENT_STOCK_ERROR',
  InsufficientStockOnHandError = 'INSUFFICIENT_STOCK_ON_HAND_ERROR',
  InvalidCredentialsError = 'INVALID_CREDENTIALS_ERROR',
  InvalidFulfillmentHandlerError = 'INVALID_FULFILLMENT_HANDLER_ERROR',
  ItemsAlreadyFulfilledError = 'ITEMS_ALREADY_FULFILLED_ERROR',
  LanguageNotAvailableError = 'LANGUAGE_NOT_AVAILABLE_ERROR',
  ManualPaymentStateError = 'MANUAL_PAYMENT_STATE_ERROR',
  MimeTypeError = 'MIME_TYPE_ERROR',
  MissingConditionsError = 'MISSING_CONDITIONS_ERROR',
  MultipleOrderError = 'MULTIPLE_ORDER_ERROR',
  NativeAuthStrategyError = 'NATIVE_AUTH_STRATEGY_ERROR',
  NegativeQuantityError = 'NEGATIVE_QUANTITY_ERROR',
  NothingToRefundError = 'NOTHING_TO_REFUND_ERROR',
  NoActiveOrderError = 'NO_ACTIVE_ORDER_ERROR',
  NoChangesSpecifiedError = 'NO_CHANGES_SPECIFIED_ERROR',
  OrderLimitError = 'ORDER_LIMIT_ERROR',
  OrderModificationError = 'ORDER_MODIFICATION_ERROR',
  OrderModificationStateError = 'ORDER_MODIFICATION_STATE_ERROR',
  OrderStateTransitionError = 'ORDER_STATE_TRANSITION_ERROR',
  PaymentMethodMissingError = 'PAYMENT_METHOD_MISSING_ERROR',
  PaymentOrderMismatchError = 'PAYMENT_ORDER_MISMATCH_ERROR',
  PaymentStateTransitionError = 'PAYMENT_STATE_TRANSITION_ERROR',
  ProductOptionInUseError = 'PRODUCT_OPTION_IN_USE_ERROR',
  QuantityTooGreatError = 'QUANTITY_TOO_GREAT_ERROR',
  RefundAmountError = 'REFUND_AMOUNT_ERROR',
  RefundOrderStateError = 'REFUND_ORDER_STATE_ERROR',
  RefundPaymentIdMissingError = 'REFUND_PAYMENT_ID_MISSING_ERROR',
  RefundStateTransitionError = 'REFUND_STATE_TRANSITION_ERROR',
  SettlePaymentError = 'SETTLE_PAYMENT_ERROR',
  UnknownError = 'UNKNOWN_ERROR'
}

export type ErrorResult = {
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EventApplicant = Node & {
  __typename?: 'EventApplicant';
  contactInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  event: FanClubEvent;
  eventId: Scalars['ID']['output'];
  fakePurchaseQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  idol?: Maybe<EventIdol>;
  idolId?: Maybe<Scalars['ID']['output']>;
  isWinner: Scalars['Boolean']['output'];
  method?: Maybe<Scalars['String']['output']>;
  purchaseQuantity: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventApplicantFilterParameter = {
  _and?: InputMaybe<Array<EventApplicantFilterParameter>>;
  _or?: InputMaybe<Array<EventApplicantFilterParameter>>;
  contactInfo?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  customerFirstName?: InputMaybe<StringOperators>;
  customerId?: InputMaybe<StringOperators>;
  customerLastName?: InputMaybe<StringOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  eventId?: InputMaybe<IdOperators>;
  fakePurchaseQuantity?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  idolId?: InputMaybe<IdOperators>;
  idolName?: InputMaybe<StringOperators>;
  isWinner?: InputMaybe<BooleanOperators>;
  method?: InputMaybe<StringOperators>;
  purchaseQuantity?: InputMaybe<NumberOperators>;
  status?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type EventApplicantList = PaginatedList & {
  __typename?: 'EventApplicantList';
  items: Array<EventApplicant>;
  totalItems: Scalars['Int']['output'];
};

export type EventApplicantListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<EventApplicantFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<EventApplicantSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EventApplicantSortParameter = {
  contactInfo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerFirstName?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  customerLastName?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  fakePurchaseQuantity?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idolId?: InputMaybe<SortOrder>;
  idolName?: InputMaybe<SortOrder>;
  method?: InputMaybe<SortOrder>;
  purchaseQuantity?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EventIdol = Node & {
  __typename?: 'EventIdol';
  createdAt: Scalars['DateTime']['output'];
  deleteAt: Scalars['DateTime']['output'];
  event: FanClubEvent;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numOfWinners: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EventIdolFilterParameter = {
  _and?: InputMaybe<Array<EventIdolFilterParameter>>;
  _or?: InputMaybe<Array<EventIdolFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  deleteAt?: InputMaybe<DateOperators>;
  eventId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  numOfWinners?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type EventIdolList = PaginatedList & {
  __typename?: 'EventIdolList';
  items: Array<EventIdol>;
  totalItems: Scalars['Int']['output'];
};

export type EventIdolListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<EventIdolFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<EventIdolSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EventIdolSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  deleteAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  numOfWinners?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EventMetricEntry = {
  __typename?: 'EventMetricEntry';
  label: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum EventMetricInterval {
  Daily = 'Daily'
}

export type EventMetricSummary = {
  __typename?: 'EventMetricSummary';
  entries: Array<EventMetricEntry>;
  interval: EventMetricInterval;
  title: Scalars['String']['output'];
  type: EventStatisticsType;
};

export type EventStatisticsInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  interval: EventMetricInterval;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: Array<EventStatisticsType>;
};

export enum EventStatisticsType {
  PaymentAuthorized = 'PaymentAuthorized',
  PaymentSettled = 'PaymentSettled',
  Shipped = 'Shipped'
}

export enum EventStatus {
  Ended = 'Ended',
  Ongoing = 'Ongoing',
  WinnerAnnouced = 'WinnerAnnouced'
}

export enum EventType {
  FaceToFace = 'FaceToFace',
  VideoCall = 'VideoCall'
}

export type Facet = Node & {
  __typename?: 'Facet';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of the Facet's values. Added in v2.1.0. */
  valueList: FacetValueList;
  values: Array<FacetValue>;
};


export type FacetValueListArgs = {
  options?: InputMaybe<FacetValueListOptions>;
};

export type FacetFilterParameter = {
  _and?: InputMaybe<Array<FacetFilterParameter>>;
  _or?: InputMaybe<Array<FacetFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isPrivate?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetInUseError = ErrorResult & {
  __typename?: 'FacetInUseError';
  errorCode: ErrorCode;
  facetCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  variantCount: Scalars['Int']['output'];
};

export type FacetList = PaginatedList & {
  __typename?: 'FacetList';
  items: Array<Facet>;
  totalItems: Scalars['Int']['output'];
};

export type FacetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetTranslation = {
  __typename?: 'FacetTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FacetValue = Node & {
  __typename?: 'FacetValue';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  facet: Facet;
  facetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetValueTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Used to construct boolean expressions for filtering search results
 * by FacetValue ID. Examples:
 *
 * * ID=1 OR ID=2: `{ facetValueFilters: [{ or: [1,2] }] }`
 * * ID=1 AND ID=2: `{ facetValueFilters: [{ and: 1 }, { and: 2 }] }`
 * * ID=1 AND (ID=2 OR ID=3): `{ facetValueFilters: [{ and: 1 }, { or: [2,3] }] }`
 */
export type FacetValueFilterInput = {
  and?: InputMaybe<Scalars['ID']['input']>;
  or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FacetValueFilterParameter = {
  _and?: InputMaybe<Array<FacetValueFilterParameter>>;
  _or?: InputMaybe<Array<FacetValueFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  facetId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetValueList = PaginatedList & {
  __typename?: 'FacetValueList';
  items: Array<FacetValue>;
  totalItems: Scalars['Int']['output'];
};

export type FacetValueListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetValueFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetValueSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Which FacetValues are present in the products returned
 * by the search, and in what quantity.
 */
export type FacetValueResult = {
  __typename?: 'FacetValueResult';
  count: Scalars['Int']['output'];
  facetValue: FacetValue;
};

export type FacetValueSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  facetId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetValueTranslation = {
  __typename?: 'FacetValueTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetValueTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FanClub = Node & {
  __typename?: 'FanClub';
  artist?: Maybe<Artist>;
  artistId?: Maybe<Scalars['ID']['output']>;
  artistName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isAutoApprove: Scalars['Boolean']['output'];
  joinStatus?: Maybe<Scalars['String']['output']>;
  links: Array<FanClubLink>;
  logo?: Maybe<Asset>;
  members?: Maybe<Array<Maybe<FanClubMember>>>;
  name: Scalars['String']['output'];
  revenueScore: Scalars['Int']['output'];
  totalLinks: Scalars['Int']['output'];
  totalMembers?: Maybe<Scalars['Int']['output']>;
  totalSales: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type FanClubMembersArgs = {
  status?: InputMaybe<MemberStatus>;
};

export type FanClubEditRequest = Node & {
  __typename?: 'FanClubEditRequest';
  approvedBy?: Maybe<Administrator>;
  approvedById?: Maybe<Scalars['ID']['output']>;
  artistName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Customer;
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fanClub: FanClub;
  fanClubId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Asset>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  status: FanClubEditStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FanClubEditStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type FanClubEvent = Node & {
  __typename?: 'FanClubEvent';
  allowCorporate?: Maybe<Scalars['Boolean']['output']>;
  announcementContent?: Maybe<Scalars['String']['output']>;
  applicationEndDate: Scalars['DateTime']['output'];
  applicationStartDate: Scalars['DateTime']['output'];
  artist?: Maybe<Artist>;
  artistId?: Maybe<Scalars['ID']['output']>;
  artistName: Scalars['String']['output'];
  checkboxes?: Maybe<Array<ConfirmationCheckbox>>;
  consentContents?: Maybe<Array<DefaultEventConsentContent>>;
  contactInfoType?: Maybe<ContactInfoType>;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  deleteAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  highestPurchaseQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  idols?: Maybe<Array<Maybe<EventIdol>>>;
  image?: Maybe<Asset>;
  imageId?: Maybe<Scalars['ID']['output']>;
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isCancelled: Scalars['Boolean']['output'];
  isRequestingCancel: Scalars['Boolean']['output'];
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  links: Array<FanClubLink>;
  name: Scalars['String']['output'];
  numOfWinners: Scalars['Int']['output'];
  orders: Array<FanClubOrder>;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  totalApplicants?: Maybe<Scalars['Int']['output']>;
  totalLinks?: Maybe<Scalars['Int']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  totalShippingOrders?: Maybe<Scalars['Int']['output']>;
  totalWinners?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubEventExtendedListOptions = {
  status?: InputMaybe<EventStatus>;
};

export type FanClubEventFilterParameter = {
  _and?: InputMaybe<Array<FanClubEventFilterParameter>>;
  _or?: InputMaybe<Array<FanClubEventFilterParameter>>;
  allowCorporate?: InputMaybe<BooleanOperators>;
  announcementContent?: InputMaybe<StringOperators>;
  applicationEndDate?: InputMaybe<DateOperators>;
  applicationStartDate?: InputMaybe<DateOperators>;
  artist?: InputMaybe<StringOperators>;
  artistId?: InputMaybe<IdOperators>;
  artistName?: InputMaybe<StringOperators>;
  contactInfoType?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  createdById?: InputMaybe<IdOperators>;
  deleteAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  endDate?: InputMaybe<DateOperators>;
  eventType?: InputMaybe<StringOperators>;
  highestPurchaseQuantity?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  imageId?: InputMaybe<IdOperators>;
  isApproved?: InputMaybe<BooleanOperators>;
  isCancelled?: InputMaybe<BooleanOperators>;
  isRequestingCancel?: InputMaybe<BooleanOperators>;
  isWinner?: InputMaybe<BooleanOperators>;
  linkId?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  numOfWinners?: InputMaybe<NumberOperators>;
  startDate?: InputMaybe<DateOperators>;
  status?: InputMaybe<StringOperators>;
  totalApplicants?: InputMaybe<NumberOperators>;
  totalLinks?: InputMaybe<NumberOperators>;
  totalOrders?: InputMaybe<NumberOperators>;
  totalShippingOrders?: InputMaybe<NumberOperators>;
  totalWinners?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubEventList = PaginatedList & {
  __typename?: 'FanClubEventList';
  items: Array<FanClubEvent>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubEventListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubEventFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubEventSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubEventSortParameter = {
  announcementContent?: InputMaybe<SortOrder>;
  applicationEndDate?: InputMaybe<SortOrder>;
  applicationStartDate?: InputMaybe<SortOrder>;
  artistId?: InputMaybe<SortOrder>;
  artistName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdById?: InputMaybe<SortOrder>;
  deleteAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventType?: InputMaybe<SortOrder>;
  highestPurchaseQuantity?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  numOfWinners?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalApplicants?: InputMaybe<SortOrder>;
  totalLinks?: InputMaybe<SortOrder>;
  totalOrders?: InputMaybe<SortOrder>;
  totalShippingOrders?: InputMaybe<SortOrder>;
  totalWinners?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubFilterParameter = {
  _and?: InputMaybe<Array<FanClubFilterParameter>>;
  _or?: InputMaybe<Array<FanClubFilterParameter>>;
  artist?: InputMaybe<StringOperators>;
  artistId?: InputMaybe<IdOperators>;
  artistName?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  isAdmin?: InputMaybe<BooleanOperators>;
  isAutoApprove?: InputMaybe<BooleanOperators>;
  joinStatus?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  productId?: InputMaybe<IdOperators>;
  revenueScore?: InputMaybe<NumberOperators>;
  totalLinks?: InputMaybe<NumberOperators>;
  totalMembers?: InputMaybe<NumberOperators>;
  totalSales?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubGroup = Node & {
  __typename?: 'FanClubGroup';
  createdAt: Scalars['DateTime']['output'];
  customers: Array<Customer>;
  fanClub: FanClub;
  fanClubId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};

export type FanClubGroupFilterParameter = {
  _and?: InputMaybe<Array<FanClubGroupFilterParameter>>;
  _or?: InputMaybe<Array<FanClubGroupFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  fanClubId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubGroupList = PaginatedList & {
  __typename?: 'FanClubGroupList';
  items: Array<FanClubGroup>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubGroupListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubGroupFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubGroupSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubGroupSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  fanClubId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubLink = Node & {
  __typename?: 'FanClubLink';
  availableCountries?: Maybe<Array<AvailableCountryShipping>>;
  checkboxs?: Maybe<Array<ConfirmationCheckbox>>;
  countries?: Maybe<Array<Country>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdByAdmin?: Maybe<Administrator>;
  createdById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  events: Array<Maybe<FanClubEvent>>;
  fanClub?: Maybe<NullableFanClub>;
  fanClubId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isCorporateLink: Scalars['Boolean']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isFanClubExclusive: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  linkVariants: Array<LinkVariant>;
  product: Product;
  productId: Scalars['ID']['output'];
  sales?: Maybe<Scalars['Int']['output']>;
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  showGifts: Scalars['Boolean']['output'];
  showSalesData: Scalars['Boolean']['output'];
  showStock: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  totalBuyers: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalShippingOrders: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubLinkFilterParameter = {
  _and?: InputMaybe<Array<FanClubLinkFilterParameter>>;
  _or?: InputMaybe<Array<FanClubLinkFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  createdById?: InputMaybe<IdOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  endDate?: InputMaybe<DateOperators>;
  eventId?: InputMaybe<IdOperators>;
  fanClubId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  isActivated?: InputMaybe<BooleanOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  isApproved?: InputMaybe<BooleanOperators>;
  isCorporateLink?: InputMaybe<BooleanOperators>;
  isExclusive?: InputMaybe<BooleanOperators>;
  isFanClubExclusive?: InputMaybe<BooleanOperators>;
  isSuspended?: InputMaybe<BooleanOperators>;
  productId?: InputMaybe<IdOperators>;
  sales?: InputMaybe<NumberOperators>;
  showGifts?: InputMaybe<BooleanOperators>;
  showSalesData?: InputMaybe<BooleanOperators>;
  showStock?: InputMaybe<BooleanOperators>;
  slug?: InputMaybe<StringOperators>;
  startDate?: InputMaybe<DateOperators>;
  totalBuyers?: InputMaybe<NumberOperators>;
  totalEvents?: InputMaybe<NumberOperators>;
  totalOrders?: InputMaybe<NumberOperators>;
  totalShippingOrders?: InputMaybe<NumberOperators>;
  totalViews?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubLinkInvoiceHistory = Node & {
  __typename?: 'FanClubLinkInvoiceHistory';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<FanClubLink>;
  linkId?: Maybe<Scalars['ID']['output']>;
  requester?: Maybe<Customer>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubLinkInvoiceHistoryFilterParameter = {
  _and?: InputMaybe<Array<FanClubLinkInvoiceHistoryFilterParameter>>;
  _or?: InputMaybe<Array<FanClubLinkInvoiceHistoryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  endTime?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  linkId?: InputMaybe<IdOperators>;
  requesterId?: InputMaybe<IdOperators>;
  startTime?: InputMaybe<DateOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubLinkInvoiceHistoryList = PaginatedList & {
  __typename?: 'FanClubLinkInvoiceHistoryList';
  items: Array<FanClubLinkInvoiceHistory>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubLinkInvoiceHistoryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubLinkInvoiceHistoryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubLinkInvoiceHistorySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubLinkInvoiceHistorySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkId?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubLinkList = PaginatedList & {
  __typename?: 'FanClubLinkList';
  items: Array<FanClubLink>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubLinkListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubLinkFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubLinkSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubLinkMission = Node & {
  __typename?: 'FanClubLinkMission';
  createdAt: Scalars['DateTime']['output'];
  current: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isFinished: Scalars['Boolean']['output'];
  link: FanClubLink;
  linkId: Scalars['ID']['output'];
  pointRewardAmount?: Maybe<Scalars['Int']['output']>;
  promotion?: Maybe<Promotion>;
  promotionId?: Maybe<Scalars['ID']['output']>;
  rewardType: FanClubLinkMissionRewardType;
  target: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  translations: Array<FanClubLinkMissionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubLinkMissionFilterParameter = {
  _and?: InputMaybe<Array<FanClubLinkMissionFilterParameter>>;
  _or?: InputMaybe<Array<FanClubLinkMissionFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  current?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  isFinished?: InputMaybe<BooleanOperators>;
  linkId?: InputMaybe<IdOperators>;
  pointRewardAmount?: InputMaybe<NumberOperators>;
  promotionId?: InputMaybe<IdOperators>;
  rewardType?: InputMaybe<StringOperators>;
  target?: InputMaybe<NumberOperators>;
  text?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubLinkMissionList = PaginatedList & {
  __typename?: 'FanClubLinkMissionList';
  items: Array<FanClubLinkMission>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubLinkMissionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubLinkMissionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubLinkMissionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum FanClubLinkMissionRewardType {
  Coupon = 'Coupon',
  Point = 'Point'
}

export type FanClubLinkMissionSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  current?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkId?: InputMaybe<SortOrder>;
  pointRewardAmount?: InputMaybe<SortOrder>;
  promotionId?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubLinkMissionTranslation = Node & {
  __typename?: 'FanClubLinkMissionTranslation';
  base: FanClubLinkMission;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubLinkPurchaseNeeded = Node & {
  __typename?: 'FanClubLinkPurchaseNeeded';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isExclusive: Scalars['Boolean']['output'];
  isFanClubExclusive: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  productVariants: Array<ProductVariant>;
  showGifts: Scalars['Boolean']['output'];
  showSalesData: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubLinkSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  createdById?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  fanClubId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sales?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  totalBuyers?: InputMaybe<SortOrder>;
  totalEvents?: InputMaybe<SortOrder>;
  totalOrders?: InputMaybe<SortOrder>;
  totalShippingOrders?: InputMaybe<SortOrder>;
  totalViews?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubList = PaginatedList & {
  __typename?: 'FanClubList';
  items: Array<FanClub>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubMember = Node & {
  __typename?: 'FanClubMember';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fanClub: FanClub;
  fanClubId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  status: MemberStatus;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type FanClubMemberFilterParameter = {
  _and?: InputMaybe<Array<FanClubMemberFilterParameter>>;
  _or?: InputMaybe<Array<FanClubMemberFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  customerId?: InputMaybe<IdOperators>;
  customerName?: InputMaybe<StringOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  fanClubId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  isAdmin?: InputMaybe<BooleanOperators>;
  status?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  userId?: InputMaybe<IdOperators>;
};

export type FanClubMemberList = PaginatedList & {
  __typename?: 'FanClubMemberList';
  items: Array<FanClubMember>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubMemberListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubMemberFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubMemberSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubMemberSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  fanClubId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type FanClubOrder = Node & {
  __typename?: 'FanClubOrder';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<FanClubEvent>;
  eventId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  link: FanClubLink;
  linkId: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubOrderFilterParameter = {
  _and?: InputMaybe<Array<FanClubOrderFilterParameter>>;
  _or?: InputMaybe<Array<FanClubOrderFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  eventId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  linkId?: InputMaybe<IdOperators>;
  orderId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubOrderList = PaginatedList & {
  __typename?: 'FanClubOrderList';
  items: Array<FanClubOrder>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubOrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubOrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubOrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubOrderSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkId?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubPointHistory = Node & {
  __typename?: 'FanClubPointHistory';
  admin?: Maybe<Administrator>;
  adminId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  fanClub: FanClub;
  fanClubId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FanClubPointHistoryFilterParameter = {
  _and?: InputMaybe<Array<FanClubPointHistoryFilterParameter>>;
  _or?: InputMaybe<Array<FanClubPointHistoryFilterParameter>>;
  adminId?: InputMaybe<IdOperators>;
  amount?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  fanClubId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  note?: InputMaybe<StringOperators>;
  orderId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FanClubPointHistoryList = PaginatedList & {
  __typename?: 'FanClubPointHistoryList';
  items: Array<FanClubPointHistory>;
  totalItems: Scalars['Int']['output'];
};

export type FanClubPointHistoryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FanClubPointHistoryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FanClubPointHistorySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FanClubPointHistorySortParameter = {
  adminId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  fanClubId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubSortParameter = {
  artistId?: InputMaybe<SortOrder>;
  artistName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinStatus?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  revenueScore?: InputMaybe<SortOrder>;
  totalLinks?: InputMaybe<SortOrder>;
  totalMembers?: InputMaybe<SortOrder>;
  totalSales?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FanClubView = Node & {
  __typename?: 'FanClubView';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Scalars['String']['output'];
  link: FanClubLink;
  linkId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FloatCustomFieldConfig = CustomField & {
  __typename?: 'FloatCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type FreeGiftCondition = Node & {
  __typename?: 'FreeGiftCondition';
  createdAt: Scalars['DateTime']['output'];
  giftQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minQuantity: Scalars['Int']['output'];
  productVariants: Array<ProductVariant>;
  selection: FreeGiftSelection;
  selectionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeGiftConditionPurchaseNeeded = Node & {
  __typename?: 'FreeGiftConditionPurchaseNeeded';
  createdAt: Scalars['DateTime']['output'];
  giftQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minQuantity: Scalars['Int']['output'];
  selection: FreeGiftSelectionPurchaseNeeded;
  selectionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeGiftSelection = Node & {
  __typename?: 'FreeGiftSelection';
  conditions: Array<FreeGiftCondition>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRandom?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeGiftSelectionFilterParameter = {
  _and?: InputMaybe<Array<FreeGiftSelectionFilterParameter>>;
  _or?: InputMaybe<Array<FreeGiftSelectionFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isRandom?: InputMaybe<BooleanOperators>;
  productId?: InputMaybe<IdOperators>;
  productVariantId?: InputMaybe<IdOperators>;
  title?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FreeGiftSelectionList = PaginatedList & {
  __typename?: 'FreeGiftSelectionList';
  items: Array<FreeGiftSelection>;
  totalItems: Scalars['Int']['output'];
};

export type FreeGiftSelectionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FreeGiftSelectionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FreeGiftSelectionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FreeGiftSelectionPurchaseNeeded = Node & {
  __typename?: 'FreeGiftSelectionPurchaseNeeded';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariantId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeGiftSelectionSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productVariantId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FulfillOrderInput = {
  handler: ConfigurableOperationInput;
  lines: Array<OrderLineInput>;
};

export type Fulfillment = Node & {
  __typename?: 'Fulfillment';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lines: Array<FulfillmentLine>;
  method: Scalars['String']['output'];
  nextStates: Array<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  /** @deprecated Use the `lines` field instead */
  summary: Array<FulfillmentLine>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FulfillmentLine = {
  __typename?: 'FulfillmentLine';
  fulfillment: Fulfillment;
  fulfillmentId: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

/** Returned when there is an error in transitioning the Fulfillment state */
export type FulfillmentStateTransitionError = ErrorResult & {
  __typename?: 'FulfillmentStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

export type GenerateProductSlugInput = {
  slugPrefix: Scalars['String']['input'];
};

export enum GlobalFlag {
  False = 'FALSE',
  Inherit = 'INHERIT',
  True = 'TRUE'
}

export type GlobalSettings = {
  __typename?: 'GlobalSettings';
  availableLanguages: Array<LanguageCode>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<GlobalSettingsCustomFields>;
  id: Scalars['ID']['output'];
  outOfStockThreshold: Scalars['Int']['output'];
  serverConfig: ServerConfig;
  trackInventory: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GlobalSettingsCustomFields = {
  __typename?: 'GlobalSettingsCustomFields';
  adminUrl?: Maybe<Scalars['String']['output']>;
  storefrontUrl?: Maybe<Scalars['String']['output']>;
};

export type GoodsGetInput = {
  abcCate?: InputMaybe<Scalars['String']['input']>;
  assistBarcode?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  cateName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateModifiedGoods?: InputMaybe<Scalars['String']['input']>;
  endDateModifiedSku?: InputMaybe<Scalars['String']['input']>;
  goodsAlias?: InputMaybe<Scalars['String']['input']>;
  goodsName?: InputMaybe<Scalars['String']['input']>;
  goodsNo?: InputMaybe<Scalars['Int']['input']>;
  isBlockup?: InputMaybe<Scalars['Int']['input']>;
  isPackageGood?: InputMaybe<Scalars['Int']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  skuBarcode?: InputMaybe<Scalars['String']['input']>;
  skuIsBlockup?: InputMaybe<Scalars['Int']['input']>;
  skuName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDateModifiedGoods?: InputMaybe<Scalars['String']['input']>;
  startDateModifiedSku?: InputMaybe<Scalars['String']['input']>;
};

/** Returned when attempting to set the Customer on a guest checkout when the configured GuestCheckoutStrategy does not allow it. */
export type GuestCheckoutError = ErrorResult & {
  __typename?: 'GuestCheckoutError';
  errorCode: ErrorCode;
  errorDetail: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Guidance = Node & {
  __typename?: 'Guidance';
  createdAt: Scalars['DateTime']['output'];
  guidanceContentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  translations: Array<GuidanceTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GuidanceFilterParameter = {
  _and?: InputMaybe<Array<GuidanceFilterParameter>>;
  _or?: InputMaybe<Array<GuidanceFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  guidanceContentId?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type GuidanceList = PaginatedList & {
  __typename?: 'GuidanceList';
  items: Array<Guidance>;
  totalItems: Scalars['Int']['output'];
};

export type GuidanceListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<GuidanceFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<GuidanceSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GuidanceSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  guidanceContentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type GuidanceTranslation = {
  __typename?: 'GuidanceTranslation';
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  localizedContent: Scalars['String']['output'];
};

export type GuidanceTranslationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: Scalars['String']['input'];
  localizedContent: Scalars['String']['input'];
};

export type HistoryEntry = Node & {
  __typename?: 'HistoryEntry';
  administrator?: Maybe<Administrator>;
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  type: HistoryEntryType;
  updatedAt: Scalars['DateTime']['output'];
};

export type HistoryEntryFilterParameter = {
  _and?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  _or?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isPublic?: InputMaybe<BooleanOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type HistoryEntryList = PaginatedList & {
  __typename?: 'HistoryEntryList';
  items: Array<HistoryEntry>;
  totalItems: Scalars['Int']['output'];
};

export type HistoryEntryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<HistoryEntryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<HistoryEntrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type HistoryEntrySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HistoryEntryType {
  CustomerAddedToGroup = 'CUSTOMER_ADDED_TO_GROUP',
  CustomerAddressCreated = 'CUSTOMER_ADDRESS_CREATED',
  CustomerAddressDeleted = 'CUSTOMER_ADDRESS_DELETED',
  CustomerAddressUpdated = 'CUSTOMER_ADDRESS_UPDATED',
  CustomerDetailUpdated = 'CUSTOMER_DETAIL_UPDATED',
  CustomerEmailUpdateRequested = 'CUSTOMER_EMAIL_UPDATE_REQUESTED',
  CustomerEmailUpdateVerified = 'CUSTOMER_EMAIL_UPDATE_VERIFIED',
  CustomerNote = 'CUSTOMER_NOTE',
  CustomerPasswordResetRequested = 'CUSTOMER_PASSWORD_RESET_REQUESTED',
  CustomerPasswordResetVerified = 'CUSTOMER_PASSWORD_RESET_VERIFIED',
  CustomerPasswordUpdated = 'CUSTOMER_PASSWORD_UPDATED',
  CustomerRegistered = 'CUSTOMER_REGISTERED',
  CustomerRemovedFromGroup = 'CUSTOMER_REMOVED_FROM_GROUP',
  CustomerVerified = 'CUSTOMER_VERIFIED',
  EventCreate = 'EVENT_CREATE',
  EventDelete = 'EVENT_DELETE',
  EventOrderPurchased = 'EVENT_ORDER_PURCHASED',
  EventUpdate = 'EVENT_UPDATE',
  FanclubCreate = 'FANCLUB_CREATE',
  FanclubDelete = 'FANCLUB_DELETE',
  FanclubUpdate = 'FANCLUB_UPDATE',
  LinkCreate = 'LINK_CREATE',
  LinkDelete = 'LINK_DELETE',
  LinkUpdate = 'LINK_UPDATE',
  OrderCancellation = 'ORDER_CANCELLATION',
  OrderCouponApplied = 'ORDER_COUPON_APPLIED',
  OrderCouponRemoved = 'ORDER_COUPON_REMOVED',
  OrderCustomerUpdated = 'ORDER_CUSTOMER_UPDATED',
  OrderFulfillment = 'ORDER_FULFILLMENT',
  OrderFulfillmentTransition = 'ORDER_FULFILLMENT_TRANSITION',
  OrderModified = 'ORDER_MODIFIED',
  OrderNote = 'ORDER_NOTE',
  OrderPaymentTransition = 'ORDER_PAYMENT_TRANSITION',
  OrderRefundTransition = 'ORDER_REFUND_TRANSITION',
  OrderStateTransition = 'ORDER_STATE_TRANSITION',
  ProductCreate = 'PRODUCT_CREATE',
  ProductDelete = 'PRODUCT_DELETE',
  ProductUpdate = 'PRODUCT_UPDATE'
}

export type HomepageProductList = {
  __typename?: 'HomepageProductList';
  eventList?: Maybe<Array<Product>>;
  newList?: Maybe<Array<Product>>;
  preOrderList?: Maybe<Array<Product>>;
};

/** Operators for filtering on a list of ID fields */
export type IdListOperators = {
  inList: Scalars['ID']['input'];
};

/** Operators for filtering on an ID field */
export type IdOperators = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportFileInput = {
  file: Scalars['Upload']['input'];
};

export type ImportInfo = {
  __typename?: 'ImportInfo';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  imported: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

export type InboundApprove = Node & {
  __typename?: 'InboundApprove';
  assets: Array<Asset>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Administrator;
  id: Scalars['ID']['output'];
  inbound: Inbounding;
  inboundId: Scalars['ID']['output'];
  isApproved: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundApproveRequest = Node & {
  __typename?: 'InboundApproveRequest';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  assets: Array<Asset>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Administrator;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  withoutPurchaseRequest?: Maybe<Scalars['Boolean']['output']>;
};

export type InboundApproveRequestFilterParameter = {
  _and?: InputMaybe<Array<InboundApproveRequestFilterParameter>>;
  _or?: InputMaybe<Array<InboundApproveRequestFilterParameter>>;
  arrivalDate?: InputMaybe<DateOperators>;
  companyName?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  createdById?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  identifier?: InputMaybe<StringOperators>;
  note?: InputMaybe<StringOperators>;
  productId?: InputMaybe<IdOperators>;
  productVariantId?: InputMaybe<IdOperators>;
  quantity?: InputMaybe<NumberOperators>;
  reason?: InputMaybe<StringOperators>;
  status?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  withoutPurchaseRequest?: InputMaybe<BooleanOperators>;
};

export type InboundApproveRequestList = PaginatedList & {
  __typename?: 'InboundApproveRequestList';
  items: Array<InboundApproveRequest>;
  totalItems: Scalars['Int']['output'];
};

export type InboundApproveRequestListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<InboundApproveRequestFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<InboundApproveRequestSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type InboundApproveRequestSortParameter = {
  arrivalDate?: InputMaybe<SortOrder>;
  companyName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  productVariantId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum InboundApproveRequestStatus {
  Approved = 'Approved',
  New = 'New',
  Rejected = 'Rejected',
  Requested = 'Requested'
}

export type InboundFanClubLinkPurchaseNeeded = Node & {
  __typename?: 'InboundFanClubLinkPurchaseNeeded';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActivated: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isExclusive: Scalars['Boolean']['output'];
  isFanClubExclusive: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  productVariants: Array<ProductVariant>;
  showGifts: Scalars['Boolean']['output'];
  showSalesData: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundRequestPurchase = Node & {
  __typename?: 'InboundRequestPurchase';
  approver?: Maybe<Administrator>;
  approverId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  daysLate: Scalars['Int']['output'];
  details?: Maybe<Array<InboundRequestPurchaseDetail>>;
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  inNo?: Maybe<Scalars['String']['output']>;
  notSpecify?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderQuantity: Scalars['Int']['output'];
  productVariant: ProductVariant;
  productVariantId: Scalars['ID']['output'];
  quantityFulfilled: Scalars['Int']['output'];
  quantityNeeded: Scalars['Int']['output'];
  requester?: Maybe<Administrator>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  stockOnHand: Scalars['Int']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundRequestPurchaseDetail = Node & {
  __typename?: 'InboundRequestPurchaseDetail';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  link: InboundFanClubLinkPurchaseNeeded;
  linkId: Scalars['ID']['output'];
  orderQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundRequestPurchaseGroup = Node & {
  __typename?: 'InboundRequestPurchaseGroup';
  approver?: Maybe<Administrator>;
  approverId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Asset>>>;
  note?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['ID']['output'];
  requester?: Maybe<Administrator>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  requests?: Maybe<Array<InboundRequestPurchase>>;
  shopSupplier?: Maybe<ShopSupplier>;
  status: Scalars['String']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Inbounding = Node & {
  __typename?: 'Inbounding';
  approvalStatus: ApprovalStatus;
  confirmer?: Maybe<Administrator>;
  confirmerId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  daysLate: Scalars['Int']['output'];
  group: InboundRequestPurchaseGroup;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  totalOrderQuantity: Scalars['Int']['output'];
  totalQuantityFulfilled: Scalars['Int']['output'];
  totalQuantityNeeded: Scalars['Int']['output'];
  totalStockOnHand: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundingFilterParameter = {
  _and?: InputMaybe<Array<InboundingFilterParameter>>;
  _or?: InputMaybe<Array<InboundingFilterParameter>>;
  approvalStatus?: InputMaybe<StringOperators>;
  confirmerId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  daysLate?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  inNo?: InputMaybe<StringOperators>;
  productName?: InputMaybe<StringOperators>;
  status?: InputMaybe<StringOperators>;
  totalOrderQuantity?: InputMaybe<NumberOperators>;
  totalQuantityFulfilled?: InputMaybe<NumberOperators>;
  totalQuantityNeeded?: InputMaybe<NumberOperators>;
  totalStockOnHand?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type InboundingList = PaginatedList & {
  __typename?: 'InboundingList';
  items: Array<Inbounding>;
  totalItems: Scalars['Int']['output'];
};

export type InboundingListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<InboundingFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<InboundingSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type InboundingSortParameter = {
  confirmerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  daysLate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalOrderQuantity?: InputMaybe<SortOrder>;
  totalQuantityFulfilled?: InputMaybe<SortOrder>;
  totalQuantityNeeded?: InputMaybe<SortOrder>;
  totalStockOnHand?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum InboundingStatus {
  Confirmed = 'Confirmed',
  Finished = 'Finished',
  Late = 'Late',
  Waiting = 'Waiting'
}

/** Returned when attempting to set a ShippingMethod for which the Order is not eligible */
export type IneligibleShippingMethodError = ErrorResult & {
  __typename?: 'IneligibleShippingMethodError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to add more items to the Order than are available */
export type InsufficientStockError = ErrorResult & {
  __typename?: 'InsufficientStockError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  order: Order;
  quantityAvailable: Scalars['Int']['output'];
};

/**
 * Returned if attempting to create a Fulfillment when there is insufficient
 * stockOnHand of a ProductVariant to satisfy the requested quantity.
 */
export type InsufficientStockOnHandError = ErrorResult & {
  __typename?: 'InsufficientStockOnHandError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  stockOnHand: Scalars['Int']['output'];
};

export type IntCustomFieldConfig = CustomField & {
  __typename?: 'IntCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Returned if the user authentication credentials are not valid */
export type InvalidCredentialsError = ErrorResult & {
  __typename?: 'InvalidCredentialsError';
  authenticationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the specified FulfillmentHandler code is not valid */
export type InvalidFulfillmentHandlerError = ErrorResult & {
  __typename?: 'InvalidFulfillmentHandlerError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the specified items are already part of a Fulfillment */
export type ItemsAlreadyFulfilledError = ErrorResult & {
  __typename?: 'ItemsAlreadyFulfilledError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Job = Node & {
  __typename?: 'Job';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  duration: Scalars['Int']['output'];
  error?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isSettled: Scalars['Boolean']['output'];
  progress: Scalars['Float']['output'];
  queueName: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  retries: Scalars['Int']['output'];
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: JobState;
};

export type JobBufferSize = {
  __typename?: 'JobBufferSize';
  bufferId: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type JobFilterParameter = {
  _and?: InputMaybe<Array<JobFilterParameter>>;
  _or?: InputMaybe<Array<JobFilterParameter>>;
  attempts?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  duration?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  isSettled?: InputMaybe<BooleanOperators>;
  progress?: InputMaybe<NumberOperators>;
  queueName?: InputMaybe<StringOperators>;
  retries?: InputMaybe<NumberOperators>;
  settledAt?: InputMaybe<DateOperators>;
  startedAt?: InputMaybe<DateOperators>;
  state?: InputMaybe<StringOperators>;
};

export type JobList = PaginatedList & {
  __typename?: 'JobList';
  items: Array<Job>;
  totalItems: Scalars['Int']['output'];
};

export type JobListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<JobFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<JobSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobQueue = {
  __typename?: 'JobQueue';
  name: Scalars['String']['output'];
  running: Scalars['Boolean']['output'];
};

export type JobSortParameter = {
  attempts?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  progress?: InputMaybe<SortOrder>;
  queueName?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
  settledAt?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
};

/**
 * @description
 * The state of a Job in the JobQueue
 *
 * @docsCategory common
 */
export enum JobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Retrying = 'RETRYING',
  Running = 'RUNNING'
}

/**
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 *
 * @docsCategory common
 */
export enum LanguageCode {
  /** Afrikaans */
  Af = 'af',
  /** Akan */
  Ak = 'ak',
  /** Amharic */
  Am = 'am',
  /** Arabic */
  Ar = 'ar',
  /** Assamese */
  As = 'as',
  /** Azerbaijani */
  Az = 'az',
  /** Belarusian */
  Be = 'be',
  /** Bulgarian */
  Bg = 'bg',
  /** Bambara */
  Bm = 'bm',
  /** Bangla */
  Bn = 'bn',
  /** Tibetan */
  Bo = 'bo',
  /** Breton */
  Br = 'br',
  /** Bosnian */
  Bs = 'bs',
  /** Catalan */
  Ca = 'ca',
  /** Chechen */
  Ce = 'ce',
  /** Corsican */
  Co = 'co',
  /** Czech */
  Cs = 'cs',
  /** Church Slavic */
  Cu = 'cu',
  /** Welsh */
  Cy = 'cy',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** Austrian German */
  DeAt = 'de_AT',
  /** Swiss High German */
  DeCh = 'de_CH',
  /** Dzongkha */
  Dz = 'dz',
  /** Ewe */
  Ee = 'ee',
  /** Greek */
  El = 'el',
  /** English */
  En = 'en',
  /** Australian English */
  EnAu = 'en_AU',
  /** Canadian English */
  EnCa = 'en_CA',
  /** British English */
  EnGb = 'en_GB',
  /** American English */
  EnUs = 'en_US',
  /** Esperanto */
  Eo = 'eo',
  /** Spanish */
  Es = 'es',
  /** European Spanish */
  EsEs = 'es_ES',
  /** Mexican Spanish */
  EsMx = 'es_MX',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Persian */
  Fa = 'fa',
  /** Dari */
  FaAf = 'fa_AF',
  /** Fulah */
  Ff = 'ff',
  /** Finnish */
  Fi = 'fi',
  /** Faroese */
  Fo = 'fo',
  /** French */
  Fr = 'fr',
  /** Canadian French */
  FrCa = 'fr_CA',
  /** Swiss French */
  FrCh = 'fr_CH',
  /** Western Frisian */
  Fy = 'fy',
  /** Irish */
  Ga = 'ga',
  /** Scottish Gaelic */
  Gd = 'gd',
  /** Galician */
  Gl = 'gl',
  /** Gujarati */
  Gu = 'gu',
  /** Manx */
  Gv = 'gv',
  /** Hausa */
  Ha = 'ha',
  /** Hebrew */
  He = 'he',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Haitian Creole */
  Ht = 'ht',
  /** Hungarian */
  Hu = 'hu',
  /** Armenian */
  Hy = 'hy',
  /** Interlingua */
  Ia = 'ia',
  /** Indonesian */
  Id = 'id',
  /** Igbo */
  Ig = 'ig',
  /** Sichuan Yi */
  Ii = 'ii',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Javanese */
  Jv = 'jv',
  /** Georgian */
  Ka = 'ka',
  /** Kikuyu */
  Ki = 'ki',
  /** Kazakh */
  Kk = 'kk',
  /** Kalaallisut */
  Kl = 'kl',
  /** Khmer */
  Km = 'km',
  /** Kannada */
  Kn = 'kn',
  /** Korean */
  Ko = 'ko',
  /** Kashmiri */
  Ks = 'ks',
  /** Kurdish */
  Ku = 'ku',
  /** Cornish */
  Kw = 'kw',
  /** Kyrgyz */
  Ky = 'ky',
  /** Latin */
  La = 'la',
  /** Luxembourgish */
  Lb = 'lb',
  /** Ganda */
  Lg = 'lg',
  /** Lingala */
  Ln = 'ln',
  /** Lao */
  Lo = 'lo',
  /** Lithuanian */
  Lt = 'lt',
  /** Luba-Katanga */
  Lu = 'lu',
  /** Latvian */
  Lv = 'lv',
  /** Malagasy */
  Mg = 'mg',
  /** Maori */
  Mi = 'mi',
  /** Macedonian */
  Mk = 'mk',
  /** Malayalam */
  Ml = 'ml',
  /** Mongolian */
  Mn = 'mn',
  /** Marathi */
  Mr = 'mr',
  /** Malay */
  Ms = 'ms',
  /** Maltese */
  Mt = 'mt',
  /** Burmese */
  My = 'my',
  /** Norwegian Bokmål */
  Nb = 'nb',
  /** North Ndebele */
  Nd = 'nd',
  /** Nepali */
  Ne = 'ne',
  /** Dutch */
  Nl = 'nl',
  /** Flemish */
  NlBe = 'nl_BE',
  /** Norwegian Nynorsk */
  Nn = 'nn',
  /** Nyanja */
  Ny = 'ny',
  /** Oromo */
  Om = 'om',
  /** Odia */
  Or = 'or',
  /** Ossetic */
  Os = 'os',
  /** Punjabi */
  Pa = 'pa',
  /** Polish */
  Pl = 'pl',
  /** Pashto */
  Ps = 'ps',
  /** Portuguese */
  Pt = 'pt',
  /** Brazilian Portuguese */
  PtBr = 'pt_BR',
  /** European Portuguese */
  PtPt = 'pt_PT',
  /** Quechua */
  Qu = 'qu',
  /** Romansh */
  Rm = 'rm',
  /** Rundi */
  Rn = 'rn',
  /** Romanian */
  Ro = 'ro',
  /** Moldavian */
  RoMd = 'ro_MD',
  /** Russian */
  Ru = 'ru',
  /** Kinyarwanda */
  Rw = 'rw',
  /** Sanskrit */
  Sa = 'sa',
  /** Sindhi */
  Sd = 'sd',
  /** Northern Sami */
  Se = 'se',
  /** Sango */
  Sg = 'sg',
  /** Sinhala */
  Si = 'si',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Samoan */
  Sm = 'sm',
  /** Shona */
  Sn = 'sn',
  /** Somali */
  So = 'so',
  /** Albanian */
  Sq = 'sq',
  /** Serbian */
  Sr = 'sr',
  /** Southern Sotho */
  St = 'st',
  /** Sundanese */
  Su = 'su',
  /** Swedish */
  Sv = 'sv',
  /** Swahili */
  Sw = 'sw',
  /** Congo Swahili */
  SwCd = 'sw_CD',
  /** Tamil */
  Ta = 'ta',
  /** Telugu */
  Te = 'te',
  /** Tajik */
  Tg = 'tg',
  /** Thai */
  Th = 'th',
  /** Tigrinya */
  Ti = 'ti',
  /** Turkmen */
  Tk = 'tk',
  /** Tongan */
  To = 'to',
  /** Turkish */
  Tr = 'tr',
  /** Tatar */
  Tt = 'tt',
  /** Uyghur */
  Ug = 'ug',
  /** Ukrainian */
  Uk = 'uk',
  /** Urdu */
  Ur = 'ur',
  /** Uzbek */
  Uz = 'uz',
  /** Vietnamese */
  Vi = 'vi',
  /** Volapük */
  Vo = 'vo',
  /** Wolof */
  Wo = 'wo',
  /** Xhosa */
  Xh = 'xh',
  /** Yiddish */
  Yi = 'yi',
  /** Yoruba */
  Yo = 'yo',
  /** Chinese */
  Zh = 'zh',
  /** Simplified Chinese */
  ZhHans = 'zh_Hans',
  /** Traditional Chinese */
  ZhHant = 'zh_Hant',
  /** Zulu */
  Zu = 'zu'
}

/** Returned if attempting to set a Channel's defaultLanguageCode to a language which is not enabled in GlobalSettings */
export type LanguageNotAvailableError = ErrorResult & {
  __typename?: 'LanguageNotAvailableError';
  errorCode: ErrorCode;
  languageCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum LevelType {
  Cooperate = 'Cooperate',
  General = 'General'
}

export type LinkVariant = {
  __typename?: 'LinkVariant';
  customPrice?: Maybe<Scalars['Float']['output']>;
  customStock?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fanClubLink: FanClubLink;
  id: Scalars['ID']['output'];
  inCart?: Maybe<Scalars['Int']['output']>;
  prices?: Maybe<Array<LinkVariantPrice>>;
  productVariant: ProductVariant;
  stockAllocated?: Maybe<Scalars['Int']['output']>;
};

export type LinkVariantPrice = {
  __typename?: 'LinkVariantPrice';
  beforeTax?: Maybe<Scalars['Float']['output']>;
  country: Country;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customServiceFee?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  linkVariant: LinkVariant;
  linkVariantId: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type LocaleStringCustomFieldConfig = CustomField & {
  __typename?: 'LocaleStringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocaleTextCustomFieldConfig = CustomField & {
  __typename?: 'LocaleTextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  languageCode: LanguageCode;
  value: Scalars['String']['output'];
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type ManualPaymentInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Returned when a call to addManualPaymentToOrder is made but the Order
 * is not in the required state.
 */
export type ManualPaymentStateError = ErrorResult & {
  __typename?: 'ManualPaymentStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export enum MemberStatus {
  Active = 'Active',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum MetricInterval {
  Daily = 'Daily'
}

export type MetricSummary = {
  __typename?: 'MetricSummary';
  entries: Array<MetricSummaryEntry>;
  interval: MetricInterval;
  title: Scalars['String']['output'];
  type: MetricType;
};

export type MetricSummaryEntry = {
  __typename?: 'MetricSummaryEntry';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MetricSummaryInput = {
  interval: MetricInterval;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<MetricType>;
};

export enum MetricType {
  AverageOrderValue = 'AverageOrderValue',
  OrderCount = 'OrderCount',
  OrderTotal = 'OrderTotal'
}

export type MimeTypeError = ErrorResult & {
  __typename?: 'MimeTypeError';
  errorCode: ErrorCode;
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/** Returned if a PromotionCondition has neither a couponCode nor any conditions set */
export type MissingConditionsError = ErrorResult & {
  __typename?: 'MissingConditionsError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ModifyOrderInput = {
  addItems?: InputMaybe<Array<AddItemInput>>;
  adjustOrderLines?: InputMaybe<Array<OrderLineInput>>;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
  dryRun: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ModifyOrderOptions>;
  orderId: Scalars['ID']['input'];
  /**
   * Deprecated in v2.2.0. Use `refunds` instead to allow multiple refunds to be
   * applied in the case that multiple payment methods have been used on the order.
   */
  refund?: InputMaybe<AdministratorRefundInput>;
  refunds?: InputMaybe<Array<AdministratorRefundInput>>;
  /** Added in v2.2 */
  shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  surcharges?: InputMaybe<Array<SurchargeInput>>;
  updateBillingAddress?: InputMaybe<UpdateOrderAddressInput>;
  updateShippingAddress?: InputMaybe<UpdateOrderAddressInput>;
};

export type ModifyOrderOptions = {
  freezePromotions?: InputMaybe<Scalars['Boolean']['input']>;
  recalculateShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifyOrderResult = CouponCodeExpiredError | CouponCodeInvalidError | CouponCodeLimitError | IneligibleShippingMethodError | InsufficientStockError | NegativeQuantityError | NoChangesSpecifiedError | Order | OrderLimitError | OrderModificationStateError | PaymentMethodMissingError | RefundPaymentIdMissingError;

export type MoveCollectionInput = {
  collectionId: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  parentId: Scalars['ID']['input'];
};

/** Returned if an operation has specified OrderLines from multiple Orders */
export type MultipleOrderError = ErrorResult & {
  __typename?: 'MultipleOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCountryToShippingMethod: ShippingMethod;
  addCustomerToEvent?: Maybe<EventApplicant>;
  /** Add Customers to a CustomerGroup */
  addCustomersToGroup: CustomerGroup;
  addCustomsClearanceFiles: CustomsClearance;
  addExchangeRate: PriceExchangeRate;
  addFulfillmentToOrder: AddFulfillmentToOrderResult;
  /** Adds an item to the draft Order. */
  addItemToDraftOrder: UpdateOrderItemsResult;
  /**
   * Used to manually create a new Payment against an Order.
   * This can be used by an Administrator when an Order is in the ArrangingPayment state.
   *
   * It is also used when a completed Order
   * has been modified (using `modifyOrder`) and the price has increased. The extra payment
   * can then be manually arranged by the administrator, and the details used to create a new
   * Payment.
   */
  addManualPaymentToOrder: AddManualPaymentToOrderResult;
  /** Add members to a Zone */
  addMembersToZone: Zone;
  addNoteToCustomer: Customer;
  addNoteToOrder: Order;
  /** Add an OptionGroup to a Product */
  addOptionGroupToProduct: Product;
  /** Adjusts a draft OrderLine. If custom fields are defined on the OrderLine entity, a third argument 'customFields' of type `OrderLineCustomFieldsInput` will be available. */
  adjustDraftOrderLine: UpdateOrderItemsResult;
  allocatePackageStock: Array<PackageLine>;
  announceWinnerEvent: FanClubEvent;
  /** Applies the given coupon code to the draft Order */
  applyCouponCodeToDraftOrder: ApplyCouponCodeResult;
  approveAuditRequest: Scalars['Boolean']['output'];
  approveCancelEvent: Scalars['Boolean']['output'];
  approveEvent: Scalars['Boolean']['output'];
  approveJoinApplication: FanClubMember;
  approveLink: FanClubLink;
  approveProduct: Scalars['Boolean']['output'];
  approvePurchaseNeeded?: Maybe<Scalars['JSON']['output']>;
  approvefanClubEditRequest: FanClubEditRequest;
  /** Assign assets to channel */
  assignAssetsToChannel: Array<Asset>;
  /** Assigns Collections to the specified Channel */
  assignCollectionsToChannel: Array<Collection>;
  /** Assigns Facets to the specified Channel */
  assignFacetsToChannel: Array<Facet>;
  /** Assigns PaymentMethods to the specified Channel */
  assignPaymentMethodsToChannel: Array<PaymentMethod>;
  /** Assigns ProductVariants to the specified Channel */
  assignProductVariantsToChannel: Array<ProductVariant>;
  /** Assigns all ProductVariants of Product to the specified Channel */
  assignProductsToChannel: Array<Product>;
  /** Assigns Promotions to the specified Channel */
  assignPromotionsToChannel: Array<Promotion>;
  /** Assign a Role to an Administrator */
  assignRoleToAdministrator: Administrator;
  /** Assigns ShippingMethods to the specified Channel */
  assignShippingMethodsToChannel: Array<ShippingMethod>;
  /** Assigns StockLocations to the specified Channel */
  assignStockLocationsToChannel: Array<StockLocation>;
  /** Authenticates the user using a named authentication strategy */
  authenticate: AuthenticationResult;
  bulkUpdateBeforeTax: Scalars['Boolean']['output'];
  bulkUpdatePackageReview?: Maybe<Array<PackageReview>>;
  bulkUpdateRulePackageReview?: Maybe<Array<PackageReview>>;
  cancelJob: Job;
  cancelOrder: CancelOrderResult;
  cancelPayment: CancelPaymentResult;
  changeCustomsClearanceState: CustomsClearance;
  checkBulkUpdate?: Maybe<Array<Maybe<AffectedOrder>>>;
  checkBulkUpdateRule?: Maybe<Array<Maybe<AffectedOrder>>>;
  closeEvent: FanClubEvent;
  commentQuestionPost: QuestionPostComment;
  completeInbounds: Array<Inbounding>;
  confirmInbounds: Array<Inbounding>;
  confirmWinners: Scalars['Int']['output'];
  /** Create a new Administrator */
  createAdministrator: Administrator;
  createAlert: Alert;
  createArtist: Artist;
  /** Create a new Asset */
  createAssets: Array<CreateAssetResult>;
  createBanner: Banner;
  /** Create a new Channel */
  createChannel: CreateChannelResult;
  createCheckBox: ConfirmationCheckbox;
  /** Create a new Collection */
  createCollection: Collection;
  createCooperateAccount: CreateCustomerResult;
  /** Create a new Country */
  createCountry: Country;
  /** Create a new Customer. If a password is provided, a new User will also be created an linked to the Customer. */
  createCustomer: CreateCustomerResult;
  /** Create a new Address and associate it with the Customer specified by customerId */
  createCustomerAddress: Address;
  createCustomerCountry: CustomerCountry;
  /** Create a new CustomerGroup */
  createCustomerGroup: CustomerGroup;
  createDefaultEventConsentContent?: Maybe<DefaultEventConsentContent>;
  createDefaultEventConsentContentTranslation?: Maybe<DefaultEventConsentContentTranslation>;
  createDefaultProductDescription: DefaultProductDescription;
  createDefaultProductDescriptionTranslation: DefaultProductDescriptionTranslation;
  createDefaultProductInformation: DefaultProductInformation;
  /** Creates a draft Order */
  createDraftOrder: Order;
  createEmailTemplate: EmailTemplate;
  createEmailTemplateTranslation: EmailTemplateTranslation;
  createEvent: FanClubEvent;
  /** Create a new Facet */
  createFacet: Facet;
  /** Create one or more FacetValues */
  createFacetValues: Array<FacetValue>;
  createFanClub: FanClub;
  createFanClubGroup: FanClubGroup;
  createFanClubLink: FanClubLink;
  createFanClubLinkMission: FanClubLinkMission;
  createFanClubPointHistory: FanClubPointHistory;
  createFreeGiftCondition: FreeGiftCondition;
  createFreeGiftSelection: FreeGiftSelection;
  createGuidance?: Maybe<Guidance>;
  createInboundApprove: InboundApprove;
  createInboundApproveRequest: InboundApproveRequest;
  createLinkVariantPrice: LinkVariantPrice;
  createNotice: Notice;
  createOrUpdateFanClubGroup: FanClubGroup;
  createOrUpdateFreeGiftSelection: FreeGiftSelection;
  createPackage: Package;
  createPackageReview: PackageReview;
  createPackageReviewFromOrder?: Maybe<Scalars['Boolean']['output']>;
  createPackageReviewFromProduct?: Maybe<Scalars['Int']['output']>;
  createPackageReviewOrderLine: PackageReviewOrderLine;
  createPackagesFromOrders: Array<Package>;
  /** Create existing PaymentMethod */
  createPaymentMethod: PaymentMethod;
  /** Create a new Product */
  createProduct: Product;
  /** Create a new ProductOption within a ProductOptionGroup */
  createProductOption: ProductOption;
  /** Create a new ProductOptionGroup */
  createProductOptionGroup: ProductOptionGroup;
  createProductSpecification: ProductSpecification;
  createProductType: ProductType;
  /** Create a set of ProductVariants based on the OptionGroups assigned to the given Product */
  createProductVariants: Array<Maybe<ProductVariant>>;
  createPromotion: CreatePromotionResult;
  /** Create a new Province */
  createProvince: Province;
  createPurchase: Scalars['JSON']['output'];
  createPurchaseRequestCronjob?: Maybe<PurchaseRequestCronjob>;
  createPushTemplate: PushTemplate;
  createQuestionPost: QuestionPost;
  createRefundRequest: RefundRequest;
  createRequestManual: RequestPurchaseGroup;
  createRetail: Retail;
  /** Create a new Role */
  createRole: Role;
  /** Create a new Seller */
  createSeller: Seller;
  createServiceFee: ServiceFee;
  createShipping: Shipping;
  createShippingFee: ShippingFee;
  createShippingFeeCountry: ShippingFeeCountry;
  createShippingFeeType: Scalars['ID']['output'];
  /** Create a new ShippingMethod */
  createShippingMethod: ShippingMethod;
  createShopSupplier: ShopSupplier;
  createSmsTemplate: SmsTemplate;
  createSplitOrderRule: SplitOrderRule;
  createStaticPage: StaticPage;
  createStaticPageClassification: StaticPageClassification;
  createStockLocation: StockLocation;
  createSupplier: Scalars['JSON']['output'];
  /** Create a new Tag */
  createTag: Tag;
  /** Create a new TaxCategory */
  createTaxCategory: TaxCategory;
  /** Create a new TaxRate */
  createTaxRate: TaxRate;
  createTicket: Ticket;
  createTicketComment?: Maybe<TicketComment>;
  createUserLevel: UserLevel;
  createWarehouse: Warehouse;
  /** Create a new Zone */
  createZone: Zone;
  createandstockin: Scalars['JSON']['output'];
  /** Delete an Administrator */
  deleteAdministrator: DeletionResponse;
  /** Delete multiple Administrators */
  deleteAdministrators: Array<DeletionResponse>;
  deleteAlert: DeletionResponse;
  deleteArtist: DeletionResponse;
  /** Delete an Asset */
  deleteAsset: DeletionResponse;
  /** Delete multiple Assets */
  deleteAssets: DeletionResponse;
  deleteAvailableCountry: DeletionResponse;
  deleteBanner: DeletionResponse;
  /** Delete a Channel */
  deleteChannel: DeletionResponse;
  /** Delete multiple Channels */
  deleteChannels: Array<DeletionResponse>;
  deleteCheckbox: DeletionResponse;
  /** Delete a Collection and all of its descendants */
  deleteCollection: DeletionResponse;
  /** Delete multiple Collections and all of their descendants */
  deleteCollections: Array<DeletionResponse>;
  deleteComment?: Maybe<DeletionResponse>;
  /** Delete multiple Countries */
  deleteCountries: Array<DeletionResponse>;
  /** Delete a Country */
  deleteCountry: DeletionResponse;
  /** Delete a Customer */
  deleteCustomer: DeletionResponse;
  /** Update an existing Address */
  deleteCustomerAddress: Success;
  /** Delete a CustomerGroup */
  deleteCustomerGroup: DeletionResponse;
  /** Delete multiple CustomerGroups */
  deleteCustomerGroups: Array<DeletionResponse>;
  deleteCustomerNote: DeletionResponse;
  /** Deletes Customers */
  deleteCustomers: Array<DeletionResponse>;
  deleteDefaultEventConsentContent?: Maybe<DeletionResponse>;
  deleteDefaultEventConsentContentTranslation?: Maybe<DeletionResponse>;
  deleteDefaultProductDescription: DeletionResponse;
  deleteDefaultProductDescriptionTranslation: DeletionResponse;
  deleteDefaultProductInformation: DeletionResponse;
  /** Deletes a draft Order */
  deleteDraftOrder: DeletionResponse;
  deleteEvent: DeletionResponse;
  deleteEventIdol: DeletionResponse;
  /** Delete an existing Facet */
  deleteFacet: DeletionResponse;
  /** Delete one or more FacetValues */
  deleteFacetValues: Array<DeletionResponse>;
  /** Delete multiple existing Facets */
  deleteFacets: Array<DeletionResponse>;
  deleteFanClub: DeletionResponse;
  deleteFanClubLink: DeletionResponse;
  deleteFanClubLinkMission: Scalars['JSON']['output'];
  deleteFanClubMember: DeletionResponse;
  deleteFreeGiftCondition: DeletionResponse;
  deleteFreeGiftSelection: DeletionResponse;
  deleteInboundApprove: DeletionResult;
  deleteNotice: DeletionResponse;
  deleteOrderNote: DeletionResponse;
  deletePackageReview: DeletionResult;
  deletePackageReviewOrderLine: DeletionResponse;
  /** Delete a PaymentMethod */
  deletePaymentMethod: DeletionResponse;
  /** Delete multiple PaymentMethods */
  deletePaymentMethods: Array<DeletionResponse>;
  /** Delete a Product */
  deleteProduct: DeletionResponse;
  /** Delete a ProductOption */
  deleteProductOption: DeletionResponse;
  deleteProductSpecification: DeletionResponse;
  deleteProductType: DeletionResponse;
  /** Delete a ProductVariant */
  deleteProductVariant: DeletionResponse;
  /** Delete multiple ProductVariants */
  deleteProductVariants: Array<DeletionResponse>;
  /** Delete multiple Products */
  deleteProducts: Array<DeletionResponse>;
  deletePromotion: DeletionResponse;
  deletePromotions: Array<DeletionResponse>;
  /** Delete a Province */
  deleteProvince: DeletionResponse;
  deletePurchaseRequestCronjob: DeletionResponse;
  deleteQuestionPost?: Maybe<DeletionResponse>;
  deleteRetail: DeletionResponse;
  deleteRetailerFile: DeletionResponse;
  /** Delete an existing Role */
  deleteRole: DeletionResponse;
  /** Delete multiple Roles */
  deleteRoles: Array<DeletionResponse>;
  /** Delete a Seller */
  deleteSeller: DeletionResponse;
  /** Delete multiple Sellers */
  deleteSellers: Array<DeletionResponse>;
  deleteServiceFee: DeletionResponse;
  deleteShippingFee: DeletionResponse;
  deleteShippingFeeCountry: DeletionResponse;
  deleteShippingFeeType: DeletionResponse;
  /** Delete a ShippingMethod */
  deleteShippingMethod: DeletionResponse;
  /** Delete multiple ShippingMethods */
  deleteShippingMethods: Array<DeletionResponse>;
  deleteShopSupplier: DeletionResponse;
  deleteShopSupplierFile: DeletionResponse;
  deleteStaticPage: DeletionResponse;
  deleteStaticPageClassification: DeletionResponse;
  deleteStockLocation: DeletionResponse;
  deleteStockLocations: Array<DeletionResponse>;
  /** Delete an existing Tag */
  deleteTag: DeletionResponse;
  /** Deletes multiple TaxCategories */
  deleteTaxCategories: Array<DeletionResponse>;
  /** Deletes a TaxCategory */
  deleteTaxCategory: DeletionResponse;
  /** Delete a TaxRate */
  deleteTaxRate: DeletionResponse;
  /** Delete multiple TaxRates */
  deleteTaxRates: Array<DeletionResponse>;
  deleteTicket?: Maybe<DeletionResponse>;
  deleteTicketComment?: Maybe<DeletionResponse>;
  deleteUserLevel: DeletionResponse;
  deleteUserLevelOrderQuan: DeletionResponse;
  /** Delete a Zone */
  deleteZone: DeletionResponse;
  /** Delete a Zone */
  deleteZones: Array<DeletionResponse>;
  /**
   * Duplicate an existing entity using a specific EntityDuplicator.
   * Since v2.2.0.
   */
  duplicateEntity: DuplicateEntityResult;
  duplicateTo?: Maybe<DefaultProductInformation>;
  flushBufferedJobs: Success;
  generatePrices?: Maybe<PriceGenerateResult>;
  getAlbumRank?: Maybe<AlbumRank>;
  importProducts?: Maybe<ImportInfo>;
  importShippingFeeFile: Scalars['Int']['output'];
  inProgressInbounds: Array<Inbounding>;
  linkCustomerCountry?: Maybe<Customer>;
  /**
   * Authenticates the user using the native authentication strategy. This mutation is an alias for authenticate({ native: { ... }})
   *
   * The `rememberMe` option applies when using cookie-based sessions, and if `true` it will set the maxAge of the session cookie
   * to 1 year.
   */
  login: NativeAuthenticationResult;
  logout: Success;
  manualCheckLinkStatus?: Maybe<ResultManualCheckLinkStatus>;
  /**
   * Allows an Order to be modified after it has been completed by the Customer. The Order must first
   * be in the `Modifying` state.
   */
  modifyOrder: ModifyOrderResult;
  /** Move a Collection to a different parent or index */
  moveCollection: Collection;
  myCoupons: PromotionList;
  myUsedCoupons: PromotionList;
  performSplitOrder: Job;
  pickWinner: EventApplicant;
  pickWinners: Array<EventApplicant>;
  postPushNotification: PushNotification;
  randomBanner?: Maybe<Banner>;
  randomizeWinner: Array<EventApplicant>;
  refundOrder: RefundOrderResult;
  reindex: Job;
  reindexProductAdvancedList?: Maybe<Job>;
  /** Removes Collections from the specified Channel */
  removeCollectionsFromChannel: Array<Collection>;
  /** Removes the given coupon code from the draft Order */
  removeCouponCodeFromDraftOrder?: Maybe<Order>;
  /** Remove Customers from a CustomerGroup */
  removeCustomersFromGroup: CustomerGroup;
  removeCustomsClearanceFile: CustomsClearance;
  /** Remove an OrderLine from the draft Order */
  removeDraftOrderLine: RemoveOrderItemsResult;
  /** Removes Facets from the specified Channel */
  removeFacetsFromChannel: Array<RemoveFacetFromChannelResult>;
  removeFromFanClubGroup: FanClubGroup;
  /** Remove members from a Zone */
  removeMembersFromZone: Zone;
  /**
   * Remove an OptionGroup from a Product. If the OptionGroup is in use by any ProductVariants
   * the mutation will return a ProductOptionInUseError, and the OptionGroup will not be removed.
   * Setting the `force` argument to `true` will override this and remove the OptionGroup anyway,
   * as well as removing any of the group's options from the Product's ProductVariants.
   */
  removeOptionGroupFromProduct: RemoveOptionGroupFromProductResult;
  /** Removes PaymentMethods from the specified Channel */
  removePaymentMethodsFromChannel: Array<PaymentMethod>;
  /** Removes ProductVariants from the specified Channel */
  removeProductVariantsFromChannel: Array<ProductVariant>;
  /** Removes all ProductVariants of Product from the specified Channel */
  removeProductsFromChannel: Array<Product>;
  /** Removes Promotions from the specified Channel */
  removePromotionsFromChannel: Array<Promotion>;
  /** Remove all settled jobs in the given queues older than the given date. Returns the number of jobs deleted. */
  removeSettledJobs: Scalars['Int']['output'];
  /** Removes ShippingMethods from the specified Channel */
  removeShippingMethodsFromChannel: Array<ShippingMethod>;
  /** Removes StockLocations from the specified Channel */
  removeStockLocationsFromChannel: Array<StockLocation>;
  removeSupplierFile: DeletionResponse;
  removeWinner: EventApplicant;
  requestCancelEvent: Scalars['Boolean']['output'];
  requestContinueLink: Scalars['Boolean']['output'];
  requestCustomsClearance: Order;
  requestDeleteEvent: DeletionResponse;
  requestDeleteLink: Scalars['Boolean']['output'];
  requestDeleteProducts: Scalars['Int']['output'];
  requestForceStopLink: Scalars['Boolean']['output'];
  requestMultiplePurchaseNeeded: Scalars['Int']['output'];
  requestPurchaseNeeded: RequestPurchase;
  requestShipmentPackages: Scalars['Int']['output'];
  requestUpdateEvent?: Maybe<Scalars['Boolean']['output']>;
  requestUpdateProduct?: Maybe<Scalars['Boolean']['output']>;
  requestUpdateProductVariant?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatingDateLink: Scalars['Boolean']['output'];
  rerollGift: OrderLine;
  resetPasswordByPhoneNumber: Scalars['Boolean']['output'];
  restoreComment: QuestionPostComment;
  restoreQuestionPost: QuestionPost;
  runPendingSearchIndexUpdates: Success;
  sendVerificationCode: Scalars['String']['output'];
  setCustomerForDraftOrder: SetCustomerForDraftOrderResult;
  /** Sets the billing address for a draft Order */
  setDraftOrderBillingAddress: Order;
  /** Allows any custom fields to be set for the active order */
  setDraftOrderCustomFields: Order;
  /** Sets the shipping address for a draft Order */
  setDraftOrderShippingAddress: Order;
  /** Sets the shipping method by id, which can be obtained with the `eligibleShippingMethodsForDraftOrder` query */
  setDraftOrderShippingMethod: SetOrderShippingMethodResult;
  setOrderCustomFields?: Maybe<Order>;
  /** Allows a different Customer to be assigned to an Order. Added in v2.2.0. */
  setOrderCustomer?: Maybe<Order>;
  setRequestCompleted?: Maybe<Scalars['JSON']['output']>;
  setWaitForApproval?: Maybe<Scalars['JSON']['output']>;
  settlePayment: SettlePaymentResult;
  settleRefund: SettleRefundResult;
  splitOrderPackageReviews?: Maybe<Array<Maybe<PackageReview>>>;
  syncAllProductVariantCustomServiceFee?: Maybe<Scalars['Int']['output']>;
  syncTaxForDefaultCountry: Scalars['Boolean']['output'];
  testUploadChinaFile?: Maybe<Scalars['JSON']['output']>;
  transitionFulfillmentToState: TransitionFulfillmentToStateResult;
  transitionOrderToState?: Maybe<TransitionOrderToStateResult>;
  transitionPaymentToState: TransitionPaymentToStateResult;
  /** Update the active (currently logged-in) Administrator */
  updateActiveAdministrator: Administrator;
  /** Update an existing Administrator */
  updateAdministrator: Administrator;
  updateAlert: Alert;
  updateArtist: Artist;
  /** Update an existing Asset */
  updateAsset: Asset;
  updateAvailableCountryProduct?: Maybe<Array<AvailableCountryShipping>>;
  updateBanner: Banner;
  /** Update an existing Channel */
  updateChannel: UpdateChannelResult;
  /** Update an existing Collection */
  updateCollection: Collection;
  updateCooperateUser: CooperateUser;
  /** Update an existing Country */
  updateCountry: Country;
  /** Update an existing Customer */
  updateCustomer: UpdateCustomerResult;
  /** Update an existing Address */
  updateCustomerAddress: Address;
  updateCustomerCountry?: Maybe<CustomerCountry>;
  /** Update an existing CustomerGroup */
  updateCustomerGroup: CustomerGroup;
  updateCustomerNote: HistoryEntry;
  updateDefaultEventConsentContent?: Maybe<DefaultEventConsentContent>;
  updateDefaultEventConsentContentTranslation?: Maybe<DefaultEventConsentContentTranslation>;
  updateDefaultProductDescription: DefaultProductDescription;
  updateDefaultProductDescriptionTranslation: DefaultProductDescriptionTranslation;
  updateDefaultProductInformation: DefaultProductInformation;
  updateDefaultTaxRatePrice?: Maybe<TaxRatePriceUpdateResult>;
  updateEmailTemplateTranslation: EmailTemplateTranslation;
  updateEvent: FanClubEvent;
  updateExchangeRate: PriceExchangeRate;
  /** Update an existing Facet */
  updateFacet: Facet;
  /** Update one or more FacetValues */
  updateFacetValues: Array<FacetValue>;
  updateFanClub: FanClub;
  updateFanClubGroup: FanClubGroup;
  updateFanClubLink: FanClubLink;
  updateFanClubLinkMission: FanClubLinkMission;
  updateFanClubMember: FanClubMember;
  updateFreeGiftCondition: FreeGiftCondition;
  updateFreeGiftSelection: FreeGiftSelection;
  updateGlobalSettings: UpdateGlobalSettingsResult;
  updateGoods: Scalars['JSON']['output'];
  updateGuidance?: Maybe<Guidance>;
  updateInboundApproveRequest: InboundApproveRequest;
  updateLinkVariantPrice: LinkVariantPrice;
  updateNotice: Notice;
  updateOrderNote: HistoryEntry;
  updatePackage: Package;
  updatePackageReview: PackageReview;
  updatePackageReviewOrderLine: PackageReviewOrderLine;
  updatePackageReviewSplitRule: SplitOrder;
  /** Update an existing PaymentMethod */
  updatePaymentMethod: PaymentMethod;
  /** Update an existing Product */
  updateProduct: Product;
  /** Create a new ProductOption within a ProductOptionGroup */
  updateProductOption: ProductOption;
  /** Update an existing ProductOptionGroup */
  updateProductOptionGroup: ProductOptionGroup;
  updateProductSpecification: ProductSpecification;
  updateProductType: ProductType;
  /** Update existing ProductVariants */
  updateProductVariants: Array<Maybe<ProductVariant>>;
  /** Update multiple existing Products */
  updateProducts: Array<Product>;
  updatePromotion: UpdatePromotionResult;
  /** Update an existing Province */
  updateProvince: Province;
  updatePurchaseRequestCronjob?: Maybe<PurchaseRequestCronjob>;
  updatePushTemplate: PushTemplate;
  updateQuestionPost: QuestionPost;
  updateQuestionPostComment: QuestionPostComment;
  updateRefundRequest: RefundRequest;
  updateRequestPurchase: Array<RequestPurchase>;
  updateRetail: Retail;
  /** Update an existing Role */
  updateRole: Role;
  /** Update an existing Seller */
  updateSeller: Seller;
  updateServiceFee: ServiceFee;
  updateShippables?: Maybe<Scalars['JSON']['output']>;
  updateShipping: Shipping;
  updateShippingFee: ShippingFee;
  updateShippingFeeCountry: ShippingFeeCountry;
  updateShippingFeeType: Scalars['ID']['output'];
  /** Update an existing ShippingMethod */
  updateShippingMethod: ShippingMethod;
  updateShopSupplier: ShopSupplier;
  updateSplitOrderRule: SplitOrderRule;
  updateStaticPage: StaticPage;
  updateStaticPageClassification: StaticPageClassification;
  updateStockLocation: StockLocation;
  updateSupplier: Scalars['JSON']['output'];
  /** Update an existing Tag */
  updateTag: Tag;
  /** Update an existing TaxCategory */
  updateTaxCategory: TaxCategory;
  /** Update an existing TaxRate */
  updateTaxRate: TaxRate;
  updateTicket: Ticket;
  updateTicketComment?: Maybe<TicketComment>;
  updateUserLevel: UserLevel;
  /** Update an existing Zone */
  updateZone: Zone;
  upsertAlbumRank?: Maybe<AlbumRank>;
  verifyCode: Scalars['String']['output'];
};


export type MutationAddCountryToShippingMethodArgs = {
  input: AddCountryToShippingMethodInput;
};


export type MutationAddCustomerToEventArgs = {
  input: AddCustomerToEventInput;
};


export type MutationAddCustomersToGroupArgs = {
  customerGroupId: Scalars['ID']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type MutationAddCustomsClearanceFilesArgs = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationAddExchangeRateArgs = {
  input: CreateExchangeRateInput;
};


export type MutationAddFulfillmentToOrderArgs = {
  input: FulfillOrderInput;
};


export type MutationAddItemToDraftOrderArgs = {
  input: AddItemToDraftOrderInput;
  orderId: Scalars['ID']['input'];
};


export type MutationAddManualPaymentToOrderArgs = {
  input: ManualPaymentInput;
};


export type MutationAddMembersToZoneArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type MutationAddNoteToCustomerArgs = {
  input: AddNoteToCustomerInput;
};


export type MutationAddNoteToOrderArgs = {
  input: AddNoteToOrderInput;
};


export type MutationAddOptionGroupToProductArgs = {
  optionGroupId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAdjustDraftOrderLineArgs = {
  input: AdjustDraftOrderLineInput;
  orderId: Scalars['ID']['input'];
};


export type MutationAnnounceWinnerEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplyCouponCodeToDraftOrderArgs = {
  couponCode: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationApproveAuditRequestArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
};


export type MutationApproveCancelEventArgs = {
  id: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
};


export type MutationApproveEventArgs = {
  id: Scalars['ID']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationApproveJoinApplicationArgs = {
  isApprove: Scalars['Boolean']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationApproveLinkArgs = {
  id: Scalars['ID']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationApproveProductArgs = {
  id: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
};


export type MutationApprovePurchaseNeededArgs = {
  input: Array<ApprovePurchaseNeededGroupInput>;
  isApproved: Scalars['Boolean']['input'];
};


export type MutationApprovefanClubEditRequestArgs = {
  id: Scalars['ID']['input'];
  isApproved: Scalars['Boolean']['input'];
};


export type MutationAssignAssetsToChannelArgs = {
  input: AssignAssetsToChannelInput;
};


export type MutationAssignCollectionsToChannelArgs = {
  input: AssignCollectionsToChannelInput;
};


export type MutationAssignFacetsToChannelArgs = {
  input: AssignFacetsToChannelInput;
};


export type MutationAssignPaymentMethodsToChannelArgs = {
  input: AssignPaymentMethodsToChannelInput;
};


export type MutationAssignProductVariantsToChannelArgs = {
  input: AssignProductVariantsToChannelInput;
};


export type MutationAssignProductsToChannelArgs = {
  input: AssignProductsToChannelInput;
};


export type MutationAssignPromotionsToChannelArgs = {
  input: AssignPromotionsToChannelInput;
};


export type MutationAssignRoleToAdministratorArgs = {
  administratorId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationAssignShippingMethodsToChannelArgs = {
  input: AssignShippingMethodsToChannelInput;
};


export type MutationAssignStockLocationsToChannelArgs = {
  input: AssignStockLocationsToChannelInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkUpdateBeforeTaxArgs = {
  data: BulkVariantPriceData;
};


export type MutationBulkUpdatePackageReviewArgs = {
  input: BulkUpdatePackageReviewInput;
};


export type MutationBulkUpdateRulePackageReviewArgs = {
  input: BulkUpdateRulePackageReviewInput;
};


export type MutationCancelJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeCustomsClearanceStateArgs = {
  id: Scalars['ID']['input'];
  nextState: Scalars['String']['input'];
};


export type MutationCheckBulkUpdateArgs = {
  input: BulkUpdatePackageReviewInput;
};


export type MutationCheckBulkUpdateRuleArgs = {
  input: BulkUpdateRulePackageReviewInput;
};


export type MutationCloseEventArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationCommentQuestionPostArgs = {
  input: CreateQuestionPostComment;
};


export type MutationCompleteInboundsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationConfirmInboundsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationConfirmWinnersArgs = {
  input: ConfirmWinnerInput;
};


export type MutationCreateAdministratorArgs = {
  input: CreateAdministratorInput;
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateArtistArgs = {
  input: CreateArtistInput;
};


export type MutationCreateAssetsArgs = {
  input: Array<CreateAssetInput>;
};


export type MutationCreateBannerArgs = {
  input: CreateBannerInput;
};


export type MutationCreateChannelArgs = {
  input: CreateChannelInput;
};


export type MutationCreateCheckBoxArgs = {
  label: Scalars['String']['input'];
  linkId: Scalars['ID']['input'];
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCooperateAccountArgs = {
  input: RegisterCooperateInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerAddressArgs = {
  customerId: Scalars['ID']['input'];
  input: CreateAddressInput;
};


export type MutationCreateCustomerCountryArgs = {
  countryId: Scalars['ID']['input'];
};


export type MutationCreateCustomerGroupArgs = {
  input: CreateCustomerGroupInput;
};


export type MutationCreateDefaultEventConsentContentArgs = {
  input: CreateDefaultEventConsentContent;
};


export type MutationCreateDefaultEventConsentContentTranslationArgs = {
  input: CreateDefaultEventConsentContentTranslationInput;
};


export type MutationCreateDefaultProductDescriptionArgs = {
  input: CreateDefaultProductDescriptionInput;
};


export type MutationCreateDefaultProductDescriptionTranslationArgs = {
  input: CreateDefaultProductDescriptionTranslationInput;
};


export type MutationCreateDefaultProductInformationArgs = {
  input: CreateDefaultProductInformationInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};


export type MutationCreateEmailTemplateTranslationArgs = {
  input: CreateEmailTemplateTranslationInput;
};


export type MutationCreateEventArgs = {
  input: CreateFanClubEventInput;
};


export type MutationCreateFacetArgs = {
  input: CreateFacetInput;
};


export type MutationCreateFacetValuesArgs = {
  input: Array<CreateFacetValueInput>;
};


export type MutationCreateFanClubArgs = {
  input: CreateFanClubInput;
};


export type MutationCreateFanClubGroupArgs = {
  input: CreateFanClubGroupInput;
};


export type MutationCreateFanClubLinkArgs = {
  input: CreateFanClubLinkInput;
};


export type MutationCreateFanClubLinkMissionArgs = {
  input?: InputMaybe<CreateFanClubLinkMissionInput>;
};


export type MutationCreateFanClubPointHistoryArgs = {
  input?: InputMaybe<CreateFanClubPointHistoryInput>;
};


export type MutationCreateFreeGiftConditionArgs = {
  input: CreateFreeGiftConditionInput;
};


export type MutationCreateFreeGiftSelectionArgs = {
  input: CreateFreeGiftInput;
};


export type MutationCreateGuidanceArgs = {
  input: CreateGuidanceInput;
};


export type MutationCreateInboundApproveArgs = {
  input?: InputMaybe<CreateInboundApproveInput>;
};


export type MutationCreateInboundApproveRequestArgs = {
  input: CreateInboundApproveRequestInput;
};


export type MutationCreateLinkVariantPriceArgs = {
  input?: InputMaybe<CreateLinkVariantPriceInput>;
};


export type MutationCreateNoticeArgs = {
  input: CreateNoticeInput;
};


export type MutationCreateOrUpdateFanClubGroupArgs = {
  input: CreateFanClubGroupInput;
};


export type MutationCreateOrUpdateFreeGiftSelectionArgs = {
  input: CreateVariantFreeGiftInput;
};


export type MutationCreatePackageArgs = {
  input: CreatePackageInput;
};


export type MutationCreatePackageReviewArgs = {
  input: CreatePackageReviewInput;
};


export type MutationCreatePackageReviewFromOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreatePackageReviewFromProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreatePackageReviewOrderLineArgs = {
  input?: InputMaybe<CreatePackageReviewOrderLineInput>;
};


export type MutationCreatePackagesFromOrdersArgs = {
  orderIds: Array<Scalars['ID']['input']>;
};


export type MutationCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductOptionArgs = {
  input: CreateProductOptionInput;
};


export type MutationCreateProductOptionGroupArgs = {
  input: CreateProductOptionGroupInput;
};


export type MutationCreateProductSpecificationArgs = {
  input: CreateProductSpecificationInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreateProductVariantsArgs = {
  input: Array<CreateProductVariantInput>;
};


export type MutationCreatePromotionArgs = {
  input: CreatePromotionInput;
};


export type MutationCreateProvinceArgs = {
  input: CreateProvinceInput;
};


export type MutationCreatePurchaseArgs = {
  input?: InputMaybe<CreatePurchaseInput>;
};


export type MutationCreatePurchaseRequestCronjobArgs = {
  input: CreatePurchaseRequestCronjobInput;
};


export type MutationCreatePushTemplateArgs = {
  input: CreatePushTemplateInput;
};


export type MutationCreateQuestionPostArgs = {
  input: CreateQuestionPostInput;
};


export type MutationCreateRefundRequestArgs = {
  input: CreateRefundRequestAdminInput;
};


export type MutationCreateRequestManualArgs = {
  input: CreateRequestPurchaseNeededGroupInput;
};


export type MutationCreateRetailArgs = {
  input: CreateRetailInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSellerArgs = {
  input: CreateSellerInput;
};


export type MutationCreateServiceFeeArgs = {
  input: CreateServiceFeeInput;
};


export type MutationCreateShippingArgs = {
  input: CreateShippingInput;
};


export type MutationCreateShippingFeeArgs = {
  input: CreateShippingFeeInput;
};


export type MutationCreateShippingFeeCountryArgs = {
  input: CreateShippingFeeCountryInput;
};


export type MutationCreateShippingFeeTypeArgs = {
  input: CreateShippingFeeTypeInput;
};


export type MutationCreateShippingMethodArgs = {
  input: CreateShippingMethodInput;
};


export type MutationCreateShopSupplierArgs = {
  input: CreateShopSupplier;
};


export type MutationCreateSmsTemplateArgs = {
  input: CreateSmsTemplate;
};


export type MutationCreateSplitOrderRuleArgs = {
  input: CreateSplitOrderRuleInput;
};


export type MutationCreateStaticPageArgs = {
  input: CreateStaticPageInput;
};


export type MutationCreateStaticPageClassificationArgs = {
  input: CreateStaticPageClassificationInput;
};


export type MutationCreateStockLocationArgs = {
  input: CreateStockLocationInput;
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTaxCategoryArgs = {
  input: CreateTaxCategoryInput;
};


export type MutationCreateTaxRateArgs = {
  input: CreateTaxRateInput;
};


export type MutationCreateTicketArgs = {
  input: CreateTicketInput;
};


export type MutationCreateTicketCommentArgs = {
  input: CreateTicketCommentInput;
};


export type MutationCreateUserLevelArgs = {
  input: CreateUserLevelInput;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseOneInput;
};


export type MutationCreateZoneArgs = {
  input: CreateZoneInput;
};


export type MutationCreateandstockinArgs = {
  options: Scalars['JSON']['input'];
};


export type MutationDeleteAdministratorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdministratorsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArtistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteAssetsArgs = {
  input: DeleteAssetsInput;
};


export type MutationDeleteAvailableCountryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCheckboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCountriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerGroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCustomerNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDefaultEventConsentContentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDefaultEventConsentContentTranslationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDefaultProductDescriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDefaultProductDescriptionTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDefaultProductInformationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDraftOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventIdolArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacetArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacetValuesArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFacetsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFanClubArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFanClubLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFanClubLinkMissionArgs = {
  input?: InputMaybe<DeleteFanClubLinkMissionInput>;
};


export type MutationDeleteFanClubMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFreeGiftConditionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFreeGiftSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInboundApproveArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrderNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePackageReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePackageReviewOrderLineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductSpecificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductVariantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductVariantsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePromotionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProvinceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseRequestCronjobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRetailerFileArgs = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRolesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteSellerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSellersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteServiceFeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingFeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingFeeCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingFeeTypeArgs = {
  id: Scalars['ID']['input'];
  type: ShippingFeeType;
};


export type MutationDeleteShippingMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingMethodsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteShopSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShopSupplierFileArgs = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaticPageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaticPageClassificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStockLocationArgs = {
  input: DeleteStockLocationInput;
};


export type MutationDeleteStockLocationsArgs = {
  input: Array<DeleteStockLocationInput>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTaxCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxRateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxRatesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTicketCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserLevelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserLevelOrderQuanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZonesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDuplicateEntityArgs = {
  input: DuplicateEntityInput;
};


export type MutationDuplicateToArgs = {
  specId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationFlushBufferedJobsArgs = {
  bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGeneratePricesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationImportProductsArgs = {
  csvFile: Scalars['Upload']['input'];
};


export type MutationImportShippingFeeFileArgs = {
  input: ImportFileInput;
};


export type MutationInProgressInboundsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationLinkCustomerCountryArgs = {
  allowOverride: Scalars['Boolean']['input'];
  countryId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};


export type MutationModifyOrderArgs = {
  input: ModifyOrderInput;
};


export type MutationMoveCollectionArgs = {
  input: MoveCollectionInput;
};


export type MutationMyCouponsArgs = {
  options?: InputMaybe<PromotionListOptions>;
};


export type MutationMyUsedCouponsArgs = {
  options?: InputMaybe<PromotionListOptions>;
};


export type MutationPickWinnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPickWinnersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPostPushNotificationArgs = {
  input: NotificationInput;
};


export type MutationRandomizeWinnerArgs = {
  input: RandomizeWinnerInput;
};


export type MutationRefundOrderArgs = {
  input: RefundOrderInput;
};


export type MutationRemoveCollectionsFromChannelArgs = {
  input: RemoveCollectionsFromChannelInput;
};


export type MutationRemoveCouponCodeFromDraftOrderArgs = {
  couponCode: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationRemoveCustomersFromGroupArgs = {
  customerGroupId: Scalars['ID']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveCustomsClearanceFileArgs = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRemoveDraftOrderLineArgs = {
  orderId: Scalars['ID']['input'];
  orderLineId: Scalars['ID']['input'];
};


export type MutationRemoveFacetsFromChannelArgs = {
  input: RemoveFacetsFromChannelInput;
};


export type MutationRemoveFromFanClubGroupArgs = {
  input: CreateFanClubGroupInput;
};


export type MutationRemoveMembersFromZoneArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type MutationRemoveOptionGroupFromProductArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  optionGroupId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodsFromChannelArgs = {
  input: RemovePaymentMethodsFromChannelInput;
};


export type MutationRemoveProductVariantsFromChannelArgs = {
  input: RemoveProductVariantsFromChannelInput;
};


export type MutationRemoveProductsFromChannelArgs = {
  input: RemoveProductsFromChannelInput;
};


export type MutationRemovePromotionsFromChannelArgs = {
  input: RemovePromotionsFromChannelInput;
};


export type MutationRemoveSettledJobsArgs = {
  olderThan?: InputMaybe<Scalars['DateTime']['input']>;
  queueNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRemoveShippingMethodsFromChannelArgs = {
  input: RemoveShippingMethodsFromChannelInput;
};


export type MutationRemoveStockLocationsFromChannelArgs = {
  input: RemoveStockLocationsFromChannelInput;
};


export type MutationRemoveSupplierFileArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRemoveWinnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestCancelEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestContinueLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestCustomsClearanceArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRequestDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestDeleteLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestDeleteProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRequestForceStopLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestMultiplePurchaseNeededArgs = {
  input: Array<RequestMultiplePurchaseNeededInput>;
};


export type MutationRequestPurchaseNeededArgs = {
  input: RequestPurchaseNeededInput;
};


export type MutationRequestShipmentPackagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRequestUpdateEventArgs = {
  input: UpdateFanClubEventInput;
};


export type MutationRequestUpdateProductArgs = {
  input: RequestUpdateProductInput;
};


export type MutationRequestUpdateProductVariantArgs = {
  input: RequestUpdateProductInput;
};


export type MutationRequestUpdatingDateLinkArgs = {
  input: UpdatingFanClubLinkDate;
};


export type MutationRerollGiftArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type MutationResetPasswordByPhoneNumberArgs = {
  input?: InputMaybe<ResetPasswordByPhoneNumberInput>;
};


export type MutationRestoreCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRestoreQuestionPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendVerificationCodeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSetCustomerForDraftOrderArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CreateCustomerInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderBillingAddressArgs = {
  input: CreateAddressInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderCustomFieldsArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderShippingAddressArgs = {
  input: CreateAddressInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderShippingMethodArgs = {
  orderId: Scalars['ID']['input'];
  shippingMethodId: Scalars['ID']['input'];
};


export type MutationSetOrderCustomFieldsArgs = {
  input: UpdateOrderInput;
};


export type MutationSetOrderCustomerArgs = {
  input: SetOrderCustomerInput;
};


export type MutationSetRequestCompletedArgs = {
  input: ChangeStatusInput;
};


export type MutationSetWaitForApprovalArgs = {
  input: ChangeStatusInput;
};


export type MutationSettlePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSettleRefundArgs = {
  input: SettleRefundInput;
};


export type MutationSplitOrderPackageReviewsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSyncAllProductVariantCustomServiceFeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestUploadChinaFileArgs = {
  url: Scalars['String']['input'];
};


export type MutationTransitionFulfillmentToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransitionOrderToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransitionPaymentToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationUpdateActiveAdministratorArgs = {
  input: UpdateActiveAdministratorInput;
};


export type MutationUpdateAdministratorArgs = {
  input: UpdateAdministratorInput;
};


export type MutationUpdateAlertArgs = {
  input: UpdateAlertInput;
};


export type MutationUpdateArtistArgs = {
  input: UpdateArtistInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateAvailableCountryProductArgs = {
  input: UpdateCountryProductInput;
};


export type MutationUpdateBannerArgs = {
  input: UpdateBannerInput;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateCooperateUserArgs = {
  input: UpdateCooperateInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateCustomerCountryArgs = {
  countryId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateCustomerGroupArgs = {
  input: UpdateCustomerGroupInput;
};


export type MutationUpdateCustomerNoteArgs = {
  input: UpdateCustomerNoteInput;
};


export type MutationUpdateDefaultEventConsentContentArgs = {
  input: UpdateDefaultEventConsentContent;
};


export type MutationUpdateDefaultEventConsentContentTranslationArgs = {
  input: UpdateDefaultEventConsentContentTranslationInput;
};


export type MutationUpdateDefaultProductDescriptionArgs = {
  input: UpdateDefaultProductDescriptionInput;
};


export type MutationUpdateDefaultProductDescriptionTranslationArgs = {
  input: UpdateDefaultProductDescriptionTranslationInput;
};


export type MutationUpdateDefaultProductInformationArgs = {
  input: UpdateDefaultProductInformationInput;
};


export type MutationUpdateEmailTemplateTranslationArgs = {
  input: UpdateEmailTemplateTranslationInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateFanClubEventInput;
};


export type MutationUpdateExchangeRateArgs = {
  input: UpdateExchangeRateInput;
};


export type MutationUpdateFacetArgs = {
  input: UpdateFacetInput;
};


export type MutationUpdateFacetValuesArgs = {
  input: Array<UpdateFacetValueInput>;
};


export type MutationUpdateFanClubArgs = {
  input: UpdateFanClubInput;
};


export type MutationUpdateFanClubGroupArgs = {
  input: UpdateFanClubGroupInput;
};


export type MutationUpdateFanClubLinkArgs = {
  input: UpdateFanClubLinkInput;
};


export type MutationUpdateFanClubLinkMissionArgs = {
  input?: InputMaybe<UpdateFanClubLinkMissionInput>;
};


export type MutationUpdateFanClubMemberArgs = {
  input: UpdateFanClubMemberInput;
};


export type MutationUpdateFreeGiftConditionArgs = {
  input: UpdateFreeGiftConditionInput;
};


export type MutationUpdateFreeGiftSelectionArgs = {
  input: UpdateFreeGiftInput;
};


export type MutationUpdateGlobalSettingsArgs = {
  input: UpdateGlobalSettingsInput;
};


export type MutationUpdateGoodsArgs = {
  input: Array<UpdateGoodsInput>;
};


export type MutationUpdateGuidanceArgs = {
  input: UpdateGuidanceInput;
};


export type MutationUpdateInboundApproveRequestArgs = {
  input: UpdateInboundApproveRequestInput;
};


export type MutationUpdateLinkVariantPriceArgs = {
  input?: InputMaybe<UpdateLinkVariantPriceInput>;
};


export type MutationUpdateNoticeArgs = {
  input: UpdateNoticeInput;
};


export type MutationUpdateOrderNoteArgs = {
  input: UpdateOrderNoteInput;
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackageInput;
};


export type MutationUpdatePackageReviewArgs = {
  input: UpdatePackageReviewInput;
};


export type MutationUpdatePackageReviewOrderLineArgs = {
  input?: InputMaybe<UpdatePackageReviewOrderLineInput>;
};


export type MutationUpdatePackageReviewSplitRuleArgs = {
  input: UpdatePackageReviewSplitRultInput;
};


export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductOptionArgs = {
  input: UpdateProductOptionInput;
};


export type MutationUpdateProductOptionGroupArgs = {
  input: UpdateProductOptionGroupInput;
};


export type MutationUpdateProductSpecificationArgs = {
  input: UpdateProductSpecificationInput;
};


export type MutationUpdateProductTypeArgs = {
  input: UpdateProductTypeInput;
};


export type MutationUpdateProductVariantsArgs = {
  input: Array<UpdateProductVariantInput>;
};


export type MutationUpdateProductsArgs = {
  input: Array<UpdateProductInput>;
};


export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput;
};


export type MutationUpdateProvinceArgs = {
  input: UpdateProvinceInput;
};


export type MutationUpdatePurchaseRequestCronjobArgs = {
  input: UpdatePurchaseRequestCronjobInput;
};


export type MutationUpdatePushTemplateArgs = {
  input: UpdatePushTemplateInput;
};


export type MutationUpdateQuestionPostArgs = {
  input: UpdateQuestionPostInput;
};


export type MutationUpdateQuestionPostCommentArgs = {
  input: UpdateQuestionPostComment;
};


export type MutationUpdateRefundRequestArgs = {
  input?: InputMaybe<UpdateRefundRequestInput>;
};


export type MutationUpdateRequestPurchaseArgs = {
  input: Array<UpdateRequestPurchaseInput>;
};


export type MutationUpdateRetailArgs = {
  input: UpdateRetailInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSellerArgs = {
  input: UpdateSellerInput;
};


export type MutationUpdateServiceFeeArgs = {
  input: UpdateServiceFeeInput;
};


export type MutationUpdateShippablesArgs = {
  input: UpdateShippablesInput;
};


export type MutationUpdateShippingArgs = {
  input: UpdateShippingInput;
};


export type MutationUpdateShippingFeeArgs = {
  input: UpdateShippingFeeInput;
};


export type MutationUpdateShippingFeeCountryArgs = {
  input: UpdateShippingFeeCountryInput;
};


export type MutationUpdateShippingFeeTypeArgs = {
  input: UpdateShippingFeeTypeInput;
};


export type MutationUpdateShippingMethodArgs = {
  input: UpdateShippingMethodInput;
};


export type MutationUpdateShopSupplierArgs = {
  input?: InputMaybe<UpdateShopSupplier>;
};


export type MutationUpdateSplitOrderRuleArgs = {
  input: UpdateSplitOrderRuleInput;
};


export type MutationUpdateStaticPageArgs = {
  input: UpdateStaticPageInput;
};


export type MutationUpdateStaticPageClassificationArgs = {
  input: UpdateStaticPageClassificationInput;
};


export type MutationUpdateStockLocationArgs = {
  input: UpdateStockLocationInput;
};


export type MutationUpdateSupplierArgs = {
  input: UpdateSupplierInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTaxCategoryArgs = {
  input: UpdateTaxCategoryInput;
};


export type MutationUpdateTaxRateArgs = {
  input: UpdateTaxRateInput;
};


export type MutationUpdateTicketArgs = {
  input?: InputMaybe<UpdateTicketInput>;
};


export type MutationUpdateTicketCommentArgs = {
  input: UpdateTicketCommentInput;
};


export type MutationUpdateUserLevelArgs = {
  input: UpdateUserLevelInput;
};


export type MutationUpdateZoneArgs = {
  input: UpdateZoneInput;
};


export type MutationUpsertAlbumRankArgs = {
  input: UpsertAlbumRankInput;
};


export type MutationVerifyCodeArgs = {
  input: VerifyCodeInput;
};

export type NativeAuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Returned when attempting an operation that relies on the NativeAuthStrategy, if that strategy is not configured. */
export type NativeAuthStrategyError = ErrorResult & {
  __typename?: 'NativeAuthStrategyError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NativeAuthenticationResult = CurrentUser | InvalidCredentialsError | NativeAuthStrategyError;

export type NeedToShipProduct = {
  __typename?: 'NeedToShipProduct';
  needToShipQuantity: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  shippableQuantity: Scalars['Int']['output'];
  shippedQuantity: Scalars['Int']['output'];
  stock: Scalars['Int']['output'];
  totalLinks: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type NeedToShipProductDetail = {
  __typename?: 'NeedToShipProductDetail';
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  totalLinks: Scalars['Int']['output'];
  variants: Array<NeedToShipProductVariant>;
};

export type NeedToShipProductFilterParameter = {
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type NeedToShipProductList = {
  __typename?: 'NeedToShipProductList';
  items: Array<NeedToShipProduct>;
  totalItems: Scalars['Int']['output'];
};

export type NeedToShipProductOptions = {
  filter?: InputMaybe<NeedToShipProductFilterParameter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type NeedToShipProductVariant = {
  __typename?: 'NeedToShipProductVariant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  needToShipQuantity: Scalars['Int']['output'];
  shippableQuantity: Scalars['Int']['output'];
  shippedQuantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  stock: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
};

/** Returned when attempting to set a negative OrderLine quantity. */
export type NegativeQuantityError = ErrorResult & {
  __typename?: 'NegativeQuantityError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned when invoking a mutation which depends on there being an active Order on the
 * current session.
 */
export type NoActiveOrderError = ErrorResult & {
  __typename?: 'NoActiveOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when a call to modifyOrder fails to specify any changes */
export type NoChangesSpecifiedError = ErrorResult & {
  __typename?: 'NoChangesSpecifiedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

/** Returned if an attempting to refund an Order but neither items nor shipping refund was specified */
export type NothingToRefundError = ErrorResult & {
  __typename?: 'NothingToRefundError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Notice = Node & {
  __typename?: 'Notice';
  administrator: NoticeAdmin;
  administratorId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nContent: Scalars['String']['output'];
  nTitle: Scalars['String']['output'];
  nWriter: Scalars['String']['output'];
  translations: Array<NoticeTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  visibility?: Maybe<Scalars['Boolean']['output']>;
};

export type NoticeAdmin = Node & {
  __typename?: 'NoticeAdmin';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type NoticeFilterParameter = {
  _and?: InputMaybe<Array<NoticeFilterParameter>>;
  _or?: InputMaybe<Array<NoticeFilterParameter>>;
  administratorId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  nContent?: InputMaybe<StringOperators>;
  nTitle?: InputMaybe<StringOperators>;
  nWriter?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  visibility?: InputMaybe<BooleanOperators>;
};

export type NoticeList = PaginatedList & {
  __typename?: 'NoticeList';
  items: Array<Notice>;
  totalItems: Scalars['Int']['output'];
};

export type NoticeListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<NoticeFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<NoticeSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type NoticeSortParameter = {
  administratorId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nContent?: InputMaybe<SortOrder>;
  nTitle?: InputMaybe<SortOrder>;
  nWriter?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NoticeTranslation = {
  __typename?: 'NoticeTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  nContent: Scalars['String']['output'];
  nTitle: Scalars['String']['output'];
  nWriter: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NoticeTranslationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  nContent: Scalars['String']['input'];
  nTitle: Scalars['String']['input'];
  nWriter: Scalars['String']['input'];
};

export type NotificationInput = {
  body: Scalars['String']['input'];
  clickAction?: InputMaybe<ClickAction>;
  clickActionData?: InputMaybe<Scalars['String']['input']>;
  isDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  targets: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type NullableFanClub = {
  __typename?: 'NullableFanClub';
  artist?: Maybe<Artist>;
  artistId?: Maybe<Scalars['ID']['output']>;
  artistName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAutoApprove?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<Array<FanClubLink>>;
  logo?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  totalLinks?: Maybe<Scalars['Int']['output']>;
  totalMembers?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Operators for filtering on a list of Number fields */
export type NumberListOperators = {
  inList: Scalars['Float']['input'];
};

/** Operators for filtering on a Int or Float field */
export type NumberOperators = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type Order = Node & {
  __typename?: 'Order';
  /** An order is active as long as the payment process has not been completed */
  active: Scalars['Boolean']['output'];
  aggregateOrder?: Maybe<Order>;
  aggregateOrderId?: Maybe<Scalars['ID']['output']>;
  billingAddress?: Maybe<OrderAddress>;
  channels: Array<Channel>;
  /** A unique code for the Order */
  code: Scalars['String']['output'];
  /** An array of all coupon codes applied to the Order */
  couponCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<OrderCustomFields>;
  customer?: Maybe<Customer>;
  customsClearance?: Maybe<CustomsClearance>;
  discounts: Array<Discount>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  history: HistoryEntryList;
  id: Scalars['ID']['output'];
  lines: Array<OrderLine>;
  modifications: Array<OrderModification>;
  nextStates: Array<Scalars['String']['output']>;
  /**
   * The date & time that the Order was placed, i.e. the Customer
   * completed the checkout and the Order is no longer "active"
   */
  orderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  payments?: Maybe<Array<Payment>>;
  productName?: Maybe<Scalars['String']['output']>;
  /** Promotions applied to the order. Only gets populated after the payment process has completed. */
  promotions: Array<Promotion>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityExcludeFreeGifts?: Maybe<Scalars['Int']['output']>;
  sellerOrders?: Maybe<Array<Order>>;
  shipping: Scalars['Money']['output'];
  shippingAddress?: Maybe<OrderAddress>;
  shippingLines: Array<ShippingLine>;
  shippingWithTax: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  /**
   * The subTotal is the total of all OrderLines in the Order. This figure also includes any Order-level
   * discounts which have been prorated (proportionally distributed) amongst the items of each OrderLine.
   * To get a total of all OrderLines which does not account for prorated discounts, use the
   * sum of `OrderLine.discountedLinePrice` values.
   */
  subTotal: Scalars['Money']['output'];
  /** Same as subTotal, but inclusive of tax */
  subTotalWithTax: Scalars['Money']['output'];
  /**
   * Surcharges are arbitrary modifications to the Order total which are neither
   * ProductVariants nor discounts resulting from applied Promotions. For example,
   * one-off discounts based on customer interaction, or surcharges based on payment
   * methods.
   */
  surcharges: Array<Surcharge>;
  /** A summary of the taxes being applied to this Order */
  taxSummary: Array<OrderTaxSummary>;
  /** Equal to subTotal plus shipping */
  total: Scalars['Money']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalRewardPoints?: Maybe<Scalars['Float']['output']>;
  /** The final payable amount. Equal to subTotalWithTax plus shippingWithTax */
  totalWithTax: Scalars['Money']['output'];
  type: OrderType;
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderHistoryArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<AddressCustomFields>;
  fullName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type OrderCustomFields = {
  __typename?: 'OrderCustomFields';
  contactInfo?: Maybe<Scalars['String']['output']>;
  customsClearanceId?: Maybe<Scalars['String']['output']>;
  customsClearanceStatusCol?: Maybe<Scalars['Boolean']['output']>;
  idCardStatus?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Float']['output']>;
  refundStatus?: Maybe<Scalars['String']['output']>;
};

export type OrderFilterParameter = {
  _and?: InputMaybe<Array<OrderFilterParameter>>;
  _or?: InputMaybe<Array<OrderFilterParameter>>;
  active?: InputMaybe<BooleanOperators>;
  aggregateOrderId?: InputMaybe<IdOperators>;
  code?: InputMaybe<StringOperators>;
  contactInfo?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  customerLastName?: InputMaybe<StringOperators>;
  customsClearanceId?: InputMaybe<StringOperators>;
  customsClearanceStatusCol?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  idCardStatus?: InputMaybe<StringOperators>;
  orderPlacedAt?: InputMaybe<DateOperators>;
  point?: InputMaybe<NumberOperators>;
  productName?: InputMaybe<StringOperators>;
  quantity?: InputMaybe<NumberOperators>;
  quantityExcludeFreeGifts?: InputMaybe<NumberOperators>;
  refundStatus?: InputMaybe<StringOperators>;
  shipping?: InputMaybe<NumberOperators>;
  shippingWithTax?: InputMaybe<NumberOperators>;
  state?: InputMaybe<StringOperators>;
  subTotal?: InputMaybe<NumberOperators>;
  subTotalWithTax?: InputMaybe<NumberOperators>;
  total?: InputMaybe<NumberOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  totalRewardPoints?: InputMaybe<NumberOperators>;
  totalWithTax?: InputMaybe<NumberOperators>;
  transactionId?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

/** Returned when the maximum order size limit has been reached. */
export type OrderLimitError = ErrorResult & {
  __typename?: 'OrderLimitError';
  errorCode: ErrorCode;
  maxItems: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type OrderLine = Node & {
  __typename?: 'OrderLine';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<OrderLineCustomFields>;
  /** The price of the line including discounts, excluding tax */
  discountedLinePrice: Scalars['Money']['output'];
  /** The price of the line including discounts and tax */
  discountedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The price of a single unit including discounts, excluding tax.
   *
   * If Order-level discounts have been applied, this will not be the
   * actual taxable unit price (see `proratedUnitPrice`), but is generally the
   * correct price to display to customers to avoid confusion
   * about the internal handling of distributed Order-level discounts.
   */
  discountedUnitPrice: Scalars['Money']['output'];
  /** The price of a single unit including discounts and tax */
  discountedUnitPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  featuredAsset?: Maybe<Asset>;
  fulfillmentLines?: Maybe<Array<FulfillmentLine>>;
  id: Scalars['ID']['output'];
  /** The total price of the line excluding tax and discounts. */
  linePrice: Scalars['Money']['output'];
  /** The total price of the line including tax but excluding discounts. */
  linePriceWithTax: Scalars['Money']['output'];
  /** The total tax on this line */
  lineTax: Scalars['Money']['output'];
  order: Order;
  /** The quantity at the time the Order was placed */
  orderPlacedQuantity: Scalars['Int']['output'];
  productVariant: ProductVariant;
  /**
   * The actual line price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderLine, and is used in tax
   * and refund calculations.
   */
  proratedLinePrice: Scalars['Money']['output'];
  /** The proratedLinePrice including tax */
  proratedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The actual unit price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderItem, and is used in tax
   * and refund calculations.
   */
  proratedUnitPrice: Scalars['Money']['output'];
  /** The proratedUnitPrice including tax */
  proratedUnitPriceWithTax: Scalars['Money']['output'];
  /** The quantity of items purchased */
  quantity: Scalars['Int']['output'];
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  /** The price of a single unit, excluding tax and discounts */
  unitPrice: Scalars['Money']['output'];
  /** Non-zero if the unitPrice has changed since it was initially added to Order */
  unitPriceChangeSinceAdded: Scalars['Money']['output'];
  /** The price of a single unit, including tax but excluding discounts */
  unitPriceWithTax: Scalars['Money']['output'];
  /** Non-zero if the unitPriceWithTax has changed since it was initially added to Order */
  unitPriceWithTaxChangeSinceAdded: Scalars['Money']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineCustomFields = {
  __typename?: 'OrderLineCustomFields';
  freeGiftConditionId?: Maybe<Scalars['String']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  linkId?: Maybe<Scalars['String']['output']>;
  previousQuantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineCustomFieldsInput = {
  freeGiftConditionId?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  linkId?: InputMaybe<Scalars['String']['input']>;
  previousQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderLineInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderList = PaginatedList & {
  __typename?: 'OrderList';
  items: Array<Order>;
  totalItems: Scalars['Int']['output'];
};

export type OrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<OrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderModification = Node & {
  __typename?: 'OrderModification';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isSettled: Scalars['Boolean']['output'];
  lines: Array<OrderModificationLine>;
  note: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  priceChange: Scalars['Money']['output'];
  refund?: Maybe<Refund>;
  surcharges?: Maybe<Array<Surcharge>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `AddingItems` state. */
export type OrderModificationError = ErrorResult & {
  __typename?: 'OrderModificationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type OrderModificationLine = {
  __typename?: 'OrderModificationLine';
  modification: OrderModification;
  modificationId: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `Modifying` state. */
export type OrderModificationStateError = ErrorResult & {
  __typename?: 'OrderModificationStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type OrderProcessState = {
  __typename?: 'OrderProcessState';
  name: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
};

export type OrderQuantityWithCurrencyCodeInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSortParameter = {
  aggregateOrderId?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  contactInfo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerLastName?: InputMaybe<SortOrder>;
  customsClearanceId?: InputMaybe<SortOrder>;
  customsClearanceStatusCol?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idCardStatus?: InputMaybe<SortOrder>;
  orderPlacedAt?: InputMaybe<SortOrder>;
  point?: InputMaybe<SortOrder>;
  productName?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  quantityExcludeFreeGifts?: InputMaybe<SortOrder>;
  refundStatus?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<SortOrder>;
  shippingWithTax?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  subTotal?: InputMaybe<SortOrder>;
  subTotalWithTax?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  totalRewardPoints?: InputMaybe<SortOrder>;
  totalWithTax?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Returned if there is an error in transitioning the Order state */
export type OrderStateTransitionError = ErrorResult & {
  __typename?: 'OrderStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

/**
 * A summary of the taxes being applied to this order, grouped
 * by taxRate.
 */
export type OrderTaxSummary = {
  __typename?: 'OrderTaxSummary';
  /** A description of this tax */
  description: Scalars['String']['output'];
  /** The total net price of OrderLines to which this taxRate applies */
  taxBase: Scalars['Money']['output'];
  /** The taxRate as a percentage */
  taxRate: Scalars['Float']['output'];
  /** The total tax being applied to the Order at this taxRate */
  taxTotal: Scalars['Money']['output'];
};

export enum OrderType {
  Aggregate = 'Aggregate',
  Regular = 'Regular',
  Seller = 'Seller'
}

export type Package = Node & {
  __typename?: 'Package';
  createdAt: Scalars['DateTime']['output'];
  estimatedWeight: Scalars['Float']['output'];
  giftQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  jackyunOrderID?: Maybe<Scalars['String']['output']>;
  jackyunStatus: Scalars['String']['output'];
  lines?: Maybe<Array<PackageLine>>;
  order: Order;
  orderId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageFilterParameter = {
  _and?: InputMaybe<Array<PackageFilterParameter>>;
  _or?: InputMaybe<Array<PackageFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  estimatedWeight?: InputMaybe<NumberOperators>;
  giftQuantity?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  jackyunOrderID?: InputMaybe<StringOperators>;
  jackyunStatus?: InputMaybe<StringOperators>;
  orderId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PackageLine = Node & {
  __typename?: 'PackageLine';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isGift?: Maybe<Scalars['Boolean']['output']>;
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  package: Package;
  packageId: Scalars['ID']['output'];
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageList = PaginatedList & {
  __typename?: 'PackageList';
  items: Array<Package>;
  totalItems: Scalars['Int']['output'];
};

export type PackageListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PackageFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PackageSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageReview = Node & {
  __typename?: 'PackageReview';
  averageGiftQuantityPerPackage: Scalars['Int']['output'];
  averageVariantQuantityPerPackage: Scalars['Int']['output'];
  averageWeightPerPackage: Scalars['Int']['output'];
  cloneOrderLines?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<PackageReviewOrderLine>>;
  order: Order;
  orderId: Scalars['ID']['output'];
  totalPackages: Scalars['Int']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalWeight: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageReviewFilterParameter = {
  _and?: InputMaybe<Array<PackageReviewFilterParameter>>;
  _or?: InputMaybe<Array<PackageReviewFilterParameter>>;
  averageGiftQuantityPerPackage?: InputMaybe<NumberOperators>;
  averageVariantQuantityPerPackage?: InputMaybe<NumberOperators>;
  averageWeightPerPackage?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  orderId?: InputMaybe<IdOperators>;
  sku?: InputMaybe<StringOperators>;
  totalPackages?: InputMaybe<NumberOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  totalWeight?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PackageReviewList = PaginatedList & {
  __typename?: 'PackageReviewList';
  items: Array<PackageReview>;
  totalItems: Scalars['Int']['output'];
};

export type PackageReviewListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PackageReviewFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PackageReviewSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageReviewOrderLine = Node & {
  __typename?: 'PackageReviewOrderLine';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderLine?: Maybe<OrderLine>;
  orderLineId?: Maybe<Scalars['ID']['output']>;
  packageReview?: Maybe<PackageReview>;
  packageReviewId?: Maybe<Scalars['ID']['output']>;
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageReviewSortParameter = {
  averageGiftQuantityPerPackage?: InputMaybe<SortOrder>;
  averageVariantQuantityPerPackage?: InputMaybe<SortOrder>;
  averageWeightPerPackage?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  totalPackages?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  totalWeight?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PackageReviewSummaryProduct = Node & {
  __typename?: 'PackageReviewSummaryProduct';
  freeGifts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalOrder: Scalars['Int']['output'];
  totalPackage: Scalars['Int']['output'];
  variants?: Maybe<Array<PackageReviewSummaryProductVariant>>;
};

export type PackageReviewSummaryProductFilterParameter = {
  _and?: InputMaybe<Array<PackageReviewSummaryProductFilterParameter>>;
  _or?: InputMaybe<Array<PackageReviewSummaryProductFilterParameter>>;
  freeGifts?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  totalOrder?: InputMaybe<NumberOperators>;
  totalPackage?: InputMaybe<NumberOperators>;
};

export type PackageReviewSummaryProductList = PaginatedList & {
  __typename?: 'PackageReviewSummaryProductList';
  items: Array<PackageReviewSummaryProduct>;
  totalItems: Scalars['Int']['output'];
};

export type PackageReviewSummaryProductListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PackageReviewSummaryProductFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PackageReviewSummaryProductSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageReviewSummaryProductSortParameter = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  totalOrder?: InputMaybe<SortOrder>;
  totalPackage?: InputMaybe<SortOrder>;
};

export type PackageReviewSummaryProductVariant = Node & {
  __typename?: 'PackageReviewSummaryProductVariant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stock: Scalars['Int']['output'];
  totalOrder: Scalars['Int']['output'];
  totalPackage: Scalars['Int']['output'];
};

export type PackageSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  estimatedWeight?: InputMaybe<SortOrder>;
  giftQuantity?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jackyunOrderID?: InputMaybe<SortOrder>;
  jackyunStatus?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaginatedList = {
  items: Array<Node>;
  totalItems: Scalars['Int']['output'];
};

export type PartialVendPayAccountList = {
  accName?: InputMaybe<Scalars['String']['input']>;
  accountTypeCode?: InputMaybe<Scalars['String']['input']>;
  accountTypeName?: InputMaybe<Scalars['String']['input']>;
  bankacct?: InputMaybe<Scalars['String']['input']>;
  bankbranch?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  amount: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  method: Scalars['String']['output'];
  nextStates: Array<Scalars['String']['output']>;
  refunds: Array<Refund>;
  state: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethod = Node & {
  __typename?: 'PaymentMethod';
  checker?: Maybe<ConfigurableOperation>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  handler: ConfigurableOperation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  translations: Array<PaymentMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodFilterParameter = {
  _and?: InputMaybe<Array<PaymentMethodFilterParameter>>;
  _or?: InputMaybe<Array<PaymentMethodFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PaymentMethodList = PaginatedList & {
  __typename?: 'PaymentMethodList';
  items: Array<PaymentMethod>;
  totalItems: Scalars['Int']['output'];
};

export type PaymentMethodListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PaymentMethodFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PaymentMethodSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Returned when a call to modifyOrder fails to include a paymentMethod even
 * though the price has increased as a result of the changes.
 */
export type PaymentMethodMissingError = ErrorResult & {
  __typename?: 'PaymentMethodMissingError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type PaymentMethodQuote = {
  __typename?: 'PaymentMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  eligibilityMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PaymentMethodSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentMethodTranslation = {
  __typename?: 'PaymentMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if an attempting to refund a Payment against OrderLines from a different Order */
export type PaymentOrderMismatchError = ErrorResult & {
  __typename?: 'PaymentOrderMismatchError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when there is an error in transitioning the Payment state */
export type PaymentStateTransitionError = ErrorResult & {
  __typename?: 'PaymentStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

/**
 * @description
 * Permissions for administrators and customers. Used to control access to
 * GraphQL resolvers via the {@link Allow} decorator.
 *
 * ## Understanding Permission.Owner
 *
 * `Permission.Owner` is a special permission which is used in some Vendure resolvers to indicate that that resolver should only
 * be accessible to the "owner" of that resource.
 *
 * For example, the Shop API `activeCustomer` query resolver should only return the Customer object for the "owner" of that Customer, i.e.
 * based on the activeUserId of the current session. As a result, the resolver code looks like this:
 *
 * @example
 * ```TypeScript
 * \@Query()
 * \@Allow(Permission.Owner)
 * async activeCustomer(\@Ctx() ctx: RequestContext): Promise<Customer | undefined> {
 *   const userId = ctx.activeUserId;
 *   if (userId) {
 *     return this.customerService.findOneByUserId(ctx, userId);
 *   }
 * }
 * ```
 *
 * Here we can see that the "ownership" must be enforced by custom logic inside the resolver. Since "ownership" cannot be defined generally
 * nor statically encoded at build-time, any resolvers using `Permission.Owner` **must** include logic to enforce that only the owner
 * of the resource has access. If not, then it is the equivalent of using `Permission.Public`.
 *
 *
 * @docsCategory common
 */
export enum Permission {
  /** Allow approving or rejecting an audit request */
  ApproveAuditRequest = 'ApproveAuditRequest',
  /** Allows approval of events */
  ApproveEvents = 'ApproveEvents',
  /** Allows approval of fan club applicants */
  ApproveFanClubApplicant = 'ApproveFanClubApplicant',
  /** Allows approval of fan club links */
  ApproveLinks = 'ApproveLinks',
  /** Allows approval of purchase request */
  ApprovePurchaseRequest = 'ApprovePurchaseRequest',
  /** Authenticated means simply that the user is logged in */
  Authenticated = 'Authenticated',
  /** Grants permission to create Administrator */
  CreateAdministrator = 'CreateAdministrator',
  /** Grants permission to create Alert */
  CreateAlert = 'CreateAlert',
  /** Grants permission to create Artist */
  CreateArtist = 'CreateArtist',
  /** Grants permission to create Asset */
  CreateAsset = 'CreateAsset',
  /** Grants permission to create Banner */
  CreateBanner = 'CreateBanner',
  /** Grants permission to create Products, Facets, Assets, Collections */
  CreateCatalog = 'CreateCatalog',
  /** Grants permission to create Channel */
  CreateChannel = 'CreateChannel',
  /** Grants permission to create Collection */
  CreateCollection = 'CreateCollection',
  /** Grants permission to create CooperateUser */
  CreateCooperateUser = 'CreateCooperateUser',
  /** Grants permission to create Country */
  CreateCountry = 'CreateCountry',
  /** Grants permission to create CountryPriceExchange */
  CreateCountryPriceExchange = 'CreateCountryPriceExchange',
  /** Grants permission to create Customer */
  CreateCustomer = 'CreateCustomer',
  /** Grants permission to create CustomerGroup */
  CreateCustomerGroup = 'CreateCustomerGroup',
  /** Grants permission to create CustomsClearance */
  CreateCustomsClearance = 'CreateCustomsClearance',
  /** Grants permission to create DefaultProductDescription */
  CreateDefaultProductDescription = 'CreateDefaultProductDescription',
  /** Grants permission to create DefaultProductDescriptionTranslation */
  CreateDefaultProductDescriptionTranslation = 'CreateDefaultProductDescriptionTranslation',
  /** Grants permission to create EmailAdmin */
  CreateEmailAdmin = 'CreateEmailAdmin',
  /** Grants permission to create Event */
  CreateEvent = 'CreateEvent',
  /** Grants permission to create EventContentConsent */
  CreateEventContentConsent = 'CreateEventContentConsent',
  /** Grants permission to create Facet */
  CreateFacet = 'CreateFacet',
  /** Grants permission to create FanClub */
  CreateFanClub = 'CreateFanClub',
  /** Grants permission to create FanClubAdminGroup */
  CreateFanClubAdminGroup = 'CreateFanClubAdminGroup',
  /** Grants permission to create FanClubLink */
  CreateFanClubLink = 'CreateFanClubLink',
  /** Grants permission to create FreeGiftSelection */
  CreateFreeGiftSelection = 'CreateFreeGiftSelection',
  /** Grants permission to create InboundApproveRequest */
  CreateInboundApproveRequest = 'CreateInboundApproveRequest',
  /** Grants permission to create Inbounding */
  CreateInbounding = 'CreateInbounding',
  /** Grants permission to create InboundingApproval */
  CreateInboundingApproval = 'CreateInboundingApproval',
  /** Grants permission to create Notice */
  CreateNotice = 'CreateNotice',
  /** Grants permission to create Order */
  CreateOrder = 'CreateOrder',
  /** Grants permission to create Package */
  CreatePackage = 'CreatePackage',
  /** Grants permission to create PackageReview */
  CreatePackageReview = 'CreatePackageReview',
  /** Grants permission to create PaymentMethod */
  CreatePaymentMethod = 'CreatePaymentMethod',
  /** Grants permission to create Product */
  CreateProduct = 'CreateProduct',
  /** Grants permission to create ProductSpecification */
  CreateProductSpecification = 'CreateProductSpecification',
  /** Grants permission to create ProductType */
  CreateProductType = 'CreateProductType',
  /** Grants permission to create Promotion */
  CreatePromotion = 'CreatePromotion',
  /** Grants permission to create PushTemplate */
  CreatePushTemplate = 'CreatePushTemplate',
  /** Grants permission to create PusnNotification */
  CreatePusnNotification = 'CreatePusnNotification',
  /** Grants permission to create QuestionPost */
  CreateQuestionPost = 'CreateQuestionPost',
  /** Grants permission to create Retailer */
  CreateRetailer = 'CreateRetailer',
  /** Grants permission to create Seller */
  CreateSeller = 'CreateSeller',
  /** Grants permission to create ServiceFee */
  CreateServiceFee = 'CreateServiceFee',
  /** Grants permission to create PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  CreateSettings = 'CreateSettings',
  /** Grants permission to create Shippable */
  CreateShippable = 'CreateShippable',
  /** Grants permission to create ShippableApprove */
  CreateShippableApprove = 'CreateShippableApprove',
  /** Grants permission to create Shipping */
  CreateShipping = 'CreateShipping',
  /** Grants permission to create ShippingFee */
  CreateShippingFee = 'CreateShippingFee',
  /** Grants permission to create ShippingMethod */
  CreateShippingMethod = 'CreateShippingMethod',
  /** Grants permission to create SplitOrderRule */
  CreateSplitOrderRule = 'CreateSplitOrderRule',
  /** Grants permission to create StaticPage */
  CreateStaticPage = 'CreateStaticPage',
  /** Grants permission to create StockLocation */
  CreateStockLocation = 'CreateStockLocation',
  /** Grants permission to create Supplier */
  CreateSupplier = 'CreateSupplier',
  /** Grants permission to create System */
  CreateSystem = 'CreateSystem',
  /** Grants permission to create Tag */
  CreateTag = 'CreateTag',
  /** Grants permission to create TaxCategory */
  CreateTaxCategory = 'CreateTaxCategory',
  /** Grants permission to create TaxRate */
  CreateTaxRate = 'CreateTaxRate',
  /** Grants permission to create Ticket */
  CreateTicket = 'CreateTicket',
  /** Grants permission to create UserLevel */
  CreateUserLevel = 'CreateUserLevel',
  /** Grants permission to create Warehouse */
  CreateWarehouse = 'CreateWarehouse',
  /** Grants permission to create Zone */
  CreateZone = 'CreateZone',
  /** Grants permission to delete Administrator */
  DeleteAdministrator = 'DeleteAdministrator',
  /** Grants permission to delete Alert */
  DeleteAlert = 'DeleteAlert',
  /** Grants permission to delete Artist */
  DeleteArtist = 'DeleteArtist',
  /** Grants permission to delete Asset */
  DeleteAsset = 'DeleteAsset',
  /** Grants permission to delete Banner */
  DeleteBanner = 'DeleteBanner',
  /** Grants permission to delete Products, Facets, Assets, Collections */
  DeleteCatalog = 'DeleteCatalog',
  /** Grants permission to delete Channel */
  DeleteChannel = 'DeleteChannel',
  /** Grants permission to delete Collection */
  DeleteCollection = 'DeleteCollection',
  /** Grants permission to delete CooperateUser */
  DeleteCooperateUser = 'DeleteCooperateUser',
  /** Grants permission to delete Country */
  DeleteCountry = 'DeleteCountry',
  /** Grants permission to delete CountryPriceExchange */
  DeleteCountryPriceExchange = 'DeleteCountryPriceExchange',
  /** Grants permission to delete Customer */
  DeleteCustomer = 'DeleteCustomer',
  /** Grants permission to delete CustomerGroup */
  DeleteCustomerGroup = 'DeleteCustomerGroup',
  /** Grants permission to delete CustomsClearance */
  DeleteCustomsClearance = 'DeleteCustomsClearance',
  /** Grants permission to delete DefaultProductDescription */
  DeleteDefaultProductDescription = 'DeleteDefaultProductDescription',
  /** Grants permission to delete DefaultProductDescriptionTranslation */
  DeleteDefaultProductDescriptionTranslation = 'DeleteDefaultProductDescriptionTranslation',
  /** Grants permission to delete EmailAdmin */
  DeleteEmailAdmin = 'DeleteEmailAdmin',
  /** Grants permission to delete Event */
  DeleteEvent = 'DeleteEvent',
  /** Grants permission to delete EventContentConsent */
  DeleteEventContentConsent = 'DeleteEventContentConsent',
  /** Grants permission to delete Facet */
  DeleteFacet = 'DeleteFacet',
  /** Grants permission to delete FanClub */
  DeleteFanClub = 'DeleteFanClub',
  /** Grants permission to delete FanClubAdminGroup */
  DeleteFanClubAdminGroup = 'DeleteFanClubAdminGroup',
  /** Grants permission to delete FanClubLink */
  DeleteFanClubLink = 'DeleteFanClubLink',
  /** Grants permission to delete FreeGiftSelection */
  DeleteFreeGiftSelection = 'DeleteFreeGiftSelection',
  /** Grants permission to delete InboundApproveRequest */
  DeleteInboundApproveRequest = 'DeleteInboundApproveRequest',
  /** Grants permission to delete Inbounding */
  DeleteInbounding = 'DeleteInbounding',
  /** Grants permission to delete InboundingApproval */
  DeleteInboundingApproval = 'DeleteInboundingApproval',
  /** Grants permission to delete Notice */
  DeleteNotice = 'DeleteNotice',
  /** Grants permission to delete Order */
  DeleteOrder = 'DeleteOrder',
  /** Grants permission to delete Package */
  DeletePackage = 'DeletePackage',
  /** Grants permission to delete PackageReview */
  DeletePackageReview = 'DeletePackageReview',
  /** Grants permission to delete PaymentMethod */
  DeletePaymentMethod = 'DeletePaymentMethod',
  /** Grants permission to delete Product */
  DeleteProduct = 'DeleteProduct',
  /** Grants permission to delete ProductSpecification */
  DeleteProductSpecification = 'DeleteProductSpecification',
  /** Grants permission to delete ProductType */
  DeleteProductType = 'DeleteProductType',
  /** Grants permission to delete Promotion */
  DeletePromotion = 'DeletePromotion',
  /** Grants permission to delete PushTemplate */
  DeletePushTemplate = 'DeletePushTemplate',
  /** Grants permission to delete PusnNotification */
  DeletePusnNotification = 'DeletePusnNotification',
  /** Grants permission to delete QuestionPost */
  DeleteQuestionPost = 'DeleteQuestionPost',
  /** Grants permission to delete Retailer */
  DeleteRetailer = 'DeleteRetailer',
  /** Grants permission to delete Seller */
  DeleteSeller = 'DeleteSeller',
  /** Grants permission to delete ServiceFee */
  DeleteServiceFee = 'DeleteServiceFee',
  /** Grants permission to delete PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  DeleteSettings = 'DeleteSettings',
  /** Grants permission to delete Shippable */
  DeleteShippable = 'DeleteShippable',
  /** Grants permission to delete ShippableApprove */
  DeleteShippableApprove = 'DeleteShippableApprove',
  /** Grants permission to delete Shipping */
  DeleteShipping = 'DeleteShipping',
  /** Grants permission to delete ShippingFee */
  DeleteShippingFee = 'DeleteShippingFee',
  /** Grants permission to delete ShippingMethod */
  DeleteShippingMethod = 'DeleteShippingMethod',
  /** Grants permission to delete SplitOrderRule */
  DeleteSplitOrderRule = 'DeleteSplitOrderRule',
  /** Grants permission to delete StaticPage */
  DeleteStaticPage = 'DeleteStaticPage',
  /** Grants permission to delete StockLocation */
  DeleteStockLocation = 'DeleteStockLocation',
  /** Grants permission to delete Supplier */
  DeleteSupplier = 'DeleteSupplier',
  /** Grants permission to delete System */
  DeleteSystem = 'DeleteSystem',
  /** Grants permission to delete Tag */
  DeleteTag = 'DeleteTag',
  /** Grants permission to delete TaxCategory */
  DeleteTaxCategory = 'DeleteTaxCategory',
  /** Grants permission to delete TaxRate */
  DeleteTaxRate = 'DeleteTaxRate',
  /** Grants permission to delete Ticket */
  DeleteTicket = 'DeleteTicket',
  /** Grants permission to delete UserLevel */
  DeleteUserLevel = 'DeleteUserLevel',
  /** Grants permission to delete Warehouse */
  DeleteWarehouse = 'DeleteWarehouse',
  /** Grants permission to delete Zone */
  DeleteZone = 'DeleteZone',
  /** Owner means the user owns this entity, e.g. a Customer's own Order */
  Owner = 'Owner',
  /** Public means any unauthenticated user may perform the operation */
  Public = 'Public',
  /** Grants permission to read Administrator */
  ReadAdministrator = 'ReadAdministrator',
  /** Grants permission to read Alert */
  ReadAlert = 'ReadAlert',
  /** Grants permission to read Artist */
  ReadArtist = 'ReadArtist',
  /** Grants permission to read Asset */
  ReadAsset = 'ReadAsset',
  /** Grants permission to read Banner */
  ReadBanner = 'ReadBanner',
  /** Grants permission to read Products, Facets, Assets, Collections */
  ReadCatalog = 'ReadCatalog',
  /** Grants permission to read Channel */
  ReadChannel = 'ReadChannel',
  /** Grants permission to read Collection */
  ReadCollection = 'ReadCollection',
  /** Grants permission to read CooperateUser */
  ReadCooperateUser = 'ReadCooperateUser',
  /** Grants permission to read Country */
  ReadCountry = 'ReadCountry',
  /** Grants permission to read CountryPriceExchange */
  ReadCountryPriceExchange = 'ReadCountryPriceExchange',
  /** Grants permission to read Customer */
  ReadCustomer = 'ReadCustomer',
  /** Grants permission to read CustomerGroup */
  ReadCustomerGroup = 'ReadCustomerGroup',
  /** Grants permission to read CustomsClearance */
  ReadCustomsClearance = 'ReadCustomsClearance',
  /** Grants permission to read DefaultProductDescription */
  ReadDefaultProductDescription = 'ReadDefaultProductDescription',
  /** Grants permission to read DefaultProductDescriptionTranslation */
  ReadDefaultProductDescriptionTranslation = 'ReadDefaultProductDescriptionTranslation',
  /** Grants permission to read EmailAdmin */
  ReadEmailAdmin = 'ReadEmailAdmin',
  /** Grants permission to read Event */
  ReadEvent = 'ReadEvent',
  /** Grants permission to read EventContentConsent */
  ReadEventContentConsent = 'ReadEventContentConsent',
  /** Grants permission to read Facet */
  ReadFacet = 'ReadFacet',
  /** Grants permission to read FanClub */
  ReadFanClub = 'ReadFanClub',
  /** Grants permission to read FanClubAdminGroup */
  ReadFanClubAdminGroup = 'ReadFanClubAdminGroup',
  /** Grants permission to read FanClubLink */
  ReadFanClubLink = 'ReadFanClubLink',
  /** Grants permission to read FreeGiftSelection */
  ReadFreeGiftSelection = 'ReadFreeGiftSelection',
  /** Grants permission to read InboundApproveRequest */
  ReadInboundApproveRequest = 'ReadInboundApproveRequest',
  /** Grants permission to read Inbounding */
  ReadInbounding = 'ReadInbounding',
  /** Grants permission to read InboundingApproval */
  ReadInboundingApproval = 'ReadInboundingApproval',
  /** Allow viewing Need to ship list */
  ReadNeedToShip = 'ReadNeedToShip',
  /** Grants permission to read Notice */
  ReadNotice = 'ReadNotice',
  /** Grants permission to read Order */
  ReadOrder = 'ReadOrder',
  /** Grants permission to read Package */
  ReadPackage = 'ReadPackage',
  /** Grants permission to read PackageReview */
  ReadPackageReview = 'ReadPackageReview',
  /** Grants permission to read PaymentMethod */
  ReadPaymentMethod = 'ReadPaymentMethod',
  /** Grants permission to read Product */
  ReadProduct = 'ReadProduct',
  /** Grants permission to read ProductSpecification */
  ReadProductSpecification = 'ReadProductSpecification',
  /** Grants permission to read ProductType */
  ReadProductType = 'ReadProductType',
  /** Grants permission to read Promotion */
  ReadPromotion = 'ReadPromotion',
  /** Allows reading list of purchase request */
  ReadPurchaseRequest = 'ReadPurchaseRequest',
  /** Grants permission to read PushTemplate */
  ReadPushTemplate = 'ReadPushTemplate',
  /** Grants permission to read PusnNotification */
  ReadPusnNotification = 'ReadPusnNotification',
  /** Grants permission to read QuestionPost */
  ReadQuestionPost = 'ReadQuestionPost',
  /** Grants permission to read Retailer */
  ReadRetailer = 'ReadRetailer',
  /** Grants permission to read Seller */
  ReadSeller = 'ReadSeller',
  /** Grants permission to read ServiceFee */
  ReadServiceFee = 'ReadServiceFee',
  /** Grants permission to read PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  ReadSettings = 'ReadSettings',
  /** Grants permission to read Shippable */
  ReadShippable = 'ReadShippable',
  /** Grants permission to read ShippableApprove */
  ReadShippableApprove = 'ReadShippableApprove',
  /** Grants permission to read Shipping */
  ReadShipping = 'ReadShipping',
  /** Grants permission to read ShippingFee */
  ReadShippingFee = 'ReadShippingFee',
  /** Grants permission to read ShippingMethod */
  ReadShippingMethod = 'ReadShippingMethod',
  /** Grants permission to read SplitOrderRule */
  ReadSplitOrderRule = 'ReadSplitOrderRule',
  /** Grants permission to read StaticPage */
  ReadStaticPage = 'ReadStaticPage',
  /** Grants permission to read StockLocation */
  ReadStockLocation = 'ReadStockLocation',
  /** Grants permission to read Supplier */
  ReadSupplier = 'ReadSupplier',
  /** Grants permission to read System */
  ReadSystem = 'ReadSystem',
  /** Grants permission to read Tag */
  ReadTag = 'ReadTag',
  /** Grants permission to read TaxCategory */
  ReadTaxCategory = 'ReadTaxCategory',
  /** Grants permission to read TaxRate */
  ReadTaxRate = 'ReadTaxRate',
  /** Grants permission to read Ticket */
  ReadTicket = 'ReadTicket',
  /** Grants permission to read UserLevel */
  ReadUserLevel = 'ReadUserLevel',
  /** Grants permission to read Warehouse */
  ReadWarehouse = 'ReadWarehouse',
  /** Grants permission to read Zone */
  ReadZone = 'ReadZone',
  /** SuperAdmin has unrestricted access to all operations */
  SuperAdmin = 'SuperAdmin',
  /** Grants permission to update Administrator */
  UpdateAdministrator = 'UpdateAdministrator',
  /** Grants permission to update Alert */
  UpdateAlert = 'UpdateAlert',
  /** Grants permission to update Artist */
  UpdateArtist = 'UpdateArtist',
  /** Grants permission to update Asset */
  UpdateAsset = 'UpdateAsset',
  /** Grants permission to update Banner */
  UpdateBanner = 'UpdateBanner',
  /** Grants permission to update Products, Facets, Assets, Collections */
  UpdateCatalog = 'UpdateCatalog',
  /** Grants permission to update Channel */
  UpdateChannel = 'UpdateChannel',
  /** Grants permission to update Collection */
  UpdateCollection = 'UpdateCollection',
  /** Grants permission to update CooperateUser */
  UpdateCooperateUser = 'UpdateCooperateUser',
  /** Grants permission to update Country */
  UpdateCountry = 'UpdateCountry',
  /** Grants permission to update CountryPriceExchange */
  UpdateCountryPriceExchange = 'UpdateCountryPriceExchange',
  /** Grants permission to update Customer */
  UpdateCustomer = 'UpdateCustomer',
  /** Grants permission to update CustomerGroup */
  UpdateCustomerGroup = 'UpdateCustomerGroup',
  /** Grants permission to update CustomsClearance */
  UpdateCustomsClearance = 'UpdateCustomsClearance',
  /** Grants permission to update DefaultProductDescription */
  UpdateDefaultProductDescription = 'UpdateDefaultProductDescription',
  /** Grants permission to update DefaultProductDescriptionTranslation */
  UpdateDefaultProductDescriptionTranslation = 'UpdateDefaultProductDescriptionTranslation',
  /** Grants permission to update EmailAdmin */
  UpdateEmailAdmin = 'UpdateEmailAdmin',
  /** Grants permission to update Event */
  UpdateEvent = 'UpdateEvent',
  /** Grants permission to update EventContentConsent */
  UpdateEventContentConsent = 'UpdateEventContentConsent',
  /** Grants permission to update Facet */
  UpdateFacet = 'UpdateFacet',
  /** Grants permission to update FanClub */
  UpdateFanClub = 'UpdateFanClub',
  /** Grants permission to update FanClubAdminGroup */
  UpdateFanClubAdminGroup = 'UpdateFanClubAdminGroup',
  /** Grants permission to update FanClubLink */
  UpdateFanClubLink = 'UpdateFanClubLink',
  /** Grants permission to update FreeGiftSelection */
  UpdateFreeGiftSelection = 'UpdateFreeGiftSelection',
  /** Grants permission to update GlobalSettings */
  UpdateGlobalSettings = 'UpdateGlobalSettings',
  /** Grants permission to update InboundApproveRequest */
  UpdateInboundApproveRequest = 'UpdateInboundApproveRequest',
  /** Grants permission to update Inbounding */
  UpdateInbounding = 'UpdateInbounding',
  /** Grants permission to update InboundingApproval */
  UpdateInboundingApproval = 'UpdateInboundingApproval',
  /** Grants permission to update Notice */
  UpdateNotice = 'UpdateNotice',
  /** Grants permission to update Order */
  UpdateOrder = 'UpdateOrder',
  /** Grants permission to update Package */
  UpdatePackage = 'UpdatePackage',
  /** Grants permission to update PackageReview */
  UpdatePackageReview = 'UpdatePackageReview',
  /** Grants permission to update PaymentMethod */
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  /** Grants permission to update Product */
  UpdateProduct = 'UpdateProduct',
  /** Grants permission to update ProductSpecification */
  UpdateProductSpecification = 'UpdateProductSpecification',
  /** Grants permission to update ProductType */
  UpdateProductType = 'UpdateProductType',
  /** Grants permission to update Promotion */
  UpdatePromotion = 'UpdatePromotion',
  /** Grants permission to update PushTemplate */
  UpdatePushTemplate = 'UpdatePushTemplate',
  /** Grants permission to update PusnNotification */
  UpdatePusnNotification = 'UpdatePusnNotification',
  /** Grants permission to update QuestionPost */
  UpdateQuestionPost = 'UpdateQuestionPost',
  /** Grants permission to update Retailer */
  UpdateRetailer = 'UpdateRetailer',
  /** Grants permission to update Seller */
  UpdateSeller = 'UpdateSeller',
  /** Grants permission to update ServiceFee */
  UpdateServiceFee = 'UpdateServiceFee',
  /** Grants permission to update PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  UpdateSettings = 'UpdateSettings',
  /** Grants permission to update Shippable */
  UpdateShippable = 'UpdateShippable',
  /** Grants permission to update ShippableApprove */
  UpdateShippableApprove = 'UpdateShippableApprove',
  /** Grants permission to update Shipping */
  UpdateShipping = 'UpdateShipping',
  /** Grants permission to update ShippingFee */
  UpdateShippingFee = 'UpdateShippingFee',
  /** Grants permission to update ShippingMethod */
  UpdateShippingMethod = 'UpdateShippingMethod',
  /** Grants permission to update SplitOrderRule */
  UpdateSplitOrderRule = 'UpdateSplitOrderRule',
  /** Grants permission to update StaticPage */
  UpdateStaticPage = 'UpdateStaticPage',
  /** Grants permission to update StockLocation */
  UpdateStockLocation = 'UpdateStockLocation',
  /** Grants permission to update Supplier */
  UpdateSupplier = 'UpdateSupplier',
  /** Grants permission to update System */
  UpdateSystem = 'UpdateSystem',
  /** Grants permission to update Tag */
  UpdateTag = 'UpdateTag',
  /** Grants permission to update TaxCategory */
  UpdateTaxCategory = 'UpdateTaxCategory',
  /** Grants permission to update TaxRate */
  UpdateTaxRate = 'UpdateTaxRate',
  /** Grants permission to update Ticket */
  UpdateTicket = 'UpdateTicket',
  /** Grants permission to update UserLevel */
  UpdateUserLevel = 'UpdateUserLevel',
  /** Grants permission to update Warehouse */
  UpdateWarehouse = 'UpdateWarehouse',
  /** Grants permission to update Zone */
  UpdateZone = 'UpdateZone'
}

export type PermissionDefinition = {
  __typename?: 'PermissionDefinition';
  assignable: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PhoneNumberVerification = {
  __typename?: 'PhoneNumberVerification';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  expires: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Place = {
  __typename?: 'Place';
  code?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum PointAction {
  Decrease = 'Decrease',
  Increase = 'Increase'
}

export type PreviewCollectionVariantsInput = {
  filters: Array<ConfigurableOperationInput>;
  inheritFilters: Scalars['Boolean']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type PriceExchangeRate = Node & {
  __typename?: 'PriceExchangeRate';
  country?: Maybe<Country>;
  countryId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  taxRate?: Maybe<TaxRate>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PriceExchangeRateFilterParameter = {
  _and?: InputMaybe<Array<PriceExchangeRateFilterParameter>>;
  _or?: InputMaybe<Array<PriceExchangeRateFilterParameter>>;
  countryId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  default?: InputMaybe<BooleanOperators>;
  enable?: InputMaybe<BooleanOperators>;
  exchangeRate?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PriceExchangeRateList = PaginatedList & {
  __typename?: 'PriceExchangeRateList';
  items: Array<PriceExchangeRate>;
  totalItems: Scalars['Int']['output'];
};

export type PriceExchangeRateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PriceExchangeRateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PriceExchangeRateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceExchangeRateSortParameter = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  exchangeRate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PriceGenerateResult = {
  __typename?: 'PriceGenerateResult';
  created: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

/** The price range where the result has more than one price */
export type PriceRange = {
  __typename?: 'PriceRange';
  max: Scalars['Money']['output'];
  min: Scalars['Money']['output'];
};

export type PriceRangeOptions = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type Product = Node & {
  __typename?: 'Product';
  assets: Array<Asset>;
  availableCountries?: Maybe<Array<AvailableCountryShipping>>;
  channels: Array<Channel>;
  collections: Array<Collection>;
  consentContents?: Maybe<Array<DefaultEventConsentContent>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProductCustomFields>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  freeGiftSelection?: Maybe<FreeGiftSelection>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  optionGroups: Array<ProductOptionGroup>;
  sale: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  stock: Scalars['Int']['output'];
  totalRequestPurchaseAmount: Scalars['Int']['output'];
  translations: Array<ProductTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of ProductVariants */
  variantList: ProductVariantList;
  /** Returns all ProductVariants */
  variants: Array<ProductVariant>;
};


export type ProductVariantListArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type ProductAdvancedFilterParameter = {
  artistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facetValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<PriceRangeOptions>;
  retailerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductAdvancedOps = {
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAdvancedFilterParameter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAdvancedSortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAdvancedSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  sale?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductCustomFields = {
  __typename?: 'ProductCustomFields';
  artist?: Maybe<Artist>;
  createdInJackyun?: Maybe<Scalars['Boolean']['output']>;
  customThreshold?: Maybe<Scalars['Int']['output']>;
  defaultProductDescription?: Maybe<DefaultProductDescription>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Array<FanClubEvent>>;
  facetsColumn?: Maybe<Scalars['Boolean']['output']>;
  freeGifts?: Maybe<Scalars['Boolean']['output']>;
  isCorporate?: Maybe<Scalars['Boolean']['output']>;
  isSinglePurchase?: Maybe<Scalars['Boolean']['output']>;
  onSale?: Maybe<Scalars['Boolean']['output']>;
  preorder?: Maybe<Scalars['Boolean']['output']>;
  productType?: Maybe<ProductType>;
  purchaseNote?: Maybe<Scalars['String']['output']>;
  purchaseUrl?: Maybe<Scalars['String']['output']>;
  randomOption?: Maybe<Scalars['Boolean']['output']>;
  retailer?: Maybe<Retail>;
  shippingSetting?: Maybe<Scalars['String']['output']>;
  showSales?: Maybe<Scalars['Boolean']['output']>;
  showStock?: Maybe<Scalars['Boolean']['output']>;
  splitOrderRule?: Maybe<SplitOrderRule>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<ShopSupplier>;
  totalLinks?: Maybe<Scalars['String']['output']>;
  totalSalesQuantity?: Maybe<Scalars['String']['output']>;
  totalStocks?: Maybe<Scalars['Int']['output']>;
  useSaleTime?: Maybe<Scalars['Boolean']['output']>;
  warehouse?: Maybe<Warehouse>;
};

export type ProductFilterParameter = {
  _and?: InputMaybe<Array<ProductFilterParameter>>;
  _or?: InputMaybe<Array<ProductFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  createdInJackyun?: InputMaybe<BooleanOperators>;
  customThreshold?: InputMaybe<NumberOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  endTime?: InputMaybe<DateOperators>;
  event?: InputMaybe<BooleanOperators>;
  facetValueId?: InputMaybe<IdOperators>;
  facetsColumn?: InputMaybe<BooleanOperators>;
  freeGifts?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  isCorporate?: InputMaybe<BooleanOperators>;
  isSinglePurchase?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  onSale?: InputMaybe<BooleanOperators>;
  preorder?: InputMaybe<BooleanOperators>;
  purchaseNote?: InputMaybe<StringOperators>;
  purchaseUrl?: InputMaybe<StringOperators>;
  randomOption?: InputMaybe<BooleanOperators>;
  sale?: InputMaybe<NumberOperators>;
  shippingSetting?: InputMaybe<StringOperators>;
  showSales?: InputMaybe<BooleanOperators>;
  showStock?: InputMaybe<BooleanOperators>;
  sku?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  startTime?: InputMaybe<DateOperators>;
  status?: InputMaybe<StringOperators>;
  stock?: InputMaybe<NumberOperators>;
  totalLinks?: InputMaybe<StringOperators>;
  totalRequestPurchaseAmount?: InputMaybe<NumberOperators>;
  totalSalesQuantity?: InputMaybe<StringOperators>;
  totalStocks?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  useSaleTime?: InputMaybe<BooleanOperators>;
};

export type ProductList = PaginatedList & {
  __typename?: 'ProductList';
  items: Array<Product>;
  totalItems: Scalars['Int']['output'];
};

export type ProductListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOption = Node & {
  __typename?: 'ProductOption';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  group: ProductOptionGroup;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ProductOptionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroup = Node & {
  __typename?: 'ProductOptionGroup';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  translations: Array<ProductOptionGroupTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslation = {
  __typename?: 'ProductOptionGroupTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductOptionInUseError = ErrorResult & {
  __typename?: 'ProductOptionInUseError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  optionGroupCode: Scalars['String']['output'];
  productVariantCount: Scalars['Int']['output'];
};

export type ProductOptionTranslation = {
  __typename?: 'ProductOptionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSortParameter = {
  artist?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdInJackyun?: InputMaybe<SortOrder>;
  customThreshold?: InputMaybe<SortOrder>;
  defaultProductDescription?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  event?: InputMaybe<SortOrder>;
  facetsColumn?: InputMaybe<SortOrder>;
  freeGifts?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCorporate?: InputMaybe<SortOrder>;
  isSinglePurchase?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  onSale?: InputMaybe<SortOrder>;
  preorder?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  purchaseNote?: InputMaybe<SortOrder>;
  purchaseUrl?: InputMaybe<SortOrder>;
  randomOption?: InputMaybe<SortOrder>;
  retailer?: InputMaybe<SortOrder>;
  sale?: InputMaybe<SortOrder>;
  shippingSetting?: InputMaybe<SortOrder>;
  showSales?: InputMaybe<SortOrder>;
  showStock?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  splitOrderRule?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  supplier?: InputMaybe<SortOrder>;
  totalLinks?: InputMaybe<SortOrder>;
  totalRequestPurchaseAmount?: InputMaybe<SortOrder>;
  totalSalesQuantity?: InputMaybe<SortOrder>;
  totalStocks?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  useSaleTime?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<SortOrder>;
};

export type ProductSpecification = Node & {
  __typename?: 'ProductSpecification';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productVariant: ProductVariant;
  productVariantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ProductSpecificationFilterParameter = {
  _and?: InputMaybe<Array<ProductSpecificationFilterParameter>>;
  _or?: InputMaybe<Array<ProductSpecificationFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  productVariantId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type ProductSpecificationList = PaginatedList & {
  __typename?: 'ProductSpecificationList';
  items: Array<ProductSpecification>;
  totalItems: Scalars['Int']['output'];
};

export type ProductSpecificationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductSpecificationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductSpecificationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSpecificationSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productVariantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type ProductStatistic = {
  __typename?: 'ProductStatistic';
  totalCustomerOrders: Scalars['Int']['output'];
  totalLinks: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type ProductStatisticOptions = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductType = Node & {
  __typename?: 'ProductType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductTypeFilterParameter = {
  _and?: InputMaybe<Array<ProductTypeFilterParameter>>;
  _or?: InputMaybe<Array<ProductTypeFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProductTypeList = PaginatedList & {
  __typename?: 'ProductTypeList';
  items: Array<ProductType>;
  totalItems: Scalars['Int']['output'];
};

export type ProductTypeListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductTypeFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductTypeSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductTypeSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductVariant = Node & {
  __typename?: 'ProductVariant';
  assets: Array<Asset>;
  channels: Array<Channel>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<ProductVariantCustomFields>;
  enabled: Scalars['Boolean']['output'];
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  freeGiftSelection?: Maybe<FreeGiftSelection>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  outOfStockThreshold: Scalars['Int']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  prices: Array<ProductVariantPrice>;
  product: Product;
  productId: Scalars['ID']['output'];
  productSpecifications: Array<ProductSpecification>;
  sku: Scalars['String']['output'];
  /** @deprecated use stockLevels */
  stockAllocated: Scalars['Int']['output'];
  stockLevel: Scalars['String']['output'];
  stockLevels: Array<StockLevel>;
  stockMovements: StockMovementList;
  /** @deprecated use stockLevels */
  stockOnHand: Scalars['Int']['output'];
  taxCategory: TaxCategory;
  taxRateApplied: TaxRate;
  totalRequestPurchaseAmount: Scalars['Int']['output'];
  trackInventory: GlobalFlag;
  translations: Array<ProductVariantTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  useGlobalOutOfStockThreshold: Scalars['Boolean']['output'];
};


export type ProductVariantStockMovementsArgs = {
  options?: InputMaybe<StockMovementListOptions>;
};

export type ProductVariantCustomFields = {
  __typename?: 'ProductVariantCustomFields';
  fixPrice?: Maybe<Scalars['Float']['output']>;
  maxPerOrder?: Maybe<Scalars['Int']['output']>;
  minPerOrder?: Maybe<Scalars['Int']['output']>;
  skuBarcode?: Maybe<Scalars['String']['output']>;
  stockWaiting?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<Warehouse>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantFilterParameter = {
  _and?: InputMaybe<Array<ProductVariantFilterParameter>>;
  _or?: InputMaybe<Array<ProductVariantFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  facetValueId?: InputMaybe<IdOperators>;
  fixPrice?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  maxPerOrder?: InputMaybe<NumberOperators>;
  minPerOrder?: InputMaybe<NumberOperators>;
  name?: InputMaybe<StringOperators>;
  outOfStockThreshold?: InputMaybe<NumberOperators>;
  price?: InputMaybe<NumberOperators>;
  priceWithTax?: InputMaybe<NumberOperators>;
  productId?: InputMaybe<IdOperators>;
  sku?: InputMaybe<StringOperators>;
  skuBarcode?: InputMaybe<StringOperators>;
  stockAllocated?: InputMaybe<NumberOperators>;
  stockLevel?: InputMaybe<StringOperators>;
  stockOnHand?: InputMaybe<NumberOperators>;
  stockWaiting?: InputMaybe<NumberOperators>;
  supplier?: InputMaybe<StringOperators>;
  totalRequestPurchaseAmount?: InputMaybe<NumberOperators>;
  trackInventory?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  useGlobalOutOfStockThreshold?: InputMaybe<BooleanOperators>;
  weight?: InputMaybe<NumberOperators>;
};

export type ProductVariantList = PaginatedList & {
  __typename?: 'ProductVariantList';
  items: Array<ProductVariant>;
  totalItems: Scalars['Int']['output'];
};

export type ProductVariantListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductVariantFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductVariantSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantPrice = {
  __typename?: 'ProductVariantPrice';
  currencyCode: CurrencyCode;
  customFields?: Maybe<ProductVariantPriceCustomFields>;
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
};

export type ProductVariantPriceCustomFields = {
  __typename?: 'ProductVariantPriceCustomFields';
  beforeTax?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  customServiceFee?: Maybe<Scalars['Float']['output']>;
  syncWithOther?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Used to set up update the price of a ProductVariant in a particular Channel.
 * If the `delete` flag is `true`, the price will be deleted for the given Channel.
 */
export type ProductVariantPriceInput = {
  currencyCode: CurrencyCode;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Money']['input'];
};

export type ProductVariantSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  fixPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxPerOrder?: InputMaybe<SortOrder>;
  minPerOrder?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  outOfStockThreshold?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceWithTax?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  skuBarcode?: InputMaybe<SortOrder>;
  stockAllocated?: InputMaybe<SortOrder>;
  stockLevel?: InputMaybe<SortOrder>;
  stockOnHand?: InputMaybe<SortOrder>;
  stockWaiting?: InputMaybe<SortOrder>;
  supplier?: InputMaybe<SortOrder>;
  totalRequestPurchaseAmount?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ProductVariantTranslation = {
  __typename?: 'ProductVariantTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductVariantTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Promotion = Node & {
  __typename?: 'Promotion';
  actions: Array<ConfigurableOperation>;
  conditions: Array<ConfigurableOperation>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<PromotionCustomFields>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perCustomerUsageLimit?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  translations: Array<PromotionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCustomFields = {
  __typename?: 'PromotionCustomFields';
  customers?: Maybe<Array<Customer>>;
};

export type PromotionFilterParameter = {
  _and?: InputMaybe<Array<PromotionFilterParameter>>;
  _or?: InputMaybe<Array<PromotionFilterParameter>>;
  couponCode?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  endsAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  perCustomerUsageLimit?: InputMaybe<NumberOperators>;
  startsAt?: InputMaybe<DateOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  usageLimit?: InputMaybe<NumberOperators>;
};

export type PromotionList = PaginatedList & {
  __typename?: 'PromotionList';
  items: Array<Promotion>;
  totalItems: Scalars['Int']['output'];
};

export type PromotionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PromotionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PromotionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionSortParameter = {
  couponCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  perCustomerUsageLimit?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageLimit?: InputMaybe<SortOrder>;
};

export type PromotionTranslation = {
  __typename?: 'PromotionTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Province = Node & Region & {
  __typename?: 'Province';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProvinceCustomFields>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProvinceCustomFields = {
  __typename?: 'ProvinceCustomFields';
  currencyCode?: Maybe<Scalars['String']['output']>;
};

export type ProvinceFilterParameter = {
  _and?: InputMaybe<Array<ProvinceFilterParameter>>;
  _or?: InputMaybe<Array<ProvinceFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProvinceList = PaginatedList & {
  __typename?: 'ProvinceList';
  items: Array<Province>;
  totalItems: Scalars['Int']['output'];
};

export type ProvinceListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProvinceFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProvinceSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProvinceSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProvinceTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PurchBatchList = {
  batchMemo?: InputMaybe<Scalars['String']['input']>;
  batchNo?: InputMaybe<Scalars['String']['input']>;
  detailId?: InputMaybe<Scalars['String']['input']>;
  exprirationDate?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  productionDate?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  shelfLife?: InputMaybe<Scalars['Float']['input']>;
  shelfLiftUnit?: InputMaybe<Scalars['String']['input']>;
};

export type PurchExpressInfo = {
  receive?: InputMaybe<Scalars['String']['input']>;
  receiveAddress?: InputMaybe<Scalars['String']['input']>;
  receiveCityName?: InputMaybe<Scalars['String']['input']>;
  receiveCompanyName?: InputMaybe<Scalars['String']['input']>;
  receiveCountryName?: InputMaybe<Scalars['String']['input']>;
  receiveEmail?: InputMaybe<Scalars['String']['input']>;
  receivePhone?: InputMaybe<Scalars['String']['input']>;
  receiveProvinceName?: InputMaybe<Scalars['String']['input']>;
  receiveTel?: InputMaybe<Scalars['String']['input']>;
  receiveTownName?: InputMaybe<Scalars['String']['input']>;
  send?: InputMaybe<Scalars['String']['input']>;
  sendAddress?: InputMaybe<Scalars['String']['input']>;
  sendCityName?: InputMaybe<Scalars['String']['input']>;
  sendCompanyName?: InputMaybe<Scalars['String']['input']>;
  sendCountryName?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['String']['input']>;
  sendPhone?: InputMaybe<Scalars['String']['input']>;
  sendProvinceName?: InputMaybe<Scalars['String']['input']>;
  sendStreetName?: InputMaybe<Scalars['String']['input']>;
  sendTel?: InputMaybe<Scalars['String']['input']>;
  sendTownName?: InputMaybe<Scalars['String']['input']>;
};

export type PurchList = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  detailField1?: InputMaybe<Scalars['String']['input']>;
  detailField2?: InputMaybe<Scalars['String']['input']>;
  detailField3?: InputMaybe<Scalars['String']['input']>;
  detailField4?: InputMaybe<Scalars['String']['input']>;
  detailField5?: InputMaybe<Scalars['String']['input']>;
  isBatch?: InputMaybe<Scalars['Int']['input']>;
  noTaxAmount?: InputMaybe<Scalars['Float']['input']>;
  outSkuCode?: InputMaybe<Scalars['String']['input']>;
  payableAmount?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  quantity: Scalars['String']['input'];
  recDate?: InputMaybe<Scalars['String']['input']>;
  rowRemark?: InputMaybe<Scalars['String']['input']>;
  skuBarcode?: InputMaybe<Scalars['String']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxPrice: Scalars['Float']['input'];
  taxrate?: InputMaybe<Scalars['Float']['input']>;
  unitName: Scalars['String']['input'];
  wentDutch?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseGetOptions = {
  auditUserId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endModifyDate?: InputMaybe<Scalars['String']['input']>;
  endProvDate?: InputMaybe<Scalars['String']['input']>;
  orderNums?: InputMaybe<Scalars['String']['input']>;
  outSkuCode?: InputMaybe<Scalars['String']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  revwStatus?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startModifyDate?: InputMaybe<Scalars['String']['input']>;
  startProvDate?: InputMaybe<Scalars['String']['input']>;
  vendOrderIds?: InputMaybe<Scalars['String']['input']>;
  warehouseCode?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseRequestCronjob = Node & {
  __typename?: 'PurchaseRequestCronjob';
  createdAt: Scalars['DateTime']['output'];
  everyHour: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<Product>>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseRequestCronjobFilterParameter = {
  _and?: InputMaybe<Array<PurchaseRequestCronjobFilterParameter>>;
  _or?: InputMaybe<Array<PurchaseRequestCronjobFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  everyHour?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PurchaseRequestCronjobList = PaginatedList & {
  __typename?: 'PurchaseRequestCronjobList';
  items: Array<PurchaseRequestCronjob>;
  totalItems: Scalars['Int']['output'];
};

export type PurchaseRequestCronjobListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PurchaseRequestCronjobFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PurchaseRequestCronjobSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseRequestCronjobSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  everyHour?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PushNotification = Node & {
  __typename?: 'PushNotification';
  body: Scalars['String']['output'];
  clickAction: ClickAction;
  clickActionData?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDevelopment: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  targets: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PushNotificationFilterParameter = {
  _and?: InputMaybe<Array<PushNotificationFilterParameter>>;
  _or?: InputMaybe<Array<PushNotificationFilterParameter>>;
  body?: InputMaybe<StringOperators>;
  clickAction?: InputMaybe<StringOperators>;
  clickActionData?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isDevelopment?: InputMaybe<BooleanOperators>;
  isScheduled?: InputMaybe<BooleanOperators>;
  scheduledTime?: InputMaybe<DateOperators>;
  title?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PushNotificationList = PaginatedList & {
  __typename?: 'PushNotificationList';
  items: Array<PushNotification>;
  totalItems: Scalars['Int']['output'];
};

export type PushNotificationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PushNotificationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PushNotificationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PushNotificationSortParameter = {
  body?: InputMaybe<SortOrder>;
  clickActionData?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scheduledTime?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PushTemplate = Node & {
  __typename?: 'PushTemplate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  translations: Array<PushTemplateTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PushTemplateFilterParameter = {
  _and?: InputMaybe<Array<PushTemplateFilterParameter>>;
  _or?: InputMaybe<Array<PushTemplateFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PushTemplateList = PaginatedList & {
  __typename?: 'PushTemplateList';
  items: Array<PushTemplate>;
  totalItems: Scalars['Int']['output'];
};

export type PushTemplateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PushTemplateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PushTemplateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PushTemplateSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PushTemplateTranslation = Node & {
  __typename?: 'PushTemplateTranslation';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PushTemplateTranslationInput = {
  body: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Returned if the specified quantity of an OrderLine is greater than the number of items in that line */
export type QuantityTooGreatError = ErrorResult & {
  __typename?: 'QuantityTooGreatError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeAdministrator?: Maybe<Administrator>;
  activeBanner?: Maybe<Banner>;
  activeBanners: BannerList;
  activeChannel: Channel;
  administrator?: Maybe<Administrator>;
  administrators: AdministratorList;
  alert?: Maybe<Alert>;
  alerts: AlertList;
  allCrons?: Maybe<Scalars['JSON']['output']>;
  artist?: Maybe<Artist>;
  artists: ArtistList;
  /** Get a single Asset by id */
  asset?: Maybe<Asset>;
  /** Get a list of Assets */
  assets: AssetList;
  auditRequest?: Maybe<AuditRequest>;
  auditRequests: AuditRequestList;
  banner?: Maybe<Banner>;
  banners: BannerList;
  businessSupplierFiles: AssetList;
  calulateShippingCost: Scalars['Int']['output'];
  calulateShippingCostForProduct: Scalars['Int']['output'];
  channel?: Maybe<Channel>;
  channels: ChannelList;
  checkExpiredProductRequestPurchase?: Maybe<Scalars['JSON']['output']>;
  checkInboundStatus?: Maybe<Scalars['JSON']['output']>;
  checkProductRequestPurchase?: Maybe<Scalars['JSON']['output']>;
  /** Get a Collection either by id or slug. If neither id nor slug is specified, an error will result. */
  collection?: Maybe<Collection>;
  collectionFilters: Array<ConfigurableOperationDefinition>;
  collections: CollectionList;
  cooperateMembers: CustomerList;
  countViewsByFanClubLink: Scalars['Int']['output'];
  countries: CountryList;
  country?: Maybe<Country>;
  customer?: Maybe<Customer>;
  customerCountry?: Maybe<CustomerCountry>;
  customerGroup?: Maybe<CustomerGroup>;
  customerGroups: CustomerGroupList;
  customers: CustomerList;
  customersForCoupon: CustomerList;
  customsClearance?: Maybe<CustomsClearance>;
  defaultEventConsentContent?: Maybe<DefaultEventConsentContent>;
  defaultEventConsentContentTranslation?: Maybe<DefaultEventConsentContentTranslation>;
  defaultEventConsentContentTranslations: DefaultEventConsentContentTranslationList;
  defaultEventConsentContents: DefaultEventConsentContentList;
  defaultProductDescription: DefaultProductDescription;
  defaultProductDescriptionTranslation: DefaultProductDescriptionTranslation;
  defaultProductDescriptionTranslations: DefaultProductDescriptionTranslationList;
  defaultProductDescriptions: DefaultProductDescriptionList;
  defaultProductInformation?: Maybe<DefaultProductInformation>;
  defaultProductInformations: DefaultProductInformationList;
  /** Returns a list of eligible shipping methods for the draft Order */
  eligibleShippingMethodsForDraftOrder: Array<ShippingMethodQuote>;
  emailTemplate?: Maybe<EmailTemplate>;
  emailTemplateByCode?: Maybe<EmailTemplate>;
  emailTemplateByCodeAndLanguage?: Maybe<EmailTemplateTranslation>;
  emailTemplateTranslation?: Maybe<EmailTemplateTranslation>;
  emailTemplates: EmailTemplateList;
  /** Returns all configured EntityDuplicators. */
  entityDuplicators: Array<EntityDuplicatorDefinition>;
  eventApplicant?: Maybe<FanClubEvent>;
  eventApplicants: EventApplicantList;
  eventIdols: EventIdolList;
  eventMetrics: Array<EventMetricSummary>;
  eventProducts: ProductList;
  exchangeRate: PriceExchangeRate;
  exchangeRateByCountryCode: PriceExchangeRate;
  exchangeRateByCountryId: PriceExchangeRate;
  exchangeRates: PriceExchangeRateList;
  facet?: Maybe<Facet>;
  facetValues: FacetValueList;
  facets: FacetList;
  fanClub?: Maybe<FanClub>;
  fanClubAdmins: CustomerList;
  fanClubEditRequest?: Maybe<FanClubEditRequest>;
  fanClubEvent?: Maybe<FanClubEvent>;
  fanClubEvents: FanClubEventList;
  fanClubGroup?: Maybe<FanClubGroup>;
  fanClubGroupByFanClubId?: Maybe<FanClubGroup>;
  fanClubGroups: FanClubGroupList;
  fanClubLink?: Maybe<FanClubLink>;
  fanClubLinkBySlug?: Maybe<FanClubLink>;
  fanClubLinkCheckboxs?: Maybe<Array<ConfirmationCheckbox>>;
  fanClubLinkInvoiceHistoryList?: Maybe<FanClubLinkInvoiceHistoryList>;
  fanClubLinkMissions: FanClubLinkMissionList;
  fanClubLinkOrders: OrderList;
  fanClubLinks: FanClubLinkList;
  fanClubMember?: Maybe<FanClubMember>;
  fanClubMembers: FanClubMemberList;
  fanClubOrder?: Maybe<OrderLine>;
  fanClubOrders: FanClubOrderList;
  fanClubPointHistories: FanClubPointHistoryList;
  fanClubs: FanClubList;
  filterProductByPrice: ProductList;
  findByListofDeviceToken: Array<UserDevice>;
  findCustomerByPhoneNumber: Scalars['Boolean']['output'];
  findSplitOrderByPackageReviewId?: Maybe<SplitOrder>;
  freeGiftProducts: ProductList;
  freeGiftSelection?: Maybe<FreeGiftSelection>;
  freeGiftSelectionByProductId?: Maybe<FreeGiftSelection>;
  freeGiftSelections: FreeGiftSelectionList;
  freeGiftSelectionsFromActiveOrder?: Maybe<Array<FreeGiftSelection>>;
  freeGiftSelectionsFromOrder?: Maybe<Array<FreeGiftSelection>>;
  freeGifts: ProductVariantList;
  fulfillmentHandlers: Array<ConfigurableOperationDefinition>;
  generalMembers: CustomerList;
  generateCouponCode?: Maybe<Scalars['String']['output']>;
  generateProductSlug: Scalars['String']['output'];
  generateSku: Scalars['String']['output'];
  getAllRegion: Array<Maybe<Area>>;
  getCity?: Maybe<Place>;
  getCustomsClearanceFiles: AssetList;
  getDefault: PriceExchangeRate;
  getDefaultTemplate?: Maybe<Scalars['String']['output']>;
  getDistrict?: Maybe<Place>;
  getEventOrderCountByLinkId: Scalars['Int']['output'];
  getGiftSelectionByProductId?: Maybe<FreeGiftSelection>;
  getLatestOrderAwaitPayment?: Maybe<Order>;
  getLinkVariantPriceById: LinkVariantPrice;
  getNextLevel?: Maybe<UserLevel>;
  getProvince?: Maybe<Place>;
  getPushNotification?: Maybe<PushNotification>;
  getPushNotifications: PushNotificationList;
  getSaleAbleStock: Scalars['Int']['output'];
  getSpecsByProductVariantId: Array<ProductSpecification>;
  getStorefrontUrl?: Maybe<Scalars['String']['output']>;
  getUserDeviceByToken?: Maybe<UserDevice>;
  getUserDevicesByCustomerId: UserDeviceList;
  getUserPushoNotifications: Array<PushNotification>;
  globalSettings: GlobalSettings;
  goods: Scalars['JSON']['output'];
  guidance?: Maybe<Guidance>;
  guidanceByLocationId?: Maybe<Guidance>;
  guidances: GuidanceList;
  histories: HistoryEntryList;
  history?: Maybe<HistoryEntry>;
  homepageProducts: HomepageProductList;
  inboundApproveRequest?: Maybe<InboundApproveRequest>;
  inboundApproveRequests: InboundApproveRequestList;
  inbounding?: Maybe<Inbounding>;
  inboundingToApprove?: Maybe<Inbounding>;
  inboundings: InboundingList;
  inboundingsToApprove: InboundingList;
  job?: Maybe<Job>;
  jobBufferSize: Array<JobBufferSize>;
  jobQueues: Array<JobQueue>;
  jobs: JobList;
  jobsById: Array<Job>;
  latestAlert?: Maybe<Alert>;
  linkCheckBox?: Maybe<ConfirmationCheckbox>;
  me?: Maybe<CurrentUser>;
  /** Get metrics for the given interval and metric types. */
  metricSummary: Array<MetricSummary>;
  needToShipProduct?: Maybe<NeedToShipProductDetail>;
  needToShipProducts: NeedToShipProductList;
  notice: Notice;
  notices: NoticeList;
  order?: Maybe<Order>;
  orderLinesByOrderId: Array<OrderLine>;
  orders: OrderList;
  package?: Maybe<Package>;
  packageReview?: Maybe<PackageReview>;
  packageReviewSummaryProducts: PackageReviewSummaryProductList;
  packageReviews: PackageReviewList;
  packages: PackageList;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodEligibilityCheckers: Array<ConfigurableOperationDefinition>;
  paymentMethodHandlers: Array<ConfigurableOperationDefinition>;
  paymentMethods: PaymentMethodList;
  pendingSearchIndexUpdates: Scalars['Int']['output'];
  /** Used for real-time previews of the contents of a Collection */
  previewCollectionVariants: ProductVariantList;
  /** Get a Product either by id or slug. If neither id nor slug is specified, an error will result. */
  product?: Maybe<Product>;
  productOptionGroup?: Maybe<ProductOptionGroup>;
  productOptionGroups: Array<ProductOptionGroup>;
  productPurchaseCronJobs?: Maybe<Array<Maybe<PurchaseRequestCronjob>>>;
  productSale: Scalars['Int']['output'];
  productSpecification?: Maybe<ProductSpecification>;
  productSpecifications: ProductSpecificationList;
  productStatistic: ProductStatistic;
  productType?: Maybe<ProductType>;
  productTypes: ProductTypeList;
  /** Get a ProductVariant by id */
  productVariant?: Maybe<ProductVariant>;
  /** List ProductVariants either all or for the specific product. */
  productVariants: ProductVariantList;
  productVariantsFilterFreeGift: ProductVariantList;
  /** List Products */
  products: ProductList;
  productsAdvanced: ProductList;
  productsAdvancedTest: ProductList;
  productsFilterFreeGift: ProductList;
  promotion?: Maybe<Promotion>;
  promotionActions: Array<ConfigurableOperationDefinition>;
  promotionConditions: Array<ConfigurableOperationDefinition>;
  promotions: PromotionList;
  province?: Maybe<Province>;
  provinces: ProvinceList;
  purchaseRequestCronjob?: Maybe<PurchaseRequestCronjob>;
  purchaseRequestCronjobs: PurchaseRequestCronjobList;
  purchases: Scalars['JSON']['output'];
  pushTemplate?: Maybe<PushTemplate>;
  pushTemplates: PushTemplateList;
  questionPost: QuestionPost;
  questionPosts: QuestionPostList;
  refundRequest: RefundRequest;
  refundRequestFromOrder?: Maybe<RefundRequest>;
  refundRequests: RefundRequestList;
  relatedLinks?: Maybe<Array<FanClubLink>>;
  relatedProducts?: Maybe<Array<Product>>;
  requestPurchase?: Maybe<RequestPurchase>;
  requestPurchaseGroup?: Maybe<RequestPurchaseGroup>;
  requestPurchaseGroups: RequestPurchaseGroupList;
  requestPurchases: RequestPurchaseList;
  retail?: Maybe<Retail>;
  retailerFiles: AssetList;
  retails: RetailList;
  role?: Maybe<Role>;
  roles: RoleList;
  search: SearchResponse;
  seller?: Maybe<Seller>;
  sellers: SellerList;
  serviceFee?: Maybe<ServiceFee>;
  serviceFees: ServiceFeeList;
  shipmentStatusByOrderId?: Maybe<ShipmentStatus>;
  shippables: ShippableList;
  shippablesToApprove: ShippableList;
  shipping?: Maybe<Shipping>;
  shippingCalculators: Array<ConfigurableOperationDefinition>;
  shippingEligibilityCheckers: Array<ConfigurableOperationDefinition>;
  shippingFee?: Maybe<ShippingFee>;
  shippingFeeCountries: ShippingFeeCountryList;
  shippingFeeCountry?: Maybe<ShippingFeeCountry>;
  shippingFeeFreeGiftQuantities: ShippingFeeFreeGiftQuantityList;
  shippingFeeFreeGiftQuantity?: Maybe<ShippingFeeFreeGiftQuantity>;
  shippingFeeQuantites: ShippingFeeQuantityList;
  shippingFeeQuantity?: Maybe<ShippingFeeQuantity>;
  shippingFeeWeight?: Maybe<ShippingFeeWeight>;
  shippingFeeWeights: ShippingFeeWeightList;
  shippingFees: ShippingFeeList;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingMethodFromCountry?: Maybe<Array<ShippingMethod>>;
  shippingMethods: ShippingMethodList;
  shippings: ShippingList;
  shopSupplier?: Maybe<ShopSupplier>;
  shopSupplierFiles: AssetList;
  shopSuppliers: ShopSupplierList;
  smsTemplate?: Maybe<SmsTemplate>;
  smsTemplateByCode?: Maybe<SmsTemplate>;
  smsTemplates: SmsTemplateList;
  sortProductsByPrice: ProductList;
  sortProductsByStock: ProductList;
  splitOrder?: Maybe<SplitOrder>;
  splitOrderByOrderId?: Maybe<SplitOrder>;
  splitOrderRule?: Maybe<SplitOrderRule>;
  splitOrderRuleByProductId?: Maybe<SplitOrderRule>;
  splitOrderRules: SplitOrderRuleList;
  splitOrders: SplitOrderList;
  staticPage?: Maybe<StaticPage>;
  staticPageClassification?: Maybe<StaticPageClassification>;
  staticPageClassifications: StaticPageClassificationList;
  staticPages: StaticPageList;
  stockLocation?: Maybe<StockLocation>;
  stockLocations: StockLocationList;
  stockin: Scalars['JSON']['output'];
  supplier: Scalars['JSON']['output'];
  suppliers: Scalars['JSON']['output'];
  syncStock?: Maybe<Scalars['Boolean']['output']>;
  tag: Tag;
  tags: TagList;
  taxCategories: TaxCategoryList;
  taxCategory?: Maybe<TaxCategory>;
  taxRate?: Maybe<TaxRate>;
  taxRates: TaxRateList;
  testCreateCompany: Scalars['String']['output'];
  testEligibleShippingMethods: Array<ShippingMethodQuote>;
  testExpriredEvents?: Maybe<Scalars['JSON']['output']>;
  testExpriredProducts?: Maybe<Scalars['JSON']['output']>;
  testPurchaseNeeded?: Maybe<Scalars['JSON']['output']>;
  testQueryProduct: Scalars['String']['output'];
  testShippingMethod: TestShippingMethodResult;
  ticket?: Maybe<Ticket>;
  tickets: TicketList;
  totalLinkStatisticByProduct: TotalLinkStatistic;
  userDevice?: Maybe<UserDevice>;
  userDevices: UserDeviceList;
  userLevel?: Maybe<UserLevel>;
  userLevels: UserLevelList;
  userPoint?: Maybe<UserPoint>;
  userPoints: UserPointList;
  variantFreeGiftSelectionsFromProductId: Array<FreeGiftSelection>;
  verifyChinaId: VerifyChinaIdResult;
  warehouse?: Maybe<Warehouse>;
  warehouses: WarehouseList;
  warehousesFromApi?: Maybe<Scalars['JSON']['output']>;
  zone?: Maybe<Zone>;
  zones: ZoneList;
};


export type QueryActiveBannersArgs = {
  options?: InputMaybe<BannerListOptions>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdministratorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdministratorsArgs = {
  options?: InputMaybe<AdministratorListOptions>;
};


export type QueryAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlertsArgs = {
  options?: InputMaybe<AlertListOptions>;
};


export type QueryArtistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtistsArgs = {
  options?: InputMaybe<ArtistListOptions>;
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetsArgs = {
  options?: InputMaybe<AssetListOptions>;
};


export type QueryAuditRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditRequestsArgs = {
  options?: InputMaybe<AuditRequestListOptions>;
};


export type QueryBannerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBannersArgs = {
  options?: InputMaybe<BannerListOptions>;
};


export type QueryBusinessSupplierFilesArgs = {
  code: Scalars['String']['input'];
  options?: InputMaybe<AssetListOptions>;
};


export type QueryCalulateShippingCostArgs = {
  input: CalculateShippingCostInput;
};


export type QueryCalulateShippingCostForProductArgs = {
  input: CalculateShippingCostProductInput;
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelsArgs = {
  options?: InputMaybe<ChannelListOptions>;
};


export type QueryCheckProductRequestPurchaseArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionsArgs = {
  options?: InputMaybe<CollectionListOptions>;
};


export type QueryCooperateMembersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryCountViewsByFanClubLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountriesArgs = {
  options?: InputMaybe<CountryListOptions>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerGroupsArgs = {
  options?: InputMaybe<CustomerGroupListOptions>;
};


export type QueryCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryCustomersForCouponArgs = {
  ops?: InputMaybe<CustomerCouponFilter>;
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryCustomsClearanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDefaultEventConsentContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultEventConsentContentTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultEventConsentContentTranslationsArgs = {
  options?: InputMaybe<DefaultEventConsentContentTranslationListOptions>;
};


export type QueryDefaultEventConsentContentsArgs = {
  options?: InputMaybe<DefaultEventConsentContentListOptions>;
};


export type QueryDefaultProductDescriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultProductDescriptionTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultProductDescriptionTranslationsArgs = {
  options?: InputMaybe<DefaultProductDescriptionTranslationListOptions>;
};


export type QueryDefaultProductDescriptionsArgs = {
  options?: InputMaybe<DefaultProductDescriptionListOptions>;
};


export type QueryDefaultProductInformationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultProductInformationsArgs = {
  options?: InputMaybe<DefaultProductInformationListOptions>;
};


export type QueryEligibleShippingMethodsForDraftOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplateByCodeArgs = {
  code: EmailTemplateCode;
};


export type QueryEmailTemplateByCodeAndLanguageArgs = {
  code: EmailTemplateCode;
  languageCode: Scalars['String']['input'];
};


export type QueryEmailTemplateTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplatesArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryEventApplicantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventApplicantsArgs = {
  options?: InputMaybe<EventApplicantListOptions>;
};


export type QueryEventIdolsArgs = {
  options?: InputMaybe<EventIdolListOptions>;
};


export type QueryEventMetricsArgs = {
  input?: InputMaybe<EventStatisticsInput>;
};


export type QueryEventProductsArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<ProductListOptions>;
};


export type QueryExchangeRateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExchangeRateByCountryCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryExchangeRateByCountryIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExchangeRatesArgs = {
  options?: InputMaybe<PriceExchangeRateListOptions>;
};


export type QueryFacetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacetValuesArgs = {
  options?: InputMaybe<FacetValueListOptions>;
};


export type QueryFacetsArgs = {
  options?: InputMaybe<FacetListOptions>;
};


export type QueryFanClubArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubAdminsArgs = {
  fanClubId: Scalars['ID']['input'];
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryFanClubEditRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubEventsArgs = {
  extend?: InputMaybe<FanClubEventExtendedListOptions>;
  options?: InputMaybe<FanClubEventListOptions>;
};


export type QueryFanClubGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubGroupByFanClubIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubGroupsArgs = {
  options?: InputMaybe<FanClubGroupListOptions>;
};


export type QueryFanClubLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubLinkBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFanClubLinkCheckboxsArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryFanClubLinkInvoiceHistoryListArgs = {
  options?: InputMaybe<FanClubLinkInvoiceHistoryListOptions>;
};


export type QueryFanClubLinkMissionsArgs = {
  options?: InputMaybe<FanClubLinkMissionListOptions>;
};


export type QueryFanClubLinkOrdersArgs = {
  linkId: Scalars['ID']['input'];
  options?: InputMaybe<OrderListOptions>;
};


export type QueryFanClubLinksArgs = {
  options?: InputMaybe<FanClubLinkListOptions>;
};


export type QueryFanClubMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubMembersArgs = {
  options?: InputMaybe<FanClubMemberListOptions>;
};


export type QueryFanClubOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFanClubOrdersArgs = {
  options?: InputMaybe<FanClubOrderListOptions>;
};


export type QueryFanClubPointHistoriesArgs = {
  options?: InputMaybe<FanClubPointHistoryListOptions>;
};


export type QueryFanClubsArgs = {
  options?: InputMaybe<FanClubListOptions>;
};


export type QueryFilterProductByPriceArgs = {
  from: Scalars['Int']['input'];
  options?: InputMaybe<ProductListOptions>;
  to: Scalars['Int']['input'];
};


export type QueryFindByListofDeviceTokenArgs = {
  tokens: Array<Scalars['String']['input']>;
};


export type QueryFindCustomerByPhoneNumberArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindSplitOrderByPackageReviewIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFreeGiftProductsArgs = {
  options?: InputMaybe<ProductListOptions>;
};


export type QueryFreeGiftSelectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFreeGiftSelectionByProductIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFreeGiftSelectionsArgs = {
  options?: InputMaybe<FreeGiftSelectionListOptions>;
};


export type QueryFreeGiftSelectionsFromOrderArgs = {
  code: Scalars['String']['input'];
};


export type QueryFreeGiftsArgs = {
  artistId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<ProductVariantListOptions>;
  retailerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGeneralMembersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryGenerateProductSlugArgs = {
  input: GenerateProductSlugInput;
};


export type QueryGenerateSkuArgs = {
  variantId: Scalars['ID']['input'];
};


export type QueryGetCityArgs = {
  cityId: Scalars['String']['input'];
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomsClearanceFilesArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<AssetListOptions>;
};


export type QueryGetDefaultTemplateArgs = {
  code: EmailTemplateCode;
};


export type QueryGetDistrictArgs = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  districtId: Scalars['String']['input'];
};


export type QueryGetEventOrderCountByLinkIdArgs = {
  eventId: Scalars['ID']['input'];
  linkId: Scalars['ID']['input'];
};


export type QueryGetGiftSelectionByProductIdArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetLinkVariantPriceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProvinceArgs = {
  provinceId: Scalars['String']['input'];
};


export type QueryGetPushNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPushNotificationsArgs = {
  options?: InputMaybe<PushNotificationListOptions>;
};


export type QueryGetSaleAbleStockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSpecsByProductVariantIdArgs = {
  productVariantId: Scalars['ID']['input'];
};


export type QueryGetUserDeviceByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetUserDevicesByCustomerIdArgs = {
  options?: InputMaybe<UserDeviceListOptions>;
};


export type QueryGoodsArgs = {
  options?: InputMaybe<GoodsGetInput>;
};


export type QueryGuidanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGuidanceByLocationIdArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryGuidancesArgs = {
  options?: InputMaybe<GuidanceListOptions>;
};


export type QueryHistoriesArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};


export type QueryHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundApproveRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundApproveRequestsArgs = {
  options?: InputMaybe<InboundApproveRequestListOptions>;
};


export type QueryInboundingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundingToApproveArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundingsArgs = {
  options?: InputMaybe<InboundingListOptions>;
};


export type QueryInboundingsToApproveArgs = {
  options?: InputMaybe<InboundingListOptions>;
};


export type QueryJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobBufferSizeArgs = {
  bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryJobsArgs = {
  options?: InputMaybe<JobListOptions>;
};


export type QueryJobsByIdArgs = {
  jobIds: Array<Scalars['ID']['input']>;
};


export type QueryLinkCheckBoxArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetricSummaryArgs = {
  input?: InputMaybe<MetricSummaryInput>;
};


export type QueryNeedToShipProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNeedToShipProductsArgs = {
  options?: InputMaybe<NeedToShipProductOptions>;
};


export type QueryNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoticesArgs = {
  options?: InputMaybe<NoticeListOptions>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderLinesByOrderIdArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrdersArgs = {
  options?: InputMaybe<OrderListOptions>;
};


export type QueryPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPackageReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPackageReviewSummaryProductsArgs = {
  options?: InputMaybe<PackageReviewSummaryProductListOptions>;
};


export type QueryPackageReviewsArgs = {
  options?: InputMaybe<PackageReviewListOptions>;
};


export type QueryPackagesArgs = {
  options?: InputMaybe<PackageListOptions>;
};


export type QueryPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentMethodsArgs = {
  options?: InputMaybe<PaymentMethodListOptions>;
};


export type QueryPreviewCollectionVariantsArgs = {
  input: PreviewCollectionVariantsInput;
  options?: InputMaybe<ProductVariantListOptions>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductOptionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductOptionGroupsArgs = {
  filterTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductPurchaseCronJobsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryProductSaleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductSpecificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductSpecificationsArgs = {
  options?: InputMaybe<ProductSpecificationListOptions>;
};


export type QueryProductStatisticArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ProductStatisticOptions>;
};


export type QueryProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductTypesArgs = {
  options?: InputMaybe<ProductTypeListOptions>;
};


export type QueryProductVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductVariantsFilterFreeGiftArgs = {
  isFreeGift: Scalars['Boolean']['input'];
  options?: InputMaybe<ProductVariantListOptions>;
};


export type QueryProductsArgs = {
  options?: InputMaybe<ProductListOptions>;
};


export type QueryProductsAdvancedArgs = {
  ops?: InputMaybe<ProductAdvancedOps>;
  options?: InputMaybe<ProductListOptions>;
};


export type QueryProductsAdvancedTestArgs = {
  ops?: InputMaybe<ProductAdvancedOps>;
  options?: InputMaybe<ProductListOptions>;
};


export type QueryProductsFilterFreeGiftArgs = {
  filterInRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeGift: Scalars['Boolean']['input'];
  options?: InputMaybe<ProductListOptions>;
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionsArgs = {
  options?: InputMaybe<PromotionListOptions>;
};


export type QueryProvinceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProvincesArgs = {
  options?: InputMaybe<ProvinceListOptions>;
};


export type QueryPurchaseRequestCronjobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseRequestCronjobsArgs = {
  options?: InputMaybe<PurchaseRequestCronjobListOptions>;
};


export type QueryPurchasesArgs = {
  options?: InputMaybe<PurchaseGetOptions>;
};


export type QueryPushTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPushTemplatesArgs = {
  options?: InputMaybe<PushTemplateListOptions>;
};


export type QueryQuestionPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionPostsArgs = {
  options?: InputMaybe<QuestionPostListOptions>;
};


export type QueryRefundRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRefundRequestFromOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryRefundRequestsArgs = {
  options?: InputMaybe<RefundRequestListOptions>;
};


export type QueryRelatedLinksArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryRelatedProductsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestPurchaseGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestPurchaseGroupsArgs = {
  options?: InputMaybe<RequestPurchaseGroupListOptions>;
};


export type QueryRequestPurchasesArgs = {
  options?: InputMaybe<RequestPurchaseListOptions>;
};


export type QueryRetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetailerFilesArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<AssetListOptions>;
};


export type QueryRetailsArgs = {
  options?: InputMaybe<RetailListOptions>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  options?: InputMaybe<RoleListOptions>;
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySellerArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySellersArgs = {
  options?: InputMaybe<SellerListOptions>;
};


export type QueryServiceFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceFeesArgs = {
  options?: InputMaybe<ServiceFeeListOptions>;
};


export type QueryShipmentStatusByOrderIdArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryShippablesArgs = {
  options?: InputMaybe<ShippableListOptions>;
};


export type QueryShippablesToApproveArgs = {
  options?: InputMaybe<ShippableListOptions>;
};


export type QueryShippingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeCountriesArgs = {
  options?: InputMaybe<ShippingFeeCountryListOptions>;
};


export type QueryShippingFeeCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeFreeGiftQuantitiesArgs = {
  options?: InputMaybe<ShippingFeeFreeGiftQuantityListOptions>;
};


export type QueryShippingFeeFreeGiftQuantityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeQuantitesArgs = {
  options?: InputMaybe<ShippingFeeQuantityListOptions>;
};


export type QueryShippingFeeQuantityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeWeightArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingFeeWeightsArgs = {
  options?: InputMaybe<ShippingFeeWeightListOptions>;
};


export type QueryShippingFeesArgs = {
  options?: InputMaybe<ShippingFeeListOptions>;
};


export type QueryShippingMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingMethodFromCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingMethodsArgs = {
  options?: InputMaybe<ShippingMethodListOptions>;
};


export type QueryShippingsArgs = {
  options?: InputMaybe<ShippingListOptions>;
};


export type QueryShopSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShopSupplierFilesArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<AssetListOptions>;
};


export type QueryShopSuppliersArgs = {
  options?: InputMaybe<ShopSupplierListOptions>;
};


export type QuerySmsTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsTemplateByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QuerySmsTemplatesArgs = {
  options?: InputMaybe<SmsTemplateListOptions>;
};


export type QuerySortProductsByPriceArgs = {
  options?: InputMaybe<ProductListOptions>;
  sort?: InputMaybe<SortOrder>;
};


export type QuerySortProductsByStockArgs = {
  options?: InputMaybe<ProductListOptions>;
  sort?: InputMaybe<SortOrder>;
};


export type QuerySplitOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySplitOrderByOrderIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySplitOrderRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySplitOrderRuleByProductIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySplitOrderRulesArgs = {
  options?: InputMaybe<SplitOrderRuleListOptions>;
};


export type QuerySplitOrdersArgs = {
  options?: InputMaybe<SplitOrderListOptions>;
};


export type QueryStaticPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaticPageClassificationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStaticPageClassificationsArgs = {
  options?: InputMaybe<StaticPageClassificationListOptions>;
};


export type QueryStaticPagesArgs = {
  options?: InputMaybe<StaticPageListOptions>;
};


export type QueryStockLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStockLocationsArgs = {
  options?: InputMaybe<StockLocationListOptions>;
};


export type QueryStockinArgs = {
  options?: InputMaybe<StockinGetInput>;
};


export type QuerySupplierArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuppliersArgs = {
  options?: InputMaybe<SupplierGetInput>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagsArgs = {
  options?: InputMaybe<TagListOptions>;
};


export type QueryTaxCategoriesArgs = {
  options?: InputMaybe<TaxCategoryListOptions>;
};


export type QueryTaxCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxRateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxRatesArgs = {
  options?: InputMaybe<TaxRateListOptions>;
};


export type QueryTestEligibleShippingMethodsArgs = {
  input: TestEligibleShippingMethodsInput;
};


export type QueryTestQueryProductArgs = {
  name: Scalars['String']['input'];
};


export type QueryTestShippingMethodArgs = {
  input: TestShippingMethodInput;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketsArgs = {
  options?: InputMaybe<TicketListOptions>;
};


export type QueryTotalLinkStatisticByProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDevicesArgs = {
  options?: InputMaybe<UserDeviceListOptions>;
};


export type QueryUserLevelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserLevelsArgs = {
  options?: InputMaybe<UserLevelListOptions>;
};


export type QueryUserPointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPointsArgs = {
  options?: InputMaybe<UserPointListOptions>;
};


export type QueryVariantFreeGiftSelectionsFromProductIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVerifyChinaIdArgs = {
  input?: InputMaybe<VerifyChinaIdInput>;
};


export type QueryWarehouseArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWarehousesArgs = {
  options?: InputMaybe<WarehouseListOptions>;
};


export type QueryWarehousesFromApiArgs = {
  options?: InputMaybe<WarehouseListOptions>;
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZonesArgs = {
  options?: InputMaybe<ZoneListOptions>;
};

export type QuestionPost = Node & {
  __typename?: 'QuestionPost';
  comments?: Maybe<Array<QuestionPostComment>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  files?: Maybe<Array<Asset>>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  secret: Scalars['Boolean']['output'];
  status: QuestionPostStatus;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionPostType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type QuestionPostComment = Node & {
  __typename?: 'QuestionPostComment';
  administrator?: Maybe<CommentAdmin>;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  post: QuestionPost;
  postId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type QuestionPostFilterParameter = {
  _and?: InputMaybe<Array<QuestionPostFilterParameter>>;
  _or?: InputMaybe<Array<QuestionPostFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isDeleted?: InputMaybe<BooleanOperators>;
  orderId?: InputMaybe<IdOperators>;
  productId?: InputMaybe<IdOperators>;
  secret?: InputMaybe<BooleanOperators>;
  status?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  userId?: InputMaybe<IdOperators>;
};

export type QuestionPostList = PaginatedList & {
  __typename?: 'QuestionPostList';
  items: Array<QuestionPost>;
  totalItems: Scalars['Int']['output'];
};

export type QuestionPostListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<QuestionPostFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<QuestionPostSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionPostSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum QuestionPostStatus {
  Answered = 'Answered',
  WaitResponse = 'WaitResponse'
}

export enum QuestionPostType {
  Customer = 'Customer',
  Order = 'Order',
  Product = 'Product'
}

export type Refund = Node & {
  __typename?: 'Refund';
  adjustment: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items: Scalars['Money']['output'];
  lines: Array<RefundLine>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  total: Scalars['Money']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned if `amount` is greater than the maximum un-refunded amount of the Payment */
export type RefundAmountError = ErrorResult & {
  __typename?: 'RefundAmountError';
  errorCode: ErrorCode;
  maximumRefundable: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type RefundLine = {
  __typename?: 'RefundLine';
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  refund: Refund;
  refundId: Scalars['ID']['output'];
};

export type RefundOrderDialogResult = {
  cancel: CancelOrderInput;
  refunds: Array<RefundOrderInput>;
};

export type RefundOrderInput = {
  adjustment: Scalars['Money']['input'];
  /**
   * If an amount is specified, this value will be used to create a Refund rather than calculating the
   * amount automatically. This was added in v2.2 and will be the preferred way to specify the refund
   * amount in the future. The `lines`, `shipping` and `adjustment` fields will likely be removed in a future
   * version.
   */
  amount?: InputMaybe<Scalars['Money']['input']>;
  lines: Array<OrderLineInput>;
  paymentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  shipping: Scalars['Money']['input'];
};

export type RefundOrderResult = AlreadyRefundedError | MultipleOrderError | NothingToRefundError | OrderStateTransitionError | PaymentOrderMismatchError | QuantityTooGreatError | Refund | RefundAmountError | RefundOrderStateError | RefundStateTransitionError;

/** Returned if an attempting to refund an Order which is not in the expected state */
export type RefundOrderStateError = ErrorResult & {
  __typename?: 'RefundOrderStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  orderState: Scalars['String']['output'];
};

/**
 * Returned when a call to modifyOrder fails to include a refundPaymentId even
 * though the price has decreased as a result of the changes.
 */
export type RefundPaymentIdMissingError = ErrorResult & {
  __typename?: 'RefundPaymentIdMissingError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type RefundRequest = Node & {
  __typename?: 'RefundRequest';
  args: Scalars['JSON']['output'];
  assets: Array<Asset>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lines: Array<RefundRequestLine>;
  order: Order;
  orderId: Scalars['ID']['output'];
  payment: Payment;
  paymentId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  requesterId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<RefundRequestType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RefundRequestFilterParameter = {
  _and?: InputMaybe<Array<RefundRequestFilterParameter>>;
  _or?: InputMaybe<Array<RefundRequestFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  orderId?: InputMaybe<IdOperators>;
  paymentId?: InputMaybe<IdOperators>;
  reason?: InputMaybe<StringOperators>;
  requesterId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type RefundRequestLine = Node & {
  __typename?: 'RefundRequestLine';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  refundRequest: RefundRequest;
  updatedAt: Scalars['DateTime']['output'];
};

export type RefundRequestLineInput = {
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type RefundRequestList = PaginatedList & {
  __typename?: 'RefundRequestList';
  items: Array<RefundRequest>;
  totalItems: Scalars['Int']['output'];
};

export type RefundRequestListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RefundRequestFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RefundRequestSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundRequestSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum RefundRequestType {
  Admin = 'Admin',
  Customer = 'Customer'
}

/** Returned when there is an error in transitioning the Refund state */
export type RefundStateTransitionError = ErrorResult & {
  __typename?: 'RefundStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

export type Region = {
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionCode = {
  __typename?: 'RegionCode';
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type RegionTranslation = {
  __typename?: 'RegionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegisterCooperateInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerCountryId?: InputMaybe<Scalars['ID']['input']>;
  registerCustomerInput: CreateCooperateCustomerInput;
  representative: Scalars['String']['input'];
  taxCode: Scalars['String']['input'];
};

export type RelationCustomFieldConfig = CustomField & {
  __typename?: 'RelationCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  entity: Scalars['String']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  scalarFields: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Release = Node & StockMovement & {
  __typename?: 'Release';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemoveCollectionsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
};

export type RemoveFacetFromChannelResult = Facet | FacetInUseError;

export type RemoveFacetsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  facetIds: Array<Scalars['ID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveOptionGroupFromProductResult = Product | ProductOptionInUseError;

export type RemoveOrderItemsResult = Order | OrderModificationError;

export type RemovePaymentMethodsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductVariantsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

export type RemovePromotionsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  promotionIds: Array<Scalars['ID']['input']>;
};

export type RemoveShippingMethodsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveStockLocationsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  stockLocationIds: Array<Scalars['ID']['input']>;
};

export type RequestMultiplePurchaseNeededInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  requests: Array<RequestPurchaseNeededInput>;
  retailerId?: InputMaybe<Scalars['ID']['input']>;
  shopSupplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type RequestPurchase = Node & {
  __typename?: 'RequestPurchase';
  approver?: Maybe<Administrator>;
  approverId?: Maybe<Scalars['ID']['output']>;
  condition?: Maybe<FreeGiftConditionPurchaseNeeded>;
  conditionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Array<RequestPurchaseDetail>>;
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notSpecify?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderQuantity: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productVariant: ProductVariant;
  productVariantId: Scalars['ID']['output'];
  quantityNeeded: Scalars['Int']['output'];
  requestOrderQuantity?: Maybe<Scalars['Int']['output']>;
  requestStockOnHand?: Maybe<Scalars['Int']['output']>;
  requester?: Maybe<Administrator>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  stockOnHand: Scalars['Int']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RequestPurchaseDetail = Node & {
  __typename?: 'RequestPurchaseDetail';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<FanClubLinkPurchaseNeeded>;
  linkId?: Maybe<Scalars['ID']['output']>;
  orderQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RequestPurchaseFilterParameter = {
  _and?: InputMaybe<Array<RequestPurchaseFilterParameter>>;
  _or?: InputMaybe<Array<RequestPurchaseFilterParameter>>;
  approverId?: InputMaybe<IdOperators>;
  conditionId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  expectedDate?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  notSpecify?: InputMaybe<BooleanOperators>;
  note?: InputMaybe<StringOperators>;
  orderQuantity?: InputMaybe<NumberOperators>;
  productId?: InputMaybe<IdOperators>;
  productVariantId?: InputMaybe<IdOperators>;
  quantityNeeded?: InputMaybe<NumberOperators>;
  requestOrderQuantity?: InputMaybe<NumberOperators>;
  requestStockOnHand?: InputMaybe<NumberOperators>;
  requesterId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  stockOnHand?: InputMaybe<NumberOperators>;
  supplier?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type RequestPurchaseGroup = Node & {
  __typename?: 'RequestPurchaseGroup';
  approver?: Maybe<Administrator>;
  approverId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Asset>>>;
  note?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['ID']['output'];
  requester?: Maybe<Administrator>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  requests?: Maybe<Array<RequestPurchase>>;
  retailer?: Maybe<RetailerGroup>;
  retailerId?: Maybe<Scalars['ID']['output']>;
  shopSupplier?: Maybe<ShopSupplier>;
  shopSupplierId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  supplier?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RequestPurchaseGroupFilterParameter = {
  _and?: InputMaybe<Array<RequestPurchaseGroupFilterParameter>>;
  _or?: InputMaybe<Array<RequestPurchaseGroupFilterParameter>>;
  approverId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  expectedDate?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  identifier?: InputMaybe<StringOperators>;
  note?: InputMaybe<StringOperators>;
  productId?: InputMaybe<IdOperators>;
  requesterId?: InputMaybe<IdOperators>;
  retailerId?: InputMaybe<IdOperators>;
  shopSupplierId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  supplier?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type RequestPurchaseGroupList = PaginatedList & {
  __typename?: 'RequestPurchaseGroupList';
  items: Array<RequestPurchaseGroup>;
  totalItems: Scalars['Int']['output'];
};

export type RequestPurchaseGroupListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RequestPurchaseGroupFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RequestPurchaseGroupSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestPurchaseGroupSortParameter = {
  approverId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  expectedDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrder>;
  retailerId?: InputMaybe<SortOrder>;
  shopSupplierId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  supplier?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequestPurchaseList = PaginatedList & {
  __typename?: 'RequestPurchaseList';
  items: Array<RequestPurchase>;
  totalItems: Scalars['Int']['output'];
};

export type RequestPurchaseListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RequestPurchaseFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RequestPurchaseSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestPurchaseNeededInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantityNeeded?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPurchaseSortParameter = {
  approverId?: InputMaybe<SortOrder>;
  conditionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  expectedDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderQuantity?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productVariantId?: InputMaybe<SortOrder>;
  quantityNeeded?: InputMaybe<SortOrder>;
  requestOrderQuantity?: InputMaybe<SortOrder>;
  requestStockOnHand?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stockOnHand?: InputMaybe<SortOrder>;
  supplier?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequestUpdateProductInput = {
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};

export type RerollGiftInput = {
  orderLineId: Scalars['ID']['input'];
  selectedGiftIndex: Scalars['Int']['input'];
};

export type ResetPasswordByPhoneNumberInput = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ResultManualCheckLinkStatus = {
  __typename?: 'ResultManualCheckLinkStatus';
  disabledLinks: Scalars['Int']['output'];
  enabledLinks: Scalars['Int']['output'];
};

export type Retail = Node & {
  __typename?: 'Retail';
  abbreviation: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<Asset>>>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Asset>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  productUpdateDate: Scalars['DateTime']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility?: Maybe<Scalars['Boolean']['output']>;
};

export type RetailFilterParameter = {
  _and?: InputMaybe<Array<RetailFilterParameter>>;
  _or?: InputMaybe<Array<RetailFilterParameter>>;
  abbreviation?: InputMaybe<StringOperators>;
  accountName?: InputMaybe<StringOperators>;
  address?: InputMaybe<StringOperators>;
  bankName?: InputMaybe<StringOperators>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  email?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  idNumber?: InputMaybe<StringOperators>;
  logoId?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  phone?: InputMaybe<StringOperators>;
  productUpdateDate?: InputMaybe<DateOperators>;
  registrationNumber?: InputMaybe<StringOperators>;
  total?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  visibility?: InputMaybe<BooleanOperators>;
};

export type RetailList = PaginatedList & {
  __typename?: 'RetailList';
  items: Array<Retail>;
  totalItems: Scalars['Int']['output'];
};

export type RetailListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RetailFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RetailSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RetailSortParameter = {
  abbreviation?: InputMaybe<SortOrder>;
  accountName?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idNumber?: InputMaybe<SortOrder>;
  logoId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  productUpdateDate?: InputMaybe<SortOrder>;
  registrationNumber?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RetailerGroup = Node & {
  __typename?: 'RetailerGroup';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Return = Node & StockMovement & {
  __typename?: 'Return';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type Role = Node & {
  __typename?: 'Role';
  channels: Array<Channel>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RoleFilterParameter = {
  _and?: InputMaybe<Array<RoleFilterParameter>>;
  _or?: InputMaybe<Array<RoleFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type RoleList = PaginatedList & {
  __typename?: 'RoleList';
  items: Array<Role>;
  totalItems: Scalars['Int']['output'];
};

export type RoleListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RoleFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RoleSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Sale = Node & StockMovement & {
  __typename?: 'Sale';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  facetValueFilters?: InputMaybe<Array<FacetValueFilterInput>>;
  groupByProduct?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchResultSortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchReindexResponse = {
  __typename?: 'SearchReindexResponse';
  success: Scalars['Boolean']['output'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  collections: Array<CollectionResult>;
  facetValues: Array<FacetValueResult>;
  items: Array<SearchResult>;
  totalItems: Scalars['Int']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  /** An array of ids of the Channels in which this result appears */
  channelIds: Array<Scalars['ID']['output']>;
  /** An array of ids of the Collections in which this result appears */
  collectionIds: Array<Scalars['ID']['output']>;
  currencyCode: CurrencyCode;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  facetIds: Array<Scalars['ID']['output']>;
  facetValueIds: Array<Scalars['ID']['output']>;
  inStock: Scalars['Boolean']['output'];
  price: SearchResultPrice;
  priceWithTax: SearchResultPrice;
  productAsset?: Maybe<SearchResultAsset>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productVariantAsset?: Maybe<SearchResultAsset>;
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  /** A relevance score for the result. Differs between database implementations */
  score: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SearchResultAsset = {
  __typename?: 'SearchResultAsset';
  focalPoint?: Maybe<Coordinate>;
  id: Scalars['ID']['output'];
  preview: Scalars['String']['output'];
};

/** The price of a search result product, either as a range or as a single price */
export type SearchResultPrice = PriceRange | SinglePrice;

export type SearchResultSortParameter = {
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type Seller = Node & {
  __typename?: 'Seller';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SellerFilterParameter = {
  _and?: InputMaybe<Array<SellerFilterParameter>>;
  _or?: InputMaybe<Array<SellerFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SellerList = PaginatedList & {
  __typename?: 'SellerList';
  items: Array<Seller>;
  totalItems: Scalars['Int']['output'];
};

export type SellerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SellerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SellerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SellerSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServerConfig = {
  __typename?: 'ServerConfig';
  /**
   * This field is deprecated in v2.2 in favor of the entityCustomFields field,
   * which allows custom fields to be defined on user-supplies entities.
   */
  customFieldConfig: CustomFields;
  entityCustomFields: Array<EntityCustomFields>;
  moneyStrategyPrecision: Scalars['Int']['output'];
  orderProcess: Array<OrderProcessState>;
  permissions: Array<PermissionDefinition>;
  permittedAssetTypes: Array<Scalars['String']['output']>;
};

export type ServiceFee = Node & {
  __typename?: 'ServiceFee';
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ServiceFeeFilterParameter = {
  _and?: InputMaybe<Array<ServiceFeeFilterParameter>>;
  _or?: InputMaybe<Array<ServiceFeeFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  percentage?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ServiceFeeList = PaginatedList & {
  __typename?: 'ServiceFeeList';
  items: Array<ServiceFee>;
  totalItems: Scalars['Int']['output'];
};

export type ServiceFeeListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ServiceFeeFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ServiceFeeSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceFeeSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SetCustomerForDraftOrderResult = EmailAddressConflictError | Order;

export type SetOrderCustomerInput = {
  customerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type SetOrderShippingMethodResult = IneligibleShippingMethodError | NoActiveOrderError | Order | OrderModificationError;

/** Returned if the Payment settlement fails */
export type SettlePaymentError = ErrorResult & {
  __typename?: 'SettlePaymentError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

export type SettlePaymentResult = OrderStateTransitionError | Payment | PaymentStateTransitionError | SettlePaymentError;

export type SettleRefundInput = {
  id: Scalars['ID']['input'];
  transactionId: Scalars['String']['input'];
};

export type SettleRefundResult = Refund | RefundStateTransitionError;

export type ShipmentStatus = Node & {
  __typename?: 'ShipmentStatus';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Shippable = Node & {
  __typename?: 'Shippable';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippableFilterParameter = {
  _and?: InputMaybe<Array<ShippableFilterParameter>>;
  _or?: InputMaybe<Array<ShippableFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  orderId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippableList = PaginatedList & {
  __typename?: 'ShippableList';
  items: Array<Shippable>;
  totalItems: Scalars['Int']['output'];
};

export type ShippableListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippableFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippableSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippableSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ShippableStatus {
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export type Shipping = Node & {
  __typename?: 'Shipping';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  shippingCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingFee = Node & {
  __typename?: 'ShippingFee';
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  priceFirstItem: Scalars['Float']['output'];
  priceFirstWeight: Scalars['Float']['output'];
  priceSubsequentItem: Scalars['Float']['output'];
  priceSubsequentWeight: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingFeeCountry = Node & {
  __typename?: 'ShippingFeeCountry';
  ShippingFeeWeights?: Maybe<Array<Maybe<ShippingFeeWeight>>>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  shippingFeeFreeGiftQuantities?: Maybe<Array<Maybe<ShippingFeeFreeGiftQuantity>>>;
  shippingFeeQuantities?: Maybe<Array<ShippingFeeQuantity>>;
  updatedAt: Scalars['DateTime']['output'];
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type ShippingFeeCountryFilterParameter = {
  _and?: InputMaybe<Array<ShippingFeeCountryFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFeeCountryFilterParameter>>;
  countryId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  zoneId?: InputMaybe<IdOperators>;
  zoneName?: InputMaybe<StringOperators>;
};

export type ShippingFeeCountryList = PaginatedList & {
  __typename?: 'ShippingFeeCountryList';
  items: Array<ShippingFeeCountry>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingFeeCountryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFeeCountryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingFeeCountrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingFeeCountrySortParameter = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zoneId?: InputMaybe<SortOrder>;
  zoneName?: InputMaybe<SortOrder>;
};

export type ShippingFeeFilterParameter = {
  _and?: InputMaybe<Array<ShippingFeeFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFeeFilterParameter>>;
  city?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  priceFirstItem?: InputMaybe<NumberOperators>;
  priceFirstWeight?: InputMaybe<NumberOperators>;
  priceSubsequentItem?: InputMaybe<NumberOperators>;
  priceSubsequentWeight?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingFeeFreeGiftQuantity = Node & {
  __typename?: 'ShippingFeeFreeGiftQuantity';
  basePrice: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  extraPrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  shippingFeeCountry: ShippingFeeCountry;
  shippingFeeCountryId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingFeeFreeGiftQuantityFilterParameter = {
  _and?: InputMaybe<Array<ShippingFeeFreeGiftQuantityFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFeeFreeGiftQuantityFilterParameter>>;
  basePrice?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  extraPrice?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  quantity?: InputMaybe<NumberOperators>;
  shippingFeeCountryId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingFeeFreeGiftQuantityList = PaginatedList & {
  __typename?: 'ShippingFeeFreeGiftQuantityList';
  items: Array<ShippingFeeFreeGiftQuantity>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingFeeFreeGiftQuantityListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFeeFreeGiftQuantityFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingFeeFreeGiftQuantitySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingFeeFreeGiftQuantitySortParameter = {
  basePrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  shippingFeeCountryId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShippingFeeList = PaginatedList & {
  __typename?: 'ShippingFeeList';
  items: Array<ShippingFee>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingFeeListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFeeFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingFeeSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingFeeQuantity = Node & {
  __typename?: 'ShippingFeeQuantity';
  basePrice: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  extraPrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  shippingFeeCountry: ShippingFeeCountry;
  shippingFeeCountryId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingFeeQuantityFilterParameter = {
  _and?: InputMaybe<Array<ShippingFeeQuantityFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFeeQuantityFilterParameter>>;
  basePrice?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  extraPrice?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  quantity?: InputMaybe<NumberOperators>;
  shippingFeeCountryId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingFeeQuantityList = PaginatedList & {
  __typename?: 'ShippingFeeQuantityList';
  items: Array<ShippingFeeQuantity>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingFeeQuantityListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFeeQuantityFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingFeeQuantitySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingFeeQuantitySortParameter = {
  basePrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  shippingFeeCountryId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShippingFeeSortParameter = {
  city?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceFirstItem?: InputMaybe<SortOrder>;
  priceFirstWeight?: InputMaybe<SortOrder>;
  priceSubsequentItem?: InputMaybe<SortOrder>;
  priceSubsequentWeight?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ShippingFeeType {
  FreeGiftQuantity = 'FreeGiftQuantity',
  Quantity = 'Quantity',
  Weight = 'Weight'
}

export type ShippingFeeWeight = Node & {
  __typename?: 'ShippingFeeWeight';
  basePrice: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  extraPrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  shippingFeeCountry: ShippingFeeCountry;
  shippingFeeCountryId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
};

export type ShippingFeeWeightFilterParameter = {
  _and?: InputMaybe<Array<ShippingFeeWeightFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFeeWeightFilterParameter>>;
  basePrice?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  extraPrice?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  shippingFeeCountryId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  weight?: InputMaybe<NumberOperators>;
};

export type ShippingFeeWeightList = PaginatedList & {
  __typename?: 'ShippingFeeWeightList';
  items: Array<ShippingFeeWeight>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingFeeWeightListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFeeWeightFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingFeeWeightSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingFeeWeightSortParameter = {
  basePrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  shippingFeeCountryId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ShippingFilterParameter = {
  _and?: InputMaybe<Array<ShippingFilterParameter>>;
  _or?: InputMaybe<Array<ShippingFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isApproved?: InputMaybe<BooleanOperators>;
  orderId?: InputMaybe<IdOperators>;
  shippingCode?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingLine = {
  __typename?: 'ShippingLine';
  discountedPrice: Scalars['Money']['output'];
  discountedPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  shippingMethod: ShippingMethod;
};

export type ShippingList = PaginatedList & {
  __typename?: 'ShippingList';
  items: Array<Shipping>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethod = Node & {
  __typename?: 'ShippingMethod';
  calculator: ConfigurableOperation;
  checker: ConfigurableOperation;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ShippingMethodCustomFields>;
  description: Scalars['String']['output'];
  fulfillmentHandlerCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ShippingMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodCustomFields = {
  __typename?: 'ShippingMethodCustomFields';
  countries?: Maybe<Array<Country>>;
  customsClearanceActive?: Maybe<Scalars['Boolean']['output']>;
};

export type ShippingMethodFilterParameter = {
  _and?: InputMaybe<Array<ShippingMethodFilterParameter>>;
  _or?: InputMaybe<Array<ShippingMethodFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  customsClearanceActive?: InputMaybe<BooleanOperators>;
  description?: InputMaybe<StringOperators>;
  fulfillmentHandlerCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingMethodList = PaginatedList & {
  __typename?: 'ShippingMethodList';
  items: Array<ShippingMethod>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingMethodListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingMethodFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingMethodSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethodQuote = {
  __typename?: 'ShippingMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<ShippingMethodCustomFields>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Any optional metadata returned by the ShippingCalculator in the ShippingCalculationResult */
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
};

export type ShippingMethodSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customsClearanceActive?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fulfillmentHandlerCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShippingMethodTranslation = {
  __typename?: 'ShippingMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  shippingCode?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShopSupplier = Node & {
  __typename?: 'ShopSupplier';
  abbreviation: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<Asset>>>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Asset>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShopSupplierFilterParameter = {
  _and?: InputMaybe<Array<ShopSupplierFilterParameter>>;
  _or?: InputMaybe<Array<ShopSupplierFilterParameter>>;
  abbreviation?: InputMaybe<StringOperators>;
  accountName?: InputMaybe<StringOperators>;
  address?: InputMaybe<StringOperators>;
  bankName?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  email?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  idNumber?: InputMaybe<StringOperators>;
  logoId?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  phone?: InputMaybe<StringOperators>;
  platform?: InputMaybe<StringOperators>;
  registrationNumber?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShopSupplierList = PaginatedList & {
  __typename?: 'ShopSupplierList';
  items: Array<ShopSupplier>;
  totalItems: Scalars['Int']['output'];
};

export type ShopSupplierListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShopSupplierFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShopSupplierSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShopSupplierSortParameter = {
  abbreviation?: InputMaybe<SortOrder>;
  accountName?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idNumber?: InputMaybe<SortOrder>;
  logoId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  registrationNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** The price value where the result has a single price */
export type SinglePrice = {
  __typename?: 'SinglePrice';
  value: Scalars['Money']['output'];
};

export type SmsTemplate = Node & {
  __typename?: 'SmsTemplate';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  templateCode: Scalars['String']['output'];
  translations: Array<SmsTemplateTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsTemplateFilterParameter = {
  _and?: InputMaybe<Array<SmsTemplateFilterParameter>>;
  _or?: InputMaybe<Array<SmsTemplateFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  templateCode?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SmsTemplateList = PaginatedList & {
  __typename?: 'SmsTemplateList';
  items: Array<SmsTemplate>;
  totalItems: Scalars['Int']['output'];
};

export type SmsTemplateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SmsTemplateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SmsTemplateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SmsTemplateSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateCode?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SmsTemplateTranslation = {
  __typename?: 'SmsTemplateTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  templateCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SplitOrder = Node & {
  __typename?: 'SplitOrder';
  cloneOrderLines?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lines?: Maybe<Scalars['JSON']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  splitOrderInfo: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SplitOrderFilterParameter = {
  _and?: InputMaybe<Array<SplitOrderFilterParameter>>;
  _or?: InputMaybe<Array<SplitOrderFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  orderId?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SplitOrderList = PaginatedList & {
  __typename?: 'SplitOrderList';
  items: Array<SplitOrder>;
  totalItems: Scalars['Int']['output'];
};

export type SplitOrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SplitOrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SplitOrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SplitOrderRule = Node & {
  __typename?: 'SplitOrderRule';
  createdAt: Scalars['DateTime']['output'];
  freeGiftQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  shippingQuantity: Scalars['Int']['output'];
  shippingWeight: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SplitOrderRuleFilterParameter = {
  _and?: InputMaybe<Array<SplitOrderRuleFilterParameter>>;
  _or?: InputMaybe<Array<SplitOrderRuleFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  freeGiftQuantity?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  isDefault?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  shippingQuantity?: InputMaybe<NumberOperators>;
  shippingWeight?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SplitOrderRuleList = PaginatedList & {
  __typename?: 'SplitOrderRuleList';
  items: Array<SplitOrderRule>;
  totalItems: Scalars['Int']['output'];
};

export type SplitOrderRuleListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SplitOrderRuleFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SplitOrderRuleSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SplitOrderRuleSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  freeGiftQuantity?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shippingQuantity?: InputMaybe<SortOrder>;
  shippingWeight?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SplitOrderSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StaticPage = Node & {
  __typename?: 'StaticPage';
  administrator: Admin;
  administratorId: Scalars['ID']['output'];
  classification?: Maybe<StaticPageClassification>;
  classificationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  nContent?: Maybe<Scalars['String']['output']>;
  nTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Asset>;
  translations: Array<StaticPageTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticPageClassification = Node & {
  __typename?: 'StaticPageClassification';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  nTitle?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Array<StaticPage>>;
  translations: Array<StaticPageClassificationTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticPageClassificationFilterParameter = {
  _and?: InputMaybe<Array<StaticPageClassificationFilterParameter>>;
  _or?: InputMaybe<Array<StaticPageClassificationFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  nTitle?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type StaticPageClassificationList = PaginatedList & {
  __typename?: 'StaticPageClassificationList';
  items: Array<StaticPageClassification>;
  totalItems: Scalars['Int']['output'];
};

export type StaticPageClassificationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<StaticPageClassificationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<StaticPageClassificationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StaticPageClassificationSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StaticPageClassificationTranslation = Node & {
  __typename?: 'StaticPageClassificationTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  nTitle: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticPageClassificationTranslationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  nTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StaticPageFilterParameter = {
  _and?: InputMaybe<Array<StaticPageFilterParameter>>;
  _or?: InputMaybe<Array<StaticPageFilterParameter>>;
  administratorId?: InputMaybe<IdOperators>;
  classificationId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  nContent?: InputMaybe<StringOperators>;
  nTitle?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type StaticPageList = PaginatedList & {
  __typename?: 'StaticPageList';
  items: Array<StaticPage>;
  totalItems: Scalars['Int']['output'];
};

export type StaticPageListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<StaticPageFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<StaticPageSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StaticPageSortParameter = {
  administratorId?: InputMaybe<SortOrder>;
  classificationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nContent?: InputMaybe<SortOrder>;
  nTitle?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StaticPageTranslation = Node & {
  __typename?: 'StaticPageTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  nContent: Scalars['String']['output'];
  nTitle: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticPageTranslationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  nContent: Scalars['String']['input'];
  nTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StockAdjustment = Node & StockMovement & {
  __typename?: 'StockAdjustment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLevel = Node & {
  __typename?: 'StockLevel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  stockAllocated: Scalars['Int']['output'];
  stockLocation: StockLocation;
  stockLocationId: Scalars['ID']['output'];
  stockOnHand: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLevelInput = {
  stockLocationId: Scalars['ID']['input'];
  stockOnHand: Scalars['Int']['input'];
};

export type StockLocation = Node & {
  __typename?: 'StockLocation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLocationFilterParameter = {
  _and?: InputMaybe<Array<StockLocationFilterParameter>>;
  _or?: InputMaybe<Array<StockLocationFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type StockLocationList = PaginatedList & {
  __typename?: 'StockLocationList';
  items: Array<StockLocation>;
  totalItems: Scalars['Int']['output'];
};

export type StockLocationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<StockLocationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<StockLocationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StockLocationSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StockMovement = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StockMovementItem = Allocation | Cancellation | Release | Return | Sale | StockAdjustment;

export type StockMovementList = {
  __typename?: 'StockMovementList';
  items: Array<StockMovementItem>;
  totalItems: Scalars['Int']['output'];
};

export type StockMovementListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StockMovementType>;
};

export enum StockMovementType {
  Adjustment = 'ADJUSTMENT',
  Allocation = 'ALLOCATION',
  Cancellation = 'CANCELLATION',
  Release = 'RELEASE',
  Return = 'RETURN',
  Sale = 'SALE'
}

export type StockinGetInput = {
  applyDateFrom?: InputMaybe<Scalars['String']['input']>;
  applyDateTo?: InputMaybe<Scalars['String']['input']>;
  cols: Scalars['String']['input'];
  createTimeFrom?: InputMaybe<Scalars['String']['input']>;
  createTimeTo?: InputMaybe<Scalars['String']['input']>;
  goodsName?: InputMaybe<Scalars['String']['input']>;
  goodsNo?: InputMaybe<Scalars['String']['input']>;
  inNo?: InputMaybe<Scalars['String']['input']>;
  inStatus?: InputMaybe<Scalars['String']['input']>;
  inType?: InputMaybe<Scalars['String']['input']>;
  isListLogistic?: InputMaybe<Scalars['Int']['input']>;
  isNotification?: InputMaybe<Scalars['Int']['input']>;
  modifyTimeFrom?: InputMaybe<Scalars['String']['input']>;
  modifyTimeTo?: InputMaybe<Scalars['String']['input']>;
  mulStatus?: InputMaybe<Scalars['String']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  relDataId?: InputMaybe<Scalars['String']['input']>;
  skuName?: InputMaybe<Scalars['String']['input']>;
  warehouseCode?: InputMaybe<Scalars['String']['input']>;
};

export type StringCustomFieldConfig = CustomField & {
  __typename?: 'StringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<StringFieldOption>>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StringFieldOption = {
  __typename?: 'StringFieldOption';
  label?: Maybe<Array<LocalizedString>>;
  value: Scalars['String']['output'];
};

/** Operators for filtering on a list of String fields */
export type StringListOperators = {
  inList: Scalars['String']['input'];
};

/** Operators for filtering on a String field */
export type StringOperators = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

/** Indicates that an operation succeeded, where we do not want to return any more specific information. */
export type Success = {
  __typename?: 'Success';
  success: Scalars['Boolean']['output'];
};

export type SupplierGetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  gmtModifiedEnd?: InputMaybe<Scalars['String']['input']>;
  gmtModifiedStart?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Surcharge = Node & {
  __typename?: 'Surcharge';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurchargeInput = {
  description: Scalars['String']['input'];
  price: Scalars['Money']['input'];
  priceIncludesTax: Scalars['Boolean']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  taxDescription?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type Tag = Node & {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type TagFilterParameter = {
  _and?: InputMaybe<Array<TagFilterParameter>>;
  _or?: InputMaybe<Array<TagFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type TagList = PaginatedList & {
  __typename?: 'TagList';
  items: Array<Tag>;
  totalItems: Scalars['Int']['output'];
};

export type TagListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TagFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TagSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TagSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type TaxCategory = Node & {
  __typename?: 'TaxCategory';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaxCategoryFilterParameter = {
  _and?: InputMaybe<Array<TaxCategoryFilterParameter>>;
  _or?: InputMaybe<Array<TaxCategoryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isDefault?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type TaxCategoryList = PaginatedList & {
  __typename?: 'TaxCategoryList';
  items: Array<TaxCategory>;
  totalItems: Scalars['Int']['output'];
};

export type TaxCategoryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TaxCategoryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TaxCategorySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxCategorySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TaxLine = {
  __typename?: 'TaxLine';
  description: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type TaxRate = Node & {
  __typename?: 'TaxRate';
  category: TaxCategory;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerGroup?: Maybe<CustomerGroup>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  zone: Zone;
};

export type TaxRateFilterParameter = {
  _and?: InputMaybe<Array<TaxRateFilterParameter>>;
  _or?: InputMaybe<Array<TaxRateFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<NumberOperators>;
};

export type TaxRateList = PaginatedList & {
  __typename?: 'TaxRateList';
  items: Array<TaxRate>;
  totalItems: Scalars['Int']['output'];
};

export type TaxRateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TaxRateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TaxRateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxRatePriceUpdateResult = {
  __typename?: 'TaxRatePriceUpdateResult';
  updated: Scalars['Int']['output'];
};

export type TaxRateSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type TestEligibleShippingMethodsInput = {
  lines: Array<TestShippingMethodOrderLineInput>;
  shippingAddress: CreateAddressInput;
};

export type TestShippingMethodInput = {
  calculator: ConfigurableOperationInput;
  checker: ConfigurableOperationInput;
  lines: Array<TestShippingMethodOrderLineInput>;
  shippingAddress: CreateAddressInput;
};

export type TestShippingMethodOrderLineInput = {
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type TestShippingMethodQuote = {
  __typename?: 'TestShippingMethodQuote';
  metadata?: Maybe<Scalars['JSON']['output']>;
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
};

export type TestShippingMethodResult = {
  __typename?: 'TestShippingMethodResult';
  eligible: Scalars['Boolean']['output'];
  quote?: Maybe<TestShippingMethodQuote>;
};

export type TextCustomFieldConfig = CustomField & {
  __typename?: 'TextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Ticket = Node & {
  __typename?: 'Ticket';
  assignee?: Maybe<Administrator>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  comments: Array<TicketComment>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<TicketPriority>;
  requester?: Maybe<Administrator>;
  requesterId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<TicketStatus>;
  title: Scalars['String']['output'];
  type?: Maybe<TicketType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketComment = Node & {
  __typename?: 'TicketComment';
  author: Administrator;
  authorId: Scalars['ID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  ticket: Ticket;
  ticketId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketFilterParameter = {
  _and?: InputMaybe<Array<TicketFilterParameter>>;
  _or?: InputMaybe<Array<TicketFilterParameter>>;
  assigneeId?: InputMaybe<IdOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  dueDate?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  priority?: InputMaybe<StringOperators>;
  requesterId?: InputMaybe<IdOperators>;
  status?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type TicketList = PaginatedList & {
  __typename?: 'TicketList';
  items: Array<Ticket>;
  totalItems: Scalars['Int']['output'];
};

export type TicketListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TicketFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TicketSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum TicketPriority {
  High = 'High',
  Highest = 'Highest',
  Low = 'Low',
  Lowest = 'Lowest',
  Medium = 'Medium'
}

export type TicketSortParameter = {
  assigneeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  requesterId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TicketStatus {
  Closed = 'Closed',
  New = 'New',
  Open = 'Open',
  Pending = 'Pending',
  Solved = 'Solved'
}

export enum TicketType {
  InternalTicket = 'InternalTicket',
  QaBullet = 'QABullet'
}

export type TotalLinkStatistic = {
  __typename?: 'TotalLinkStatistic';
  totalCompleted: Scalars['Int']['output'];
  totalCreated: Scalars['Int']['output'];
  totalProgress: Scalars['Int']['output'];
  totalShcheduled: Scalars['Int']['output'];
};

export type TotalPurchaseAmountFilter = {
  currencyCode: CurrencyCode;
  total: Scalars['Float']['input'];
};

export type TransitionFulfillmentToStateResult = Fulfillment | FulfillmentStateTransitionError;

export type TransitionOrderToStateResult = Order | OrderStateTransitionError;

export type TransitionPaymentToStateResult = Payment | PaymentStateTransitionError;

export type UpdateActiveAdministratorInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressCustomFieldsInput = {
  chinaName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  filesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  idCardNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to update an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdministratorInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateAlertInput = {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  translations: Array<AlertTranslationInput>;
};

export type UpdateArtistInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  focalPoint?: InputMaybe<CoordinateInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAvailableCountryInput = {
  countryId: Scalars['ID']['input'];
  id: Scalars['Int']['input'];
  methodIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateBannerInput = {
  bannerAssetId?: InputMaybe<Scalars['ID']['input']>;
  bannerCategoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  linkURL?: InputMaybe<Scalars['String']['input']>;
  mobileBannerAssetId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelCustomFieldsInput = {
  fanClubPointExchangeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateChannelInput = {
  availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
  availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateChannelCustomFieldsInput>;
  defaultCurrencyCode?: InputMaybe<CurrencyCode>;
  defaultLanguageCode?: InputMaybe<LanguageCode>;
  defaultShippingZoneId?: InputMaybe<Scalars['ID']['input']>;
  defaultTaxZoneId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  pricesIncludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChannelResult = Channel | LanguageNotAvailableError;

export type UpdateCheckboxInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type UpdateCollectionInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<ConfigurableOperationInput>>;
  id: Scalars['ID']['input'];
  inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  translations?: InputMaybe<Array<UpdateCollectionTranslationInput>>;
};

export type UpdateCollectionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCooperateInput = {
  id: Scalars['ID']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCountryCustomFieldsInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCountryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateCountryCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<CountryTranslationInput>>;
};

export type UpdateCountryProductInput = {
  availableCountries: Array<UpdateAvailableCountryInput>;
  productId: Scalars['ID']['input'];
};

export type UpdateCustomerCustomFieldsInput = {
  allowNotification?: InputMaybe<Scalars['Boolean']['input']>;
  chinaIdName?: InputMaybe<Scalars['String']['input']>;
  chinaIdNumber?: InputMaybe<Scalars['String']['input']>;
  cooperateUserId?: InputMaybe<Scalars['ID']['input']>;
  customerCountryId?: InputMaybe<Scalars['ID']['input']>;
  moneySpent?: InputMaybe<Scalars['Float']['input']>;
  pointAccumulate?: InputMaybe<Scalars['Float']['input']>;
  userLevelId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomerGroupInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  customFields?: InputMaybe<UpdateCustomerCustomFieldsInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerNoteInput = {
  note: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
};

export type UpdateCustomerResult = Customer | EmailAddressConflictError;

export type UpdateDefaultEventConsentContent = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultEventConsentContentTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultProductDescriptionInput = {
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDefaultProductDescriptionTranslationInput = {
  bottomDescription?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  languageCode?: InputMaybe<LanguageCode>;
  title?: InputMaybe<Scalars['String']['input']>;
  topDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultProductInformationInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailTemplateTranslationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  languageCode?: InputMaybe<LanguageCode>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventConsentContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventIdolInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numOfWinners?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExchangeRateInput = {
  countryId: Scalars['ID']['input'];
  default: Scalars['Boolean']['input'];
  enable: Scalars['Boolean']['input'];
  exchangeRate: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  taxRateId: Scalars['ID']['input'];
};

export type UpdateFacetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<FacetTranslationInput>>;
};

export type UpdateFacetValueInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<FacetValueTranslationInput>>;
};

export type UpdateFanClubEventInput = {
  allowCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  announcementContent?: InputMaybe<Scalars['String']['input']>;
  applicationEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  applicationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  artistId?: InputMaybe<Scalars['ID']['input']>;
  artistName?: InputMaybe<Scalars['String']['input']>;
  checkboxes?: InputMaybe<Array<UpdateEventConsentContentInput>>;
  consentContentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactInfoType?: InputMaybe<ContactInfoType>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  linkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numOfWinners?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  updateIdols?: InputMaybe<Array<UpdateEventIdolInput>>;
};

export type UpdateFanClubGroupInput = {
  id: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateFanClubInput = {
  artistId?: InputMaybe<Scalars['ID']['input']>;
  artistName?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFanClubLinkInput = {
  availableCountries?: InputMaybe<Array<UpdateAvailableCountryInput>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fanClubId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCorporateLink?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFanClubExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  linkVariants?: InputMaybe<Array<UpdateLinkVariantInput>>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showGifts?: InputMaybe<Scalars['Boolean']['input']>;
  showSalesData?: InputMaybe<Scalars['Boolean']['input']>;
  showStock?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateFanClubLinkMissionInput = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  linkId?: InputMaybe<Scalars['ID']['input']>;
  pointRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  rewardType?: InputMaybe<FanClubLinkMissionRewardType>;
  target?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFanClubMemberInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<MemberStatus>;
};

export type UpdateFreeGiftConditionInput = {
  giftQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateFreeGiftInput = {
  id: Scalars['ID']['input'];
  isRandom?: InputMaybe<Scalars['Boolean']['input']>;
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlobalSettingsCustomFieldsInput = {
  adminUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlobalSettingsInput = {
  availableLanguages?: InputMaybe<Array<LanguageCode>>;
  customFields?: InputMaybe<UpdateGlobalSettingsCustomFieldsInput>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGlobalSettingsResult = ChannelDefaultLanguageError | GlobalSettings;

export type UpdateGoodsInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  cateCode?: InputMaybe<Scalars['String']['input']>;
  cateName?: InputMaybe<Scalars['String']['input']>;
  costValuationMethod?: InputMaybe<Scalars['Int']['input']>;
  goodsAlias?: InputMaybe<Scalars['String']['input']>;
  goodsMemo?: InputMaybe<Scalars['String']['input']>;
  goodsName: Scalars['String']['input'];
  goodsNameEn?: InputMaybe<Scalars['String']['input']>;
  goodsNo: Scalars['String']['input'];
  isBatchManagement?: InputMaybe<Scalars['Int']['input']>;
  isSerialManagement?: InputMaybe<Scalars['Int']['input']>;
  outSkuCode: Scalars['String']['input'];
  shelfLife?: InputMaybe<Scalars['Int']['input']>;
  shelfLiftUnit?: InputMaybe<Scalars['String']['input']>;
  skuBarcode?: InputMaybe<Scalars['String']['input']>;
  skuName: Scalars['String']['input'];
  unitName: Scalars['String']['input'];
};

export type UpdateGuidanceInput = {
  guidanceContentId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  translations: Array<GuidanceTranslationInput>;
};

export type UpdateInboundApproveRequestInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: InboundApproveRequestStatus;
  withoutPurchaseRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInboundingInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateLinkVariantInput = {
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  customStock?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  inCart?: InputMaybe<Scalars['Int']['input']>;
  productVariantId: Scalars['ID']['input'];
  stockAllocated?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLinkVariantPriceInput = {
  beforeTax: Scalars['Int']['input'];
  customServiceFee?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateNoticeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  translations: Array<NoticeTranslationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibility: Scalars['Boolean']['input'];
};

export type UpdateOrderAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderCustomFieldsInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Scalars['Float']['input']>;
  refundStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
  id: Scalars['ID']['input'];
};

export type UpdateOrderItemsResult = InsufficientStockError | NegativeQuantityError | Order | OrderLimitError | OrderModificationError;

export type UpdateOrderNoteInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['ID']['input'];
};

export type UpdatePackageInput = {
  estimatedWeight?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  jackyunOrderID?: InputMaybe<Scalars['String']['input']>;
  jackyunStatus?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePackageReviewInput = {
  cloneOrderLines?: InputMaybe<Scalars['JSON']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePackageReviewOrderLineInput = {
  id: Scalars['ID']['input'];
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  packageReviewId?: InputMaybe<Scalars['ID']['input']>;
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePackageReviewSplitRultInput = {
  freeGiftQuantity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  shippingQuantity: Scalars['Int']['input'];
  shippingWeight: Scalars['Int']['input'];
};

export type UpdatePaymentMethodInput = {
  checker?: InputMaybe<ConfigurableOperationInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  handler?: InputMaybe<ConfigurableOperationInput>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<PaymentMethodTranslationInput>>;
};

export type UpdateProductCustomFieldsInput = {
  artistId?: InputMaybe<Scalars['ID']['input']>;
  createdInJackyun?: InputMaybe<Scalars['Boolean']['input']>;
  customThreshold?: InputMaybe<Scalars['Int']['input']>;
  defaultProductDescriptionId?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<Scalars['Boolean']['input']>;
  eventsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facetsColumn?: InputMaybe<Scalars['Boolean']['input']>;
  freeGifts?: InputMaybe<Scalars['Boolean']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  isSinglePurchase?: InputMaybe<Scalars['Boolean']['input']>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  preorder?: InputMaybe<Scalars['Boolean']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  purchaseNote?: InputMaybe<Scalars['String']['input']>;
  purchaseUrl?: InputMaybe<Scalars['String']['input']>;
  randomOption?: InputMaybe<Scalars['Boolean']['input']>;
  retailerId?: InputMaybe<Scalars['ID']['input']>;
  shippingSetting?: InputMaybe<Scalars['String']['input']>;
  showSales?: InputMaybe<Scalars['Boolean']['input']>;
  showStock?: InputMaybe<Scalars['Boolean']['input']>;
  splitOrderRuleId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  totalLinks?: InputMaybe<Scalars['String']['input']>;
  totalSalesQuantity?: InputMaybe<Scalars['String']['input']>;
  totalStocks?: InputMaybe<Scalars['Int']['input']>;
  useSaleTime?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<UpdateProductCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductTranslationInput>>;
};

export type UpdateProductOptionGroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductOptionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductSpecificationInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductVariantCustomFieldsInput = {
  fixPrice?: InputMaybe<Scalars['Float']['input']>;
  maxPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minPerOrder?: InputMaybe<Scalars['Int']['input']>;
  skuBarcode?: InputMaybe<Scalars['String']['input']>;
  stockWaiting?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductVariantInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<UpdateProductVariantCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the price for the ProductVariant in the Channel's default currency */
  price?: InputMaybe<Scalars['Money']['input']>;
  /** Allows multiple prices to be set for the ProductVariant in different currencies. */
  prices?: InputMaybe<Array<ProductVariantPriceInput>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockLevels?: InputMaybe<Array<StockLevelInput>>;
  stockOnHand?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  trackInventory?: InputMaybe<GlobalFlag>;
  translations?: InputMaybe<Array<ProductVariantTranslationInput>>;
  useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromotionCustomFieldsInput = {
  customersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePromotionInput = {
  actions?: InputMaybe<Array<ConfigurableOperationInput>>;
  conditions?: InputMaybe<Array<ConfigurableOperationInput>>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdatePromotionCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  translations?: InputMaybe<Array<PromotionTranslationInput>>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromotionResult = MissingConditionsError | Promotion;

export type UpdateProvinceCustomFieldsInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProvinceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateProvinceCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProvinceTranslationInput>>;
};

export type UpdatePurchaseRequestCronjobInput = {
  everyHour?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePushTemplateInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  translations: Array<PushTemplateTranslationInput>;
  type: Scalars['String']['input'];
};

export type UpdateQuestionPostComment = {
  detail: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionPostInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  referId?: InputMaybe<Scalars['ID']['input']>;
  secret?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionPostType>;
};

export type UpdateRefundRequestInput = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type UpdateRequestPurchaseInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRetailInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRoleInput = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Permission>>;
};

export type UpdateSellerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceFeeInput = {
  currencyCode?: InputMaybe<CurrencyCode>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateShippablesInput = {
  ids: Array<Scalars['ID']['input']>;
  status: ShippableStatus;
};

export type UpdateShippingFeeCountryInput = {
  id: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export type UpdateShippingFeeInput = {
  city: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  priceFirstItem: Scalars['Float']['input'];
  priceFirstWeight: Scalars['Float']['input'];
  priceSubsequentItem: Scalars['Float']['input'];
  priceSubsequentWeight: Scalars['Float']['input'];
};

export type UpdateShippingFeeTypeInput = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  extraPrice?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type: ShippingFeeType;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateShippingInput = {
  id: Scalars['ID']['input'];
  idApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShippingMethodCustomFieldsInput = {
  countriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customsClearanceActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShippingMethodInput = {
  calculator?: InputMaybe<ConfigurableOperationInput>;
  checker?: InputMaybe<ConfigurableOperationInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateShippingMethodCustomFieldsInput>;
  fulfillmentHandler?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  translations: Array<ShippingMethodTranslationInput>;
};

export type UpdateShopSupplier = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSplitOrderRuleInput = {
  freeGiftQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shippingQuantity?: InputMaybe<Scalars['Int']['input']>;
  shippingWeight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStaticPageClassificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  translations: Array<StaticPageClassificationTranslationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStaticPageInput = {
  classificationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnailId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<StaticPageTranslationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStockLocationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  assetIds: Array<Scalars['ID']['input']>;
  assistantCode?: InputMaybe<Scalars['String']['input']>;
  businessScope?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  className: Scalars['String']['input'];
  code: Scalars['String']['input'];
  countryName?: InputMaybe<Scalars['String']['input']>;
  developDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  flagData?: InputMaybe<Scalars['String']['input']>;
  leader?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  townName?: InputMaybe<Scalars['String']['input']>;
  vendPayAccountList?: InputMaybe<PartialVendPayAccountList>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxCategoryInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxRateInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTicketCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTicketInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<TicketPriority>;
  status?: InputMaybe<TicketStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserLevelInput = {
  cashbackPercent?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  levelType?: InputMaybe<LevelType>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderQuan?: InputMaybe<Scalars['Int']['input']>;
  orderQuantity: Array<OrderQuantityWithCurrencyCodeInput>;
  pointAccrualPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWarehouseInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  linkMan: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  townName: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseCompanyCode: Scalars['String']['input'];
  warehouseDepartCode: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseTypeCode: Scalars['String']['input'];
};

export type UpdateWarehouseOneInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  linkMan: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  townName: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseCompanyCode: Scalars['String']['input'];
  warehouseDepartCode: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseTypeCode: Scalars['String']['input'];
};

export type UpdateZoneInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatingFanClubLinkDate = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertAlbumRankInput = {
  firstProductId?: InputMaybe<Scalars['ID']['input']>;
  fourthProductId?: InputMaybe<Scalars['ID']['input']>;
  secondProductId?: InputMaybe<Scalars['ID']['input']>;
  thirdProductId?: InputMaybe<Scalars['ID']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  authenticationMethods: Array<AuthenticationMethod>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Role>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserDevice = Node & {
  __typename?: 'UserDevice';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceName: Scalars['String']['output'];
  deviceToken: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserDeviceFilterParameter = {
  _and?: InputMaybe<Array<UserDeviceFilterParameter>>;
  _or?: InputMaybe<Array<UserDeviceFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  customerId?: InputMaybe<IdOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  deviceName?: InputMaybe<StringOperators>;
  deviceToken?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  platform?: InputMaybe<StringOperators>;
  tag?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type UserDeviceList = PaginatedList & {
  __typename?: 'UserDeviceList';
  items: Array<UserDevice>;
  totalItems: Scalars['Int']['output'];
};

export type UserDeviceListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<UserDeviceFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<UserDeviceSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDeviceSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deviceName?: InputMaybe<SortOrder>;
  deviceToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  tag?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type UserLevel = Node & {
  __typename?: 'UserLevel';
  cashbackPercent: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  levelType: LevelType;
  logo?: Maybe<Asset>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  orderQuan?: Maybe<Scalars['Int']['output']>;
  orderQuantity?: Maybe<Array<UserLevelOrderQuantity>>;
  pointAccrualPercent: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserLevelFilterParameter = {
  _and?: InputMaybe<Array<UserLevelFilterParameter>>;
  _or?: InputMaybe<Array<UserLevelFilterParameter>>;
  cashbackPercent?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  levelType?: InputMaybe<StringOperators>;
  logoId?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  note?: InputMaybe<StringOperators>;
  orderQuan?: InputMaybe<NumberOperators>;
  pointAccrualPercent?: InputMaybe<NumberOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type UserLevelList = PaginatedList & {
  __typename?: 'UserLevelList';
  items: Array<UserLevel>;
  totalItems: Scalars['Int']['output'];
};

export type UserLevelListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<UserLevelFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<UserLevelSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserLevelOrderQuantity = Node & {
  __typename?: 'UserLevelOrderQuantity';
  createdAt: Scalars['DateTime']['output'];
  currencyCode?: Maybe<CurrencyCode>;
  id: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserLevelSortParameter = {
  cashbackPercent?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  logoId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderQuan?: InputMaybe<SortOrder>;
  pointAccrualPercent?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type UserPoint = Node & {
  __typename?: 'UserPoint';
  adjustmentPoint: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  pointAction: PointAction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userLevel: UserLevel;
  userLevelId: Scalars['ID']['output'];
};

export type UserPointFilterParameter = {
  _and?: InputMaybe<Array<UserPointFilterParameter>>;
  _or?: InputMaybe<Array<UserPointFilterParameter>>;
  adjustmentPoint?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  customerId?: InputMaybe<IdOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  pointAction?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  userLevelId?: InputMaybe<IdOperators>;
};

export type UserPointList = PaginatedList & {
  __typename?: 'UserPointList';
  items: Array<UserPoint>;
  totalItems: Scalars['Int']['output'];
};

export type UserPointListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<UserPointFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<UserPointSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPointSortParameter = {
  adjustmentPoint?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userLevelId?: InputMaybe<SortOrder>;
};

export type VendLinkmanList = {
  email?: InputMaybe<Scalars['String']['input']>;
  linkman?: InputMaybe<Scalars['String']['input']>;
  linktel?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  qq?: InputMaybe<Scalars['String']['input']>;
  wechat?: InputMaybe<Scalars['String']['input']>;
};

export type VendPayAccountList = {
  accName: Scalars['String']['input'];
  accountTypeCode: Scalars['String']['input'];
  accountTypeName: Scalars['String']['input'];
  bankacct: Scalars['String']['input'];
  bankbranch: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyChinaIdInput = {
  card: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type VerifyChinaIdResult = {
  __typename?: 'VerifyChinaIdResult';
  message: Scalars['String']['output'];
  result: Scalars['Boolean']['output'];
};

export type VerifyCodeInput = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Warehouse = Node & {
  __typename?: 'Warehouse';
  address: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isInoutAudit?: Maybe<Scalars['Int']['output']>;
  isInoutTask?: Maybe<Scalars['Int']['output']>;
  linkMan: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  tel: Scalars['String']['output'];
  townName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendCode?: Maybe<Scalars['String']['output']>;
  warehouseCode: Scalars['String']['output'];
  warehouseCompanyCode: Scalars['String']['output'];
  warehouseCompanyName?: Maybe<Scalars['String']['output']>;
  warehouseDepartCode: Scalars['String']['output'];
  warehouseDepartName?: Maybe<Scalars['String']['output']>;
  warehouseName: Scalars['String']['output'];
  warehouseStoreTypeCode?: Maybe<Scalars['String']['output']>;
  warehouseStoreTypeName?: Maybe<Scalars['String']['output']>;
  warehouseTypeCode: Scalars['String']['output'];
  warehouseTypeName?: Maybe<Scalars['String']['output']>;
};

export type WarehouseApiResponse = {
  __typename?: 'WarehouseApiResponse';
  address?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  linkMan?: Maybe<Scalars['String']['output']>;
  provinceName?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  townName?: Maybe<Scalars['String']['output']>;
  vendCode?: Maybe<Scalars['String']['output']>;
  warehouseCode?: Maybe<Scalars['String']['output']>;
  warehouseCompanyCode?: Maybe<Scalars['String']['output']>;
  warehouseCompanyId?: Maybe<Scalars['String']['output']>;
  warehouseCompanyName?: Maybe<Scalars['String']['output']>;
  warehouseDepartCode?: Maybe<Scalars['String']['output']>;
  warehouseDepartId?: Maybe<Scalars['String']['output']>;
  warehouseDepartName?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseStoreTypeCode?: Maybe<Scalars['String']['output']>;
  warehouseStoreTypeName?: Maybe<Scalars['String']['output']>;
  warehouseTypeCode?: Maybe<Scalars['String']['output']>;
  warehouseTypeName?: Maybe<Scalars['String']['output']>;
};

export type WarehouseFilterParameter = {
  _and?: InputMaybe<Array<WarehouseFilterParameter>>;
  _or?: InputMaybe<Array<WarehouseFilterParameter>>;
  address?: InputMaybe<StringOperators>;
  cityName?: InputMaybe<StringOperators>;
  countryName?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isInoutAudit?: InputMaybe<NumberOperators>;
  isInoutTask?: InputMaybe<NumberOperators>;
  linkMan?: InputMaybe<StringOperators>;
  provinceName?: InputMaybe<StringOperators>;
  streetName?: InputMaybe<StringOperators>;
  tel?: InputMaybe<StringOperators>;
  townName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  vendCode?: InputMaybe<StringOperators>;
  warehouseCode?: InputMaybe<StringOperators>;
  warehouseCompanyCode?: InputMaybe<StringOperators>;
  warehouseCompanyName?: InputMaybe<StringOperators>;
  warehouseDepartCode?: InputMaybe<StringOperators>;
  warehouseDepartName?: InputMaybe<StringOperators>;
  warehouseName?: InputMaybe<StringOperators>;
  warehouseStoreTypeCode?: InputMaybe<StringOperators>;
  warehouseStoreTypeName?: InputMaybe<StringOperators>;
  warehouseTypeCode?: InputMaybe<StringOperators>;
  warehouseTypeName?: InputMaybe<StringOperators>;
};

export type WarehouseList = PaginatedList & {
  __typename?: 'WarehouseList';
  items: Array<Warehouse>;
  totalItems: Scalars['Int']['output'];
};

export type WarehouseListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<WarehouseFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<WarehouseSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type WarehouseSortParameter = {
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isInoutAudit?: InputMaybe<SortOrder>;
  isInoutTask?: InputMaybe<SortOrder>;
  linkMan?: InputMaybe<SortOrder>;
  provinceName?: InputMaybe<SortOrder>;
  streetName?: InputMaybe<SortOrder>;
  tel?: InputMaybe<SortOrder>;
  townName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vendCode?: InputMaybe<SortOrder>;
  warehouseCode?: InputMaybe<SortOrder>;
  warehouseCompanyCode?: InputMaybe<SortOrder>;
  warehouseCompanyName?: InputMaybe<SortOrder>;
  warehouseDepartCode?: InputMaybe<SortOrder>;
  warehouseDepartName?: InputMaybe<SortOrder>;
  warehouseName?: InputMaybe<SortOrder>;
  warehouseStoreTypeCode?: InputMaybe<SortOrder>;
  warehouseStoreTypeName?: InputMaybe<SortOrder>;
  warehouseTypeCode?: InputMaybe<SortOrder>;
  warehouseTypeName?: InputMaybe<SortOrder>;
};

export type Zone = Node & {
  __typename?: 'Zone';
  countries?: Maybe<Array<Maybe<Country>>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  members: Array<Region>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ZoneFilterParameter = {
  _and?: InputMaybe<Array<ZoneFilterParameter>>;
  _or?: InputMaybe<Array<ZoneFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ZoneList = PaginatedList & {
  __typename?: 'ZoneList';
  items: Array<Zone>;
  totalItems: Scalars['Int']['output'];
};

export type ZoneListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ZoneFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ZoneSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ZoneSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RandomizeWinnerInput = {
  eventId: Scalars['ID']['input'];
  idolId?: InputMaybe<Scalars['ID']['input']>;
  maximumWinner: Scalars['Int']['input'];
  minPurchaseQuantity: Scalars['Int']['input'];
};

export type CreateProductTypeMutationVariables = Exact<{
  input: CreateProductTypeInput;
}>;


export type CreateProductTypeMutation = { __typename?: 'Mutation', createProductType: { __typename?: 'ProductType', id: string, createdAt: any, updatedAt: any, code: string, name: string } };

export type DeleteProductTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProductTypeMutation = { __typename?: 'Mutation', deleteProductType: { __typename?: 'DeletionResponse', result: DeletionResult } };

export type GetProductTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductTypeQuery = { __typename?: 'Query', productType?: { __typename?: 'ProductType', id: string, createdAt: any, updatedAt: any, code: string, name: string } | null };

export type GetProductTypesQueryVariables = Exact<{
  options?: InputMaybe<ProductTypeListOptions>;
}>;


export type GetProductTypesQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypeList', totalItems: number, items: Array<{ __typename?: 'ProductType', id: string, createdAt: any, updatedAt: any, code: string, name: string }> } };

export type ProductTypeFragmentFragment = { __typename?: 'ProductType', id: string, createdAt: any, updatedAt: any, code: string, name: string };

export type UpdateProductTypeMutationVariables = Exact<{
  input: UpdateProductTypeInput;
}>;


export type UpdateProductTypeMutation = { __typename?: 'Mutation', updateProductType: { __typename?: 'ProductType', id: string, createdAt: any, updatedAt: any, code: string, name: string } };

export const ProductTypeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ProductTypeFragmentFragment, unknown>;
export const CreateProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProductTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CreateProductTypeMutation, CreateProductTypeMutationVariables>;
export const DeleteProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProductType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<DeleteProductTypeMutation, DeleteProductTypeMutationVariables>;
export const GetProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetProductTypeQuery, GetProductTypeQueryVariables>;
export const GetProductTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypeListOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetProductTypesQuery, GetProductTypesQueryVariables>;
export const UpdateProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>;